// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./icons/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/font-woff;charset=utf-8;base64, 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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%230a8c5b%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
html body {
  margin: 0;
  font-family: "Poppins", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: "source-code-pro", "Menlo", "Monaco", "Consolas", "Courier New", monospace;
}

/* Color */
.text-c1 {
  color: #e5e5e5;
}

.bg-c1 {
  background-color: #e5e5e5;
}

.bg-h-c1 {
  background-color: #e5e5e5;
}

.bc-c1 {
  border-color: #e5e5e5;
}

.text-c2 {
  color: #180065;
}

.bg-c2 {
  background-color: #180065;
}

.bg-h-c2 {
  background-color: #180065;
}

.bc-c2 {
  border-color: #180065;
}

.text-c3 {
  color: #f9f9f9;
}

.bg-c3 {
  background-color: #f9f9f9;
}

.bg-h-c3 {
  background-color: #f9f9f9;
}

.bc-c3 {
  border-color: #f9f9f9;
}

.text-c4 {
  color: #556080;
}

.bg-c4 {
  background-color: #556080;
}

.bg-h-c4 {
  background-color: #556080;
}

.bc-c4 {
  border-color: #556080;
}

.text-c5 {
  color: #6c6c6c;
}

.bg-c5 {
  background-color: #6c6c6c;
}

.bg-h-c5 {
  background-color: #6c6c6c;
}

.bc-c5 {
  border-color: #6c6c6c;
}

.text-c6 {
  color: #dff5fb;
}

.bg-c6 {
  background-color: #dff5fb;
}

.bg-h-c6 {
  background-color: #dff5fb;
}

.bc-c6 {
  border-color: #dff5fb;
}

.text-c7 {
  color: #dff9e1;
}

.bg-c7 {
  background-color: #dff9e1;
}

.bg-h-c7 {
  background-color: #dff9e1;
}

.bc-c7 {
  border-color: #dff9e1;
}

.text-c8 {
  color: #dfedff;
}

.bg-c8 {
  background-color: #dfedff;
}

.bg-h-c8 {
  background-color: #dfedff;
}

.bc-c8 {
  border-color: #dfedff;
}

.text-c9 {
  color: #fee7e5;
}

.bg-c9 {
  background-color: #fee7e5;
}

.bg-h-c9 {
  background-color: #fee7e5;
}

.bc-c9 {
  border-color: #fee7e5;
}

.text-c10 {
  color: #b9e1ec;
}

.bg-c10 {
  background-color: #b9e1ec;
}

.bg-h-c10 {
  background-color: #b9e1ec;
}

.bc-c10 {
  border-color: #b9e1ec;
}

.text-c11 {
  color: #bfedc2;
}

.bg-c11 {
  background-color: #bfedc2;
}

.bg-h-c11 {
  background-color: #bfedc2;
}

.bc-c11 {
  border-color: #bfedc2;
}

.text-c12 {
  color: #b8ceeb;
}

.bg-c12 {
  background-color: #b8ceeb;
}

.bg-h-c12 {
  background-color: #b8ceeb;
}

.bc-c12 {
  border-color: #b8ceeb;
}

.text-c13 {
  color: #f2d0cd;
}

.bg-c13 {
  background-color: #f2d0cd;
}

.bg-h-c13 {
  background-color: #f2d0cd;
}

.bc-c13 {
  border-color: #f2d0cd;
}

.text-c14 {
  color: #0d0d0d;
}

.bg-c14 {
  background-color: #0d0d0d;
}

.bg-h-c14 {
  background-color: #0d0d0d;
}

.bc-c14 {
  border-color: #0d0d0d;
}

.text-c15 {
  color: #424242;
}

.bg-c15 {
  background-color: #424242;
}

.bg-h-c15 {
  background-color: #424242;
}

.bc-c15 {
  border-color: #424242;
}

.text-c16 {
  color: #d7dff7;
}

.bg-c16 {
  background-color: #d7dff7;
}

.bg-h-c16 {
  background-color: #d7dff7;
}

.bc-c16 {
  border-color: #d7dff7;
}

.text-c17 {
  color: #aebfef;
}

.bg-c17 {
  background-color: #aebfef;
}

.bg-h-c17 {
  background-color: #aebfef;
}

.bc-c17 {
  border-color: #aebfef;
}

.text-c18 {
  color: #6c6c6c;
}

.bg-c18 {
  background-color: #6c6c6c;
}

.bg-h-c18 {
  background-color: #6c6c6c;
}

.bc-c18 {
  border-color: #6c6c6c;
}

.text-c19 {
  color: #27bf2f;
}

.bg-c19 {
  background-color: #27bf2f;
}

.bg-h-c19 {
  background-color: #27bf2f;
}

.bc-c19 {
  border-color: #27bf2f;
}

.text-c20 {
  color: #ff6f06;
}

.bg-c20 {
  background-color: #ff6f06;
}

.bg-h-c20 {
  background-color: #ff6f06;
}

.bc-c20 {
  border-color: #ff6f06;
}

.text-c21 {
  color: #d73e3e;
}

.bg-c21 {
  background-color: #d73e3e;
}

.bg-h-c21 {
  background-color: #d73e3e;
}

.bc-c21 {
  border-color: #d73e3e;
}

/* Font Size */
.fs-38 {
  font-size: 38px;
}

.fs-37 {
  font-size: 37px;
}

.fs-36 {
  font-size: 36px;
}

.fs-35 {
  font-size: 35px;
}

.fs-34 {
  font-size: 34px;
}

.fs-33 {
  font-size: 33px;
}

.fs-32 {
  font-size: 32px;
}

.fs-31 {
  font-size: 31px;
}

.fs-30 {
  font-size: 30px;
}

.fs-29 {
  font-size: 29px;
}

.fs-28 {
  font-size: 28px;
}

.fs-27 {
  font-size: 27px;
}

.fs-26 {
  font-size: 26px;
}

.fs-25 {
  font-size: 25px;
}

.fs-24 {
  font-size: 24px;
}

.fs-23 {
  font-size: 23px;
}

.fs-22 {
  font-size: 22px;
}

.fs-21 {
  font-size: 21px;
}

.fs-20 {
  font-size: 20px;
}

.fs-19 {
  font-size: 19px;
}

.fs-18 {
  font-size: 18px;
}

.fs-17 {
  font-size: 17px;
}

.fs-16 {
  font-size: 16px;
}

.fs-15 {
  font-size: 15px;
}

.fs-14 {
  font-size: 14px;
}

.fs-13 {
  font-size: 13px;
}

.fs-12 {
  font-size: 12px;
}

.fs-11 {
  font-size: 11px;
}

.fs-10 {
  font-size: 10px;
}

.fs-9 {
  font-size: 9px;
}

.line-height-38 {
  line-height: 38px;
}

.line-height-37 {
  line-height: 37px;
}

.line-height-36 {
  line-height: 36px;
}

.line-height-35 {
  line-height: 35px;
}

.line-height-34 {
  line-height: 34px;
}

.line-height-33 {
  line-height: 33px;
}

.line-height-32 {
  line-height: 32px;
}

.line-height-31 {
  line-height: 31px;
}

.line-height-30 {
  line-height: 30px;
}

.line-height-29 {
  line-height: 29px;
}

.line-height-28 {
  line-height: 28px;
}

.line-height-27 {
  line-height: 27px;
}

.line-height-26 {
  line-height: 26px;
}

.line-height-25 {
  line-height: 25px;
}

.line-height-24 {
  line-height: 24px;
}

.line-height-23 {
  line-height: 23px;
}

.line-height-22 {
  line-height: 22px;
}

.line-height-21 {
  line-height: 21px;
}

.line-height-20 {
  line-height: 20px;
}

.line-height-19 {
  line-height: 19px;
}

.line-height-18 {
  line-height: 18px;
}

.line-height-17 {
  line-height: 17px;
}

.line-height-16 {
  line-height: 16px;
}

.line-height-15 {
  line-height: 15px;
}

.line-height-14 {
  line-height: 14px;
}

.line-height-13 {
  line-height: 13px;
}

.line-height-12 {
  line-height: 12px;
}

.line-height-11 {
  line-height: 11px;
}

.line-height-10 {
  line-height: 10px;
}

.line-height-9 {
  line-height: 9px;
}

/* Font-weight */
.fw-800 {
  font-weight: 800;
}

.fw-700 {
  font-weight: 700;
}

.fw-600 {
  font-weight: 600;
}

.fw-500 {
  font-weight: 500;
}

/* Height */
.h-700 {
  height: 700;
}

.h-650 {
  height: 650;
}

.h-600 {
  height: 600;
}

.h-550 {
  height: 550;
}

.h-500 {
  height: 500;
}

.h-450 {
  height: 450;
}

.primary-color {
  color: #222;
}
.primary-color-dark {
  color: #222;
}

.text-gold {
  color: #c89a32;
}

.hover-primary-dark:hover {
  color: #222;
  cursor: pointer;
}

.container-80 {
  width: 90%;
}

.container-60 {
  width: 60%;
}

.container-40 {
  width: 48%;
}

.container-height-80 {
  height: 400px;
}

.svg-hover:hover {
  background-color: white;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #222;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #222;
}

.container-sa {
  max-width: 1340px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

button.btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0);
}

.form-control:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0);
}

.btn {
  background: #e2f9ec;
  border: 1px solid #f5f6f7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #000000;
  font-weight: 500;
  padding: 0.9rem 0;
}
.btn.active {
  background: #189c5c;
  border: 1px solid #f5f6f7;
  color: #ffffff;
}

.tab-sammunaty.nav-tabs {
  border-bottom: 0px solid #dee2e6;
}
.tab-sammunaty.nav-tabs .nav-link {
  margin-left: 0;
  border: 0px;
  min-width: 170px;
  text-align: center;
  padding: 0.7rem 0rem;
  color: #189c5c;
  font-size: 1.1rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  cursor: pointer;
}
.tab-sammunaty.nav-tabs .nav-link img {
  height: 28px;
  margin-right: 10px;
}
.tab-sammunaty.nav-tabs .nav-link.active {
  background: #deecd2;
  border-color: transparent;
  color: #189c5c;
}

.ck.ck-content {
  border: 1px solid #bababa;
  border-top: 0;
}

@font-face {
  font-family: "swiper-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
:root {
  --swiper-theme-color: #007aff;
}

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
}

.swiper-container-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-container-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-container-multirow > .swiper-wrapper {
  flex-wrap: wrap;
}

.swiper-container-multirow-column > .swiper-wrapper {
  flex-wrap: wrap;
  flex-direction: column;
}

.swiper-container-free-mode > .swiper-wrapper {
  transition-timing-function: ease-out;
  margin: 0 auto;
}

.swiper-container-pointer-events {
  touch-action: pan-y;
}
.swiper-container-pointer-events.swiper-container-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.swiper-container-autoheight,
.swiper-container-autoheight .swiper-slide {
  height: auto;
}
.swiper-container-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

/* 3D Effects */
.swiper-container-3d {
  perspective: 1200px;
}
.swiper-container-3d .swiper-wrapper,
.swiper-container-3d .swiper-slide,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
.swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-container-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-container-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* CSS Mode */
.swiper-container-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}
.swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}
.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

/*!
 * Bootstrap v4.6.2 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #3783f5;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #da274a;
  --red: #dc3545;
  --orange: #f58d45;
  --yellow: #ffc107;
  --green: #0a8c5b;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #ffffff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --black: #000000;
  --primary: #3783f5;
  --secondary: #6c757d;
  --success: #0a8c5b;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #3783f5;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: rgb(10.6428571429, 91.5285714286, 212.8571428571);
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: 2.5rem;
}

h2, .h2 {
  font-size: 2rem;
}

h3, .h3 {
  font-size: 1.75rem;
}

h4, .h4 {
  font-size: 1.5rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 0.875em;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #da274a;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(199, 220.28, 252.2);
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: rgb(151, 190.52, 249.8);
}

.table-hover .table-primary:hover {
  background-color: rgb(174.7142857143, 205.2228571429, 250.9857142857);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(174.7142857143, 205.2228571429, 250.9857142857);
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(213.84, 216.36, 218.6);
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: rgb(178.56, 183.24, 187.4);
}

.table-hover .table-secondary:hover {
  background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747);
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(186.4, 222.8, 209.08);
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: rgb(127.6, 195.2, 169.72);
}

.table-hover .table-success:hover {
  background-color: rgb(169.0458333333, 214.6541666667, 197.4633333333);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(169.0458333333, 214.6541666667, 197.4633333333);
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(190.04, 228.96, 235.12);
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: rgb(134.36, 206.64, 218.08);
}

.table-hover .table-info:hover {
  background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752);
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(255, 237.64, 185.56);
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: rgb(255, 222.76, 126.04);
}

.table-hover .table-warning:hover {
  background-color: rgb(255, 231.265, 160.06);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(255, 231.265, 160.06);
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(245.2, 198.44, 202.92);
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: rgb(236.8, 149.96, 158.28);
}

.table-hover .table-danger:hover {
  background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722);
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(253.04, 253.32, 253.6);
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: rgb(251.36, 251.88, 252.4);
}

.table-hover .table-light:hover {
  background-color: rgb(238.165, 240.57, 242.975);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(238.165, 240.57, 242.975);
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(198.16, 199.84, 201.52);
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: rgb(149.44, 152.56, 155.68);
}

.table-hover .table-dark:hover {
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: rgb(69.1465517241, 77.125, 85.1034482759);
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(69.1465517241, 77.125, 85.1034482759);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(176.4285714286, 206.2857142857, 251.0714285714);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #0a8c5b;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(10, 140, 91, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #0a8c5b;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #0a8c5b;
  box-shadow: 0 0 0 0.2rem rgba(10, 140, 91, 0.25);
}

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #0a8c5b;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #0a8c5b;
  box-shadow: 0 0 0 0.2rem rgba(10, 140, 91, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #0a8c5b;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #0a8c5b;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #0a8c5b;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: rgb(13.4, 187.6, 121.94);
  background-color: rgb(13.4, 187.6, 121.94);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(10, 140, 91, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #0a8c5b;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #0a8c5b;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #0a8c5b;
  box-shadow: 0 0 0 0.2rem rgba(10, 140, 91, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: rgb(227.5316455696, 96.4683544304, 109.0253164557);
  background-color: rgb(227.5316455696, 96.4683544304, 109.0253164557);
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #212529;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #3783f5;
  border-color: #3783f5;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(18.5714285714, 108.4142857143, 243.1785714286);
  border-color: rgb(11.8571428571, 101.9714285714, 237.1428571429);
}
.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: rgb(18.5714285714, 108.4142857143, 243.1785714286);
  border-color: rgb(11.8571428571, 101.9714285714, 237.1428571429);
  box-shadow: 0 0 0 0.2rem rgba(85, 149.6, 246.5, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #3783f5;
  border-color: #3783f5;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.8571428571, 101.9714285714, 237.1428571429);
  border-color: rgb(11.25, 96.75, 225);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(85, 149.6, 246.5, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(90.2703862661, 97.7929184549, 104.4796137339);
  border-color: rgb(84.3605150215, 91.3905579399, 97.6394849785);
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: rgb(90.2703862661, 97.7929184549, 104.4796137339);
  border-color: rgb(84.3605150215, 91.3905579399, 97.6394849785);
  box-shadow: 0 0 0 0.2rem rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(84.3605150215, 91.3905579399, 97.6394849785);
  border-color: rgb(78.4506437768, 84.9881974249, 90.7993562232);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(130.05, 137.7, 144.5, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #0a8c5b;
  border-color: #0a8c5b;
}
.btn-success:hover {
  color: #fff;
  background-color: rgb(7.45, 104.3, 67.795);
  border-color: rgb(6.6, 92.4, 60.06);
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: rgb(7.45, 104.3, 67.795);
  border-color: rgb(6.6, 92.4, 60.06);
  box-shadow: 0 0 0 0.2rem rgba(46.75, 157.25, 115.6, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #0a8c5b;
  border-color: #0a8c5b;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(6.6, 92.4, 60.06);
  border-color: rgb(5.75, 80.5, 52.325);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(46.75, 157.25, 115.6, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info:hover {
  color: #fff;
  background-color: rgb(18.75, 132.0652173913, 150);
  border-color: rgb(17.3333333333, 122.0869565217, 138.6666666667);
}
.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: rgb(18.75, 132.0652173913, 150);
  border-color: rgb(17.3333333333, 122.0869565217, 138.6666666667);
  box-shadow: 0 0 0 0.2rem rgba(57.8, 175.95, 194.65, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(17.3333333333, 122.0869565217, 138.6666666667);
  border-color: rgb(15.9166666667, 112.1086956522, 127.3333333333);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(57.8, 175.95, 194.65, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:hover {
  color: #212529;
  background-color: rgb(223.75, 167.8125, 0);
  border-color: rgb(211, 158.25, 0);
}
.btn-warning:focus, .btn-warning.focus {
  color: #212529;
  background-color: rgb(223.75, 167.8125, 0);
  border-color: rgb(211, 158.25, 0);
  box-shadow: 0 0 0 0.2rem rgba(221.7, 169.6, 12.1, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: rgb(211, 158.25, 0);
  border-color: rgb(198.25, 148.6875, 0);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(221.7, 169.6, 12.1, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(200.082278481, 34.667721519, 50.5158227848);
  border-color: rgb(189.2151898734, 32.7848101266, 47.7721518987);
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: rgb(200.082278481, 34.667721519, 50.5158227848);
  border-color: rgb(189.2151898734, 32.7848101266, 47.7721518987);
  box-shadow: 0 0 0 0.2rem rgba(225.25, 83.3, 96.9, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(189.2151898734, 32.7848101266, 47.7721518987);
  border-color: rgb(178.3481012658, 30.9018987342, 45.0284810127);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(225.25, 83.3, 96.9, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:hover {
  color: #212529;
  background-color: rgb(225.6875, 229.875, 234.0625);
  border-color: rgb(218.25, 223.5, 228.75);
}
.btn-light:focus, .btn-light.focus {
  color: #212529;
  background-color: rgb(225.6875, 229.875, 234.0625);
  border-color: rgb(218.25, 223.5, 228.75);
  box-shadow: 0 0 0 0.2rem rgba(215.75, 217.2, 218.65, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(218.25, 223.5, 228.75);
  border-color: rgb(210.8125, 217.125, 223.4375);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(215.75, 217.2, 218.65, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
  box-shadow: 0 0 0 0.2rem rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(82.45, 87.55, 92.65, 0.5);
}

.btn-outline-primary {
  color: #3783f5;
  border-color: #3783f5;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #3783f5;
  border-color: #3783f5;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #3783f5;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #3783f5;
  border-color: #3783f5;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.5);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-outline-success {
  color: #0a8c5b;
  border-color: #0a8c5b;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #0a8c5b;
  border-color: #0a8c5b;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(10, 140, 91, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #0a8c5b;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #0a8c5b;
  border-color: #0a8c5b;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(10, 140, 91, 0.5);
}

.btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #17a2b8;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #dc3545;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #3783f5;
  text-decoration: none;
}
.btn-link:hover {
  color: rgb(10.6428571429, 91.5285714286, 212.8571428571);
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(21.6283783784, 24.25, 26.8716216216);
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #3783f5;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #3783f5;
  background-color: #3783f5;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgb(176.4285714286, 206.2857142857, 251.0714285714);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: rgb(225, 236.4, 253.5);
  border-color: rgb(225, 236.4, 253.5);
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #adb5bd;
}
.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #3783f5;
  background-color: #3783f5;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 131, 245, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(55, 131, 245, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 131, 245, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 131, 245, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}
.custom-select:focus {
  border-color: rgb(176.4285714286, 206.2857142857, 251.0714285714);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgb(176.4285714286, 206.2857142857, 251.0714285714);
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #3783f5;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb {
  appearance: none;
}
.custom-range::-webkit-slider-thumb:active {
  background-color: rgb(225, 236.4, 253.5);
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #3783f5;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb {
  appearance: none;
}
.custom-range::-moz-range-thumb:active {
  background-color: rgb(225, 236.4, 253.5);
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #3783f5;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb {
  appearance: none;
}
.custom-range::-ms-thumb:active {
  background-color: rgb(225, 236.4, 253.5);
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #3783f5;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #3783f5;
  background-color: #aebfef;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: rgb(10.6428571429, 91.5285714286, 212.8571428571);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #3783f5;
  border-color: #3783f5;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #3783f5;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: rgb(11.8571428571, 101.9714285714, 237.1428571429);
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 131, 245, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: rgb(84.3605150215, 91.3905579399, 97.6394849785);
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #0a8c5b;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: rgb(6.6, 92.4, 60.06);
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(10, 140, 91, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #17a2b8;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: rgb(17.3333333333, 122.0869565217, 138.6666666667);
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #212529;
  background-color: rgb(211, 158.25, 0);
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #dc3545;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: rgb(189.2151898734, 32.7848101266, 47.7721518987);
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #f8f9fa;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: rgb(218.25, 223.5, 228.75);
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: rgb(28.6, 68.12, 127.4);
  background-color: rgb(215, 230.2, 253);
  border-color: rgb(199, 220.28, 252.2);
}
.alert-primary hr {
  border-top-color: rgb(174.7142857143, 205.2228571429, 250.9857142857);
}
.alert-primary .alert-link {
  color: rgb(19.25, 45.85, 85.75);
}

.alert-secondary {
  color: rgb(56.16, 60.84, 65);
  background-color: rgb(225.6, 227.4, 229);
  border-color: rgb(213.84, 216.36, 218.6);
}
.alert-secondary hr {
  border-top-color: rgb(200.3075090253, 203.6560288809, 206.6324909747);
}
.alert-secondary .alert-link {
  color: rgb(32.5205150215, 35.2305579399, 37.6394849785);
}

.alert-success {
  color: rgb(5.2, 72.8, 47.32);
  background-color: rgb(206, 232, 222.2);
  border-color: rgb(186.4, 222.8, 209.08);
}
.alert-success hr {
  border-top-color: rgb(169.0458333333, 214.6541666667, 197.4633333333);
}
.alert-success .alert-link {
  color: rgb(1.8, 25.2, 16.38);
}

.alert-info {
  color: rgb(11.96, 84.24, 95.68);
  background-color: rgb(208.6, 236.4, 240.8);
  border-color: rgb(190.04, 228.96, 235.12);
}
.alert-info hr {
  border-top-color: rgb(170.5152475248, 221.1332673267, 229.1447524752);
}
.alert-info .alert-link {
  color: rgb(6.2933333333, 44.3269565217, 50.3466666667);
}

.alert-warning {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 242.6, 205.4);
  border-color: rgb(255, 237.64, 185.56);
}
.alert-warning hr {
  border-top-color: rgb(255, 231.265, 160.06);
}
.alert-warning .alert-link {
  color: rgb(82.9625954198, 62.7912977099, 2.2774045802);
}

.alert-danger {
  color: rgb(114.4, 27.56, 35.88);
  background-color: rgb(248, 214.6, 217.8);
  border-color: rgb(245.2, 198.44, 202.92);
}
.alert-danger hr {
  border-top-color: rgb(241.4341772152, 176.7058227848, 182.9073417722);
}
.alert-danger .alert-link {
  color: rgb(73.3010989011, 17.6589010989, 22.9898901099);
}

.alert-light {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(253.6, 253.8, 254);
  border-color: rgb(253.04, 253.32, 253.6);
}
.alert-light hr {
  border-top-color: rgb(238.165, 240.57, 242.975);
}
.alert-light .alert-link {
  color: rgb(103.5492351816, 103.98, 104.4107648184);
}

.alert-dark {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(214.4, 215.6, 216.8);
  border-color: rgb(198.16, 199.84, 201.52);
}
.alert-dark hr {
  border-top-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.alert-dark .alert-link {
  color: rgb(4.1779310345, 4.66, 5.1420689655);
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #3783f5;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #3783f5;
  border-color: #3783f5;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(28.6, 68.12, 127.4);
  background-color: rgb(199, 220.28, 252.2);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(28.6, 68.12, 127.4);
  background-color: rgb(174.7142857143, 205.2228571429, 250.9857142857);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(28.6, 68.12, 127.4);
  border-color: rgb(28.6, 68.12, 127.4);
}

.list-group-item-secondary {
  color: rgb(56.16, 60.84, 65);
  background-color: rgb(213.84, 216.36, 218.6);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(56.16, 60.84, 65);
  background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(56.16, 60.84, 65);
  border-color: rgb(56.16, 60.84, 65);
}

.list-group-item-success {
  color: rgb(5.2, 72.8, 47.32);
  background-color: rgb(186.4, 222.8, 209.08);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(5.2, 72.8, 47.32);
  background-color: rgb(169.0458333333, 214.6541666667, 197.4633333333);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(5.2, 72.8, 47.32);
  border-color: rgb(5.2, 72.8, 47.32);
}

.list-group-item-info {
  color: rgb(11.96, 84.24, 95.68);
  background-color: rgb(190.04, 228.96, 235.12);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(11.96, 84.24, 95.68);
  background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(11.96, 84.24, 95.68);
  border-color: rgb(11.96, 84.24, 95.68);
}

.list-group-item-warning {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 237.64, 185.56);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 231.265, 160.06);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 100.36, 3.64);
  border-color: rgb(132.6, 100.36, 3.64);
}

.list-group-item-danger {
  color: rgb(114.4, 27.56, 35.88);
  background-color: rgb(245.2, 198.44, 202.92);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(114.4, 27.56, 35.88);
  background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(114.4, 27.56, 35.88);
  border-color: rgb(114.4, 27.56, 35.88);
}

.list-group-item-light {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(253.04, 253.32, 253.6);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(238.165, 240.57, 242.975);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(128.96, 129.48, 130);
  border-color: rgb(128.96, 129.48, 130);
}

.list-group-item-dark {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(198.16, 199.84, 201.52);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(27.04, 30.16, 33.28);
  border-color: rgb(27.04, 30.16, 33.28);
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid rgb(247.35, 247.35, 247.35);
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: rgb(247.35, 247.35, 247.35);
  border-bottom: 1px solid rgb(234.6, 234.6, 234.6);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #3783f5 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(11.8571428571, 101.9714285714, 237.1428571429) !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(84.3605150215, 91.3905579399, 97.6394849785) !important;
}

.bg-success {
  background-color: #0a8c5b !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(6.6, 92.4, 60.06) !important;
}

.bg-info {
  background-color: #17a2b8 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(17.3333333333, 122.0869565217, 138.6666666667) !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(211, 158.25, 0) !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(189.2151898734, 32.7848101266, 47.7721518987) !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(218.25, 223.5, 228.75) !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(29.1379310345, 32.5, 35.8620689655) !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #3783f5 !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #0a8c5b !important;
}

.border-info {
  border-color: #17a2b8 !important;
}

.border-warning {
  border-color: #ffc107 !important;
}

.border-danger {
  border-color: #dc3545 !important;
}

.border-light {
  border-color: #f8f9fa !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #3783f5 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: rgb(10.6428571429, 91.5285714286, 212.8571428571) !important;
}

.text-secondary {
  color: #6c757d !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(72.5407725322, 78.5858369099, 83.9592274678) !important;
}

.text-success {
  color: #0a8c5b !important;
}

a.text-success:hover, a.text-success:focus {
  color: rgb(4.9, 68.6, 44.59) !important;
}

.text-info {
  color: #17a2b8 !important;
}

a.text-info:hover, a.text-info:focus {
  color: rgb(14.5, 102.1304347826, 116) !important;
}

.text-warning {
  color: #ffc107 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: rgb(185.5, 139.125, 0) !important;
}

.text-danger {
  color: #dc3545 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: rgb(167.4810126582, 29.0189873418, 42.2848101266) !important;
}

.text-light {
  color: #f8f9fa !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(203.375, 210.75, 218.125) !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: rgb(17.7068965517, 19.75, 21.7931034483) !important;
}

.text-body {
  color: #212529 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #dee2e6;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
  }
}
/* Color */
.text-c1 {
  color: #e5e5e5;
}

.bg-c1 {
  background-color: #e5e5e5;
}

.bg-h-c1 {
  background-color: #e5e5e5;
}

.bc-c1 {
  border-color: #e5e5e5;
}

.text-c2 {
  color: #180065;
}

.bg-c2 {
  background-color: #180065;
}

.bg-h-c2 {
  background-color: #180065;
}

.bc-c2 {
  border-color: #180065;
}

.text-c3 {
  color: #f9f9f9;
}

.bg-c3 {
  background-color: #f9f9f9;
}

.bg-h-c3 {
  background-color: #f9f9f9;
}

.bc-c3 {
  border-color: #f9f9f9;
}

.text-c4 {
  color: #556080;
}

.bg-c4 {
  background-color: #556080;
}

.bg-h-c4 {
  background-color: #556080;
}

.bc-c4 {
  border-color: #556080;
}

.text-c5 {
  color: #6c6c6c;
}

.bg-c5 {
  background-color: #6c6c6c;
}

.bg-h-c5 {
  background-color: #6c6c6c;
}

.bc-c5 {
  border-color: #6c6c6c;
}

.text-c6 {
  color: #dff5fb;
}

.bg-c6 {
  background-color: #dff5fb;
}

.bg-h-c6 {
  background-color: #dff5fb;
}

.bc-c6 {
  border-color: #dff5fb;
}

.text-c7 {
  color: #dff9e1;
}

.bg-c7 {
  background-color: #dff9e1;
}

.bg-h-c7 {
  background-color: #dff9e1;
}

.bc-c7 {
  border-color: #dff9e1;
}

.text-c8 {
  color: #dfedff;
}

.bg-c8 {
  background-color: #dfedff;
}

.bg-h-c8 {
  background-color: #dfedff;
}

.bc-c8 {
  border-color: #dfedff;
}

.text-c9 {
  color: #fee7e5;
}

.bg-c9 {
  background-color: #fee7e5;
}

.bg-h-c9 {
  background-color: #fee7e5;
}

.bc-c9 {
  border-color: #fee7e5;
}

.text-c10 {
  color: #b9e1ec;
}

.bg-c10 {
  background-color: #b9e1ec;
}

.bg-h-c10 {
  background-color: #b9e1ec;
}

.bc-c10 {
  border-color: #b9e1ec;
}

.text-c11 {
  color: #bfedc2;
}

.bg-c11 {
  background-color: #bfedc2;
}

.bg-h-c11 {
  background-color: #bfedc2;
}

.bc-c11 {
  border-color: #bfedc2;
}

.text-c12 {
  color: #b8ceeb;
}

.bg-c12 {
  background-color: #b8ceeb;
}

.bg-h-c12 {
  background-color: #b8ceeb;
}

.bc-c12 {
  border-color: #b8ceeb;
}

.text-c13 {
  color: #f2d0cd;
}

.bg-c13 {
  background-color: #f2d0cd;
}

.bg-h-c13 {
  background-color: #f2d0cd;
}

.bc-c13 {
  border-color: #f2d0cd;
}

.text-c14 {
  color: #0d0d0d;
}

.bg-c14 {
  background-color: #0d0d0d;
}

.bg-h-c14 {
  background-color: #0d0d0d;
}

.bc-c14 {
  border-color: #0d0d0d;
}

.text-c15 {
  color: #424242;
}

.bg-c15 {
  background-color: #424242;
}

.bg-h-c15 {
  background-color: #424242;
}

.bc-c15 {
  border-color: #424242;
}

.text-c16 {
  color: #d7dff7;
}

.bg-c16 {
  background-color: #d7dff7;
}

.bg-h-c16 {
  background-color: #d7dff7;
}

.bc-c16 {
  border-color: #d7dff7;
}

.text-c17 {
  color: #aebfef;
}

.bg-c17 {
  background-color: #aebfef;
}

.bg-h-c17 {
  background-color: #aebfef;
}

.bc-c17 {
  border-color: #aebfef;
}

.text-c18 {
  color: #6c6c6c;
}

.bg-c18 {
  background-color: #6c6c6c;
}

.bg-h-c18 {
  background-color: #6c6c6c;
}

.bc-c18 {
  border-color: #6c6c6c;
}

.text-c19 {
  color: #27bf2f;
}

.bg-c19 {
  background-color: #27bf2f;
}

.bg-h-c19 {
  background-color: #27bf2f;
}

.bc-c19 {
  border-color: #27bf2f;
}

.text-c20 {
  color: #ff6f06;
}

.bg-c20 {
  background-color: #ff6f06;
}

.bg-h-c20 {
  background-color: #ff6f06;
}

.bc-c20 {
  border-color: #ff6f06;
}

.text-c21 {
  color: #d73e3e;
}

.bg-c21 {
  background-color: #d73e3e;
}

.bg-h-c21 {
  background-color: #d73e3e;
}

.bc-c21 {
  border-color: #d73e3e;
}

/* Font Size */
.fs-38 {
  font-size: 38px;
}

.fs-37 {
  font-size: 37px;
}

.fs-36 {
  font-size: 36px;
}

.fs-35 {
  font-size: 35px;
}

.fs-34 {
  font-size: 34px;
}

.fs-33 {
  font-size: 33px;
}

.fs-32 {
  font-size: 32px;
}

.fs-31 {
  font-size: 31px;
}

.fs-30 {
  font-size: 30px;
}

.fs-29 {
  font-size: 29px;
}

.fs-28 {
  font-size: 28px;
}

.fs-27 {
  font-size: 27px;
}

.fs-26 {
  font-size: 26px;
}

.fs-25 {
  font-size: 25px;
}

.fs-24 {
  font-size: 24px;
}

.fs-23 {
  font-size: 23px;
}

.fs-22 {
  font-size: 22px;
}

.fs-21 {
  font-size: 21px;
}

.fs-20 {
  font-size: 20px;
}

.fs-19 {
  font-size: 19px;
}

.fs-18 {
  font-size: 18px;
}

.fs-17 {
  font-size: 17px;
}

.fs-16 {
  font-size: 16px;
}

.fs-15 {
  font-size: 15px;
}

.fs-14 {
  font-size: 14px;
}

.fs-13 {
  font-size: 13px;
}

.fs-12 {
  font-size: 12px;
}

.fs-11 {
  font-size: 11px;
}

.fs-10 {
  font-size: 10px;
}

.fs-9 {
  font-size: 9px;
}

.line-height-38 {
  line-height: 38px;
}

.line-height-37 {
  line-height: 37px;
}

.line-height-36 {
  line-height: 36px;
}

.line-height-35 {
  line-height: 35px;
}

.line-height-34 {
  line-height: 34px;
}

.line-height-33 {
  line-height: 33px;
}

.line-height-32 {
  line-height: 32px;
}

.line-height-31 {
  line-height: 31px;
}

.line-height-30 {
  line-height: 30px;
}

.line-height-29 {
  line-height: 29px;
}

.line-height-28 {
  line-height: 28px;
}

.line-height-27 {
  line-height: 27px;
}

.line-height-26 {
  line-height: 26px;
}

.line-height-25 {
  line-height: 25px;
}

.line-height-24 {
  line-height: 24px;
}

.line-height-23 {
  line-height: 23px;
}

.line-height-22 {
  line-height: 22px;
}

.line-height-21 {
  line-height: 21px;
}

.line-height-20 {
  line-height: 20px;
}

.line-height-19 {
  line-height: 19px;
}

.line-height-18 {
  line-height: 18px;
}

.line-height-17 {
  line-height: 17px;
}

.line-height-16 {
  line-height: 16px;
}

.line-height-15 {
  line-height: 15px;
}

.line-height-14 {
  line-height: 14px;
}

.line-height-13 {
  line-height: 13px;
}

.line-height-12 {
  line-height: 12px;
}

.line-height-11 {
  line-height: 11px;
}

.line-height-10 {
  line-height: 10px;
}

.line-height-9 {
  line-height: 9px;
}

/* Font-weight */
.fw-800 {
  font-weight: 800;
}

.fw-700 {
  font-weight: 700;
}

.fw-600 {
  font-weight: 600;
}

.fw-500 {
  font-weight: 500;
}

/* Height */
.h-700 {
  height: 700;
}

.h-650 {
  height: 650;
}

.h-600 {
  height: 600;
}

.h-550 {
  height: 550;
}

.h-500 {
  height: 500;
}

.h-450 {
  height: 450;
}

.center-view, .center-view-login {
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: auto;
}
.center-view-login {
  position: relative;
  height: 100vh;
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
}
.center-view .card, .center-view-login .card {
  padding: 30px;
  min-width: 400px;
  margin: auto;
  border-style: none;
}

/* Color */
.text-c1 {
  color: #e5e5e5;
}

.bg-c1 {
  background-color: #e5e5e5;
}

.bg-h-c1 {
  background-color: #e5e5e5;
}

.bc-c1 {
  border-color: #e5e5e5;
}

.text-c2 {
  color: #180065;
}

.bg-c2 {
  background-color: #180065;
}

.bg-h-c2 {
  background-color: #180065;
}

.bc-c2 {
  border-color: #180065;
}

.text-c3 {
  color: #f9f9f9;
}

.bg-c3 {
  background-color: #f9f9f9;
}

.bg-h-c3 {
  background-color: #f9f9f9;
}

.bc-c3 {
  border-color: #f9f9f9;
}

.text-c4 {
  color: #556080;
}

.bg-c4 {
  background-color: #556080;
}

.bg-h-c4 {
  background-color: #556080;
}

.bc-c4 {
  border-color: #556080;
}

.text-c5 {
  color: #6c6c6c;
}

.bg-c5 {
  background-color: #6c6c6c;
}

.bg-h-c5 {
  background-color: #6c6c6c;
}

.bc-c5 {
  border-color: #6c6c6c;
}

.text-c6 {
  color: #dff5fb;
}

.bg-c6 {
  background-color: #dff5fb;
}

.bg-h-c6 {
  background-color: #dff5fb;
}

.bc-c6 {
  border-color: #dff5fb;
}

.text-c7 {
  color: #dff9e1;
}

.bg-c7 {
  background-color: #dff9e1;
}

.bg-h-c7 {
  background-color: #dff9e1;
}

.bc-c7 {
  border-color: #dff9e1;
}

.text-c8 {
  color: #dfedff;
}

.bg-c8 {
  background-color: #dfedff;
}

.bg-h-c8 {
  background-color: #dfedff;
}

.bc-c8 {
  border-color: #dfedff;
}

.text-c9 {
  color: #fee7e5;
}

.bg-c9 {
  background-color: #fee7e5;
}

.bg-h-c9 {
  background-color: #fee7e5;
}

.bc-c9 {
  border-color: #fee7e5;
}

.text-c10 {
  color: #b9e1ec;
}

.bg-c10 {
  background-color: #b9e1ec;
}

.bg-h-c10 {
  background-color: #b9e1ec;
}

.bc-c10 {
  border-color: #b9e1ec;
}

.text-c11 {
  color: #bfedc2;
}

.bg-c11 {
  background-color: #bfedc2;
}

.bg-h-c11 {
  background-color: #bfedc2;
}

.bc-c11 {
  border-color: #bfedc2;
}

.text-c12 {
  color: #b8ceeb;
}

.bg-c12 {
  background-color: #b8ceeb;
}

.bg-h-c12 {
  background-color: #b8ceeb;
}

.bc-c12 {
  border-color: #b8ceeb;
}

.text-c13 {
  color: #f2d0cd;
}

.bg-c13 {
  background-color: #f2d0cd;
}

.bg-h-c13 {
  background-color: #f2d0cd;
}

.bc-c13 {
  border-color: #f2d0cd;
}

.text-c14 {
  color: #0d0d0d;
}

.bg-c14 {
  background-color: #0d0d0d;
}

.bg-h-c14 {
  background-color: #0d0d0d;
}

.bc-c14 {
  border-color: #0d0d0d;
}

.text-c15 {
  color: #424242;
}

.bg-c15 {
  background-color: #424242;
}

.bg-h-c15 {
  background-color: #424242;
}

.bc-c15 {
  border-color: #424242;
}

.text-c16 {
  color: #d7dff7;
}

.bg-c16 {
  background-color: #d7dff7;
}

.bg-h-c16 {
  background-color: #d7dff7;
}

.bc-c16 {
  border-color: #d7dff7;
}

.text-c17 {
  color: #aebfef;
}

.bg-c17 {
  background-color: #aebfef;
}

.bg-h-c17 {
  background-color: #aebfef;
}

.bc-c17 {
  border-color: #aebfef;
}

.text-c18 {
  color: #6c6c6c;
}

.bg-c18 {
  background-color: #6c6c6c;
}

.bg-h-c18 {
  background-color: #6c6c6c;
}

.bc-c18 {
  border-color: #6c6c6c;
}

.text-c19 {
  color: #27bf2f;
}

.bg-c19 {
  background-color: #27bf2f;
}

.bg-h-c19 {
  background-color: #27bf2f;
}

.bc-c19 {
  border-color: #27bf2f;
}

.text-c20 {
  color: #ff6f06;
}

.bg-c20 {
  background-color: #ff6f06;
}

.bg-h-c20 {
  background-color: #ff6f06;
}

.bc-c20 {
  border-color: #ff6f06;
}

.text-c21 {
  color: #d73e3e;
}

.bg-c21 {
  background-color: #d73e3e;
}

.bg-h-c21 {
  background-color: #d73e3e;
}

.bc-c21 {
  border-color: #d73e3e;
}

/* Font Size */
.fs-38 {
  font-size: 38px;
}

.fs-37 {
  font-size: 37px;
}

.fs-36 {
  font-size: 36px;
}

.fs-35 {
  font-size: 35px;
}

.fs-34 {
  font-size: 34px;
}

.fs-33 {
  font-size: 33px;
}

.fs-32 {
  font-size: 32px;
}

.fs-31 {
  font-size: 31px;
}

.fs-30 {
  font-size: 30px;
}

.fs-29 {
  font-size: 29px;
}

.fs-28 {
  font-size: 28px;
}

.fs-27 {
  font-size: 27px;
}

.fs-26 {
  font-size: 26px;
}

.fs-25 {
  font-size: 25px;
}

.fs-24 {
  font-size: 24px;
}

.fs-23 {
  font-size: 23px;
}

.fs-22 {
  font-size: 22px;
}

.fs-21 {
  font-size: 21px;
}

.fs-20 {
  font-size: 20px;
}

.fs-19 {
  font-size: 19px;
}

.fs-18 {
  font-size: 18px;
}

.fs-17 {
  font-size: 17px;
}

.fs-16 {
  font-size: 16px;
}

.fs-15 {
  font-size: 15px;
}

.fs-14 {
  font-size: 14px;
}

.fs-13 {
  font-size: 13px;
}

.fs-12 {
  font-size: 12px;
}

.fs-11 {
  font-size: 11px;
}

.fs-10 {
  font-size: 10px;
}

.fs-9 {
  font-size: 9px;
}

.line-height-38 {
  line-height: 38px;
}

.line-height-37 {
  line-height: 37px;
}

.line-height-36 {
  line-height: 36px;
}

.line-height-35 {
  line-height: 35px;
}

.line-height-34 {
  line-height: 34px;
}

.line-height-33 {
  line-height: 33px;
}

.line-height-32 {
  line-height: 32px;
}

.line-height-31 {
  line-height: 31px;
}

.line-height-30 {
  line-height: 30px;
}

.line-height-29 {
  line-height: 29px;
}

.line-height-28 {
  line-height: 28px;
}

.line-height-27 {
  line-height: 27px;
}

.line-height-26 {
  line-height: 26px;
}

.line-height-25 {
  line-height: 25px;
}

.line-height-24 {
  line-height: 24px;
}

.line-height-23 {
  line-height: 23px;
}

.line-height-22 {
  line-height: 22px;
}

.line-height-21 {
  line-height: 21px;
}

.line-height-20 {
  line-height: 20px;
}

.line-height-19 {
  line-height: 19px;
}

.line-height-18 {
  line-height: 18px;
}

.line-height-17 {
  line-height: 17px;
}

.line-height-16 {
  line-height: 16px;
}

.line-height-15 {
  line-height: 15px;
}

.line-height-14 {
  line-height: 14px;
}

.line-height-13 {
  line-height: 13px;
}

.line-height-12 {
  line-height: 12px;
}

.line-height-11 {
  line-height: 11px;
}

.line-height-10 {
  line-height: 10px;
}

.line-height-9 {
  line-height: 9px;
}

/* Font-weight */
.fw-800 {
  font-weight: 800;
}

.fw-700 {
  font-weight: 700;
}

.fw-600 {
  font-weight: 600;
}

.fw-500 {
  font-weight: 500;
}

/* Height */
.h-700 {
  height: 700;
}

.h-650 {
  height: 650;
}

.h-600 {
  height: 600;
}

.h-550 {
  height: 550;
}

.h-500 {
  height: 500;
}

.h-450 {
  height: 450;
}

.heading-20 {
  font-family: Poppins;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
}

button.btn {
  border-radius: 4px;
  font-family: Poppins;
  line-height: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
}
button.btn.mainbg-btn {
  background: #837F39;
  border: 1px solid #837F39;
  color: #fff;
}
button.btn.btn-dark-primary-border {
  background-color: #fff;
  color: #180065;
  font-weight: bold;
  border: 1px solid #180065 !important;
}
button.btn.btn-dark-primary-border:hover {
  background: #180065;
  border: 1px solid #180065;
  color: #fff;
}
button.btn.btn-dark-primary-outline {
  background-color: #fff;
  color: #180065;
  font-weight: bold;
}
button.btn.mainbg-btn:hover {
  background: transparent;
  border: 1px solid #837F39;
  transition: 0.3s ease-in;
  color: #837F39;
}
button.btn.outline-btn {
  background: transparent;
  border: 1px solid #837F39;
  transition: 0.3s ease-in;
  color: #837F39;
}
button.btn.outline-btn:hover {
  background: #837F39;
  border: 1px solid #837F39;
  color: #fff;
}
button.btn.outline-btn.border-none {
  background: transparent;
  border: 1px solid transparent;
  transition: 0.3s ease-in;
  color: #837F39;
}
button.btn.outline-btn.border-none:hover {
  background: transparent;
  border: 1px solid #837F39;
  color: #837F39;
}
button.btn.danger-btn {
  background: transparent;
  border: 1px solid #f58d45;
  transition: 0.3s ease-in;
  color: #f58d45;
}
button.btn.danger-btn:hover {
  background: #f58d45;
  border: 1px solid #f58d45;
  color: #fff;
}
button.btn.btn-dark-primary {
  background-color: #180065;
  color: #fff;
  padding: 0.7rem 2rem;
  font-weight: bold;
}
button.btn.btn-dark-primary:hover {
  background: #180065;
  border: 1px solid #000;
  color: #fff;
}
button.btn.btn-grey {
  background-color: #c4c4c4;
  color: #000;
  padding: 0.5rem 2rem;
  font-weight: bold;
}
button.btn.btn-grey:hover {
  background: #c4c4c4;
  border: 1px solid #000;
  color: #000;
}
button.btn.btn-blue-primary {
  background-color: #d4defb;
  color: #180065;
}
button.btn.btn-blue-primary:hover {
  background: #d4defb;
  border: 1px solid #d4defb;
  color: #180065;
}
button.btn.btn-blue-outline {
  background-color: transparent;
  color: #180065;
  border: 1px solid #180065;
}
button.btn.btn-blue-outline:hover {
  background: transparent;
  border: 1px solid #180065;
  color: #180065;
}

.btn:focus,
.btn.focus,
input:focus {
  outline: 0;
  box-shadow: none;
}

.form-control:focus {
  border-color: none;
  outline: 0;
  box-shadow: none;
  background: none;
}

.form-control-multiselect div:first-child {
  border-radius: 0;
}

.cursor-pointer {
  cursor: pointer;
}

.border-bottom-c4 {
  border-bottom: 1px solid #c4c4c4;
}

.white-bg {
  background-color: #fff;
  padding: 24px;
}

.font-weight-bold {
  font-weight: bold;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.cke_inner .cke_editable p {
  font-family: Poppins;
  font-size: 14px !important;
  line-height: 17px;
  color: #787878 !important;
  opacity: 0.5;
}

.add-course .stepper-horizontal {
  width: 100%;
  margin: 0 auto;
  display: flex;
}
.add-course .stepper-horizontal .step {
  position: relative;
  width: 30%;
  padding: 24px;
}
.add-course .stepper-horizontal .step:first-child {
  width: 20%;
}
.add-course .stepper-horizontal .step:first-child .step-bar-left,
.add-course .stepper-horizontal .step:last-child .step-bar-right {
  display: none;
}
.add-course .stepper-horizontal .step .step-circle {
  width: 31px;
  height: 31px;
  margin: 0 auto;
  background: #fff;
  border-radius: 50%;
  text-align: center;
  border: 1px solid #929292;
}
.add-course .stepper-horizontal.green .step.active .step-circle {
  border: 8px solid #189c5c;
}
.add-course .stepper-horizontal .step .step-title {
  margin-top: 18px;
  font-family: Poppins;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  text-transform: uppercase;
  color: #4f4f4f;
}
.add-course .stepper-horizontal .step .step-sub-title {
  font-family: Poppins;
  font-size: 13px;
  line-height: 15px;
  text-align: center;
  text-transform: uppercase;
  color: #505050;
}
.add-course .stepper-horizontal .step.active .step-bar-left.completed {
  border-top: 1px solid #189c5c;
}
.add-course .stepper-horizontal .step.active .step-sub-title {
  font-family: Poppins;
  font-size: 13px;
  line-height: 15px;
  text-align: center;
  text-transform: uppercase;
  color: #189c5c;
}
.add-course .stepper-horizontal .step.completed .step-circle {
  border: 8px solid #189c5c;
}
.add-course .stepper-horizontal .step.completed .step-bar-left,
.add-course .stepper-horizontal .step.completed .step-bar-right {
  border-top: 1px solid #189c5c;
}
.add-course .stepper-horizontal .step .step-bar-left,
.add-course .stepper-horizontal .step .step-bar-right {
  position: absolute;
  top: 36px;
  height: 1px;
  border-top: 1px solid #c4c4c4;
}
.add-course .stepper-horizontal .step .step-bar-right {
  right: 0;
  left: 50%;
  margin-left: 15px;
}
.add-course .stepper-horizontal .step .step-bar-left {
  left: 0;
  right: 50%;
  margin-right: 15px;
}

.common-navlink .nav-tabs {
  border-bottom: 1px solid #d7d7d7 !important;
  width: 100%;
}
.common-navlink .nav-tabs .nav-link {
  border-bottom: 2px solid #222;
  cursor: pointer;
  border: 0;
  padding: 10px;
}
.common-navlink .filled-tabs a {
  cursor: pointer;
}
.common-navlink .filled-tabs a.active.nav-link {
  color: #222;
  border-radius: 0px;
  border-bottom: 4px solid #222;
}
.common-navlink .filled-tabs a.nav-link {
  background: transparent;
  font-family: Poppins;
  border-bottom: 4px solid transparent;
  width: 185px;
  height: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777777;
  font-size: 1.125rem;
  line-height: 21px;
}
.common-navlink .filled-tabs a.nav-link:hover {
  color: #222;
  border-radius: 0px;
  border-bottom: 4px solid #222;
}

.input-group .mailIcon {
  height: 13px;
  width: 13px;
}

.border-dashed {
  border-style: dashed;
  border-width: thin;
  border-color: #ddd;
}

.text-black {
  color: #000;
}

.text-black-50 {
  color: #565958;
}

.text-black-30 {
  color: #303030;
}

.text-grey {
  color: #e8e4e4;
}

.text-grey-span {
  color: #909090;
}

.text-black-4D {
  color: #4d4d4d;
}

.text-grey-65 {
  color: #656565;
}

.text-green-18 {
  color: #837F39;
}

.bg-green {
  background-color: #837F39;
}

.bg-black50 {
  background-color: #565958;
}

.bg-ash-gray {
  background-color: #c4c4c4;
}

.bg-ash {
  background-color: #f7f7f7;
}

.text-black-ash {
  color: #180065;
}

.text-blue-info {
  color: #3fc1e8;
}

.bg-violet {
  background-color: #180065;
  color: #fff;
}

.form-btn {
  background-color: #180065;
  color: #fff;
}

.text-decoration-underline {
  text-decoration: underline;
}

.bg-violet-lite {
  color: #fff;
  background-color: #796ba6;
}

.bg-violet-border {
  color: #7466a3;
  background-color: #fff;
  border: 2px solid #7466a3;
}

.bg-blue-lite {
  background-color: #edf1fb;
}

.text-primarybg {
  color: #180065;
}

.border-primary-bg {
  border: 1px solid #180065;
}

.title-text {
  color: #180065;
  font-size: 1.5rem;
  font-weight: 600;
}

.border-radius-5 {
  border-radius: 5px;
}

.bg-light-primary {
  background-color: #EDF8F7;
}

.srv-validation-message {
  font-size: 12px;
}

input[type=checkbox] {
  accent-color: #2A7A7B;
}

.text-green {
  color: #2A7A7B;
}

.css-bfrw9z {
  z-index: 0;
}

.month_default_event * {
  color: white !important;
}

/* Color */
.text-c1 {
  color: #e5e5e5;
}

.bg-c1 {
  background-color: #e5e5e5;
}

.bg-h-c1 {
  background-color: #e5e5e5;
}

.bc-c1 {
  border-color: #e5e5e5;
}

.text-c2 {
  color: #180065;
}

.bg-c2 {
  background-color: #180065;
}

.bg-h-c2 {
  background-color: #180065;
}

.bc-c2 {
  border-color: #180065;
}

.text-c3 {
  color: #f9f9f9;
}

.bg-c3 {
  background-color: #f9f9f9;
}

.bg-h-c3 {
  background-color: #f9f9f9;
}

.bc-c3 {
  border-color: #f9f9f9;
}

.text-c4 {
  color: #556080;
}

.bg-c4 {
  background-color: #556080;
}

.bg-h-c4 {
  background-color: #556080;
}

.bc-c4 {
  border-color: #556080;
}

.text-c5 {
  color: #6c6c6c;
}

.bg-c5 {
  background-color: #6c6c6c;
}

.bg-h-c5 {
  background-color: #6c6c6c;
}

.bc-c5 {
  border-color: #6c6c6c;
}

.text-c6 {
  color: #dff5fb;
}

.bg-c6 {
  background-color: #dff5fb;
}

.bg-h-c6 {
  background-color: #dff5fb;
}

.bc-c6 {
  border-color: #dff5fb;
}

.text-c7 {
  color: #dff9e1;
}

.bg-c7 {
  background-color: #dff9e1;
}

.bg-h-c7 {
  background-color: #dff9e1;
}

.bc-c7 {
  border-color: #dff9e1;
}

.text-c8 {
  color: #dfedff;
}

.bg-c8 {
  background-color: #dfedff;
}

.bg-h-c8 {
  background-color: #dfedff;
}

.bc-c8 {
  border-color: #dfedff;
}

.text-c9 {
  color: #fee7e5;
}

.bg-c9 {
  background-color: #fee7e5;
}

.bg-h-c9 {
  background-color: #fee7e5;
}

.bc-c9 {
  border-color: #fee7e5;
}

.text-c10 {
  color: #b9e1ec;
}

.bg-c10 {
  background-color: #b9e1ec;
}

.bg-h-c10 {
  background-color: #b9e1ec;
}

.bc-c10 {
  border-color: #b9e1ec;
}

.text-c11 {
  color: #bfedc2;
}

.bg-c11 {
  background-color: #bfedc2;
}

.bg-h-c11 {
  background-color: #bfedc2;
}

.bc-c11 {
  border-color: #bfedc2;
}

.text-c12 {
  color: #b8ceeb;
}

.bg-c12 {
  background-color: #b8ceeb;
}

.bg-h-c12 {
  background-color: #b8ceeb;
}

.bc-c12 {
  border-color: #b8ceeb;
}

.text-c13 {
  color: #f2d0cd;
}

.bg-c13 {
  background-color: #f2d0cd;
}

.bg-h-c13 {
  background-color: #f2d0cd;
}

.bc-c13 {
  border-color: #f2d0cd;
}

.text-c14 {
  color: #0d0d0d;
}

.bg-c14 {
  background-color: #0d0d0d;
}

.bg-h-c14 {
  background-color: #0d0d0d;
}

.bc-c14 {
  border-color: #0d0d0d;
}

.text-c15 {
  color: #424242;
}

.bg-c15 {
  background-color: #424242;
}

.bg-h-c15 {
  background-color: #424242;
}

.bc-c15 {
  border-color: #424242;
}

.text-c16 {
  color: #d7dff7;
}

.bg-c16 {
  background-color: #d7dff7;
}

.bg-h-c16 {
  background-color: #d7dff7;
}

.bc-c16 {
  border-color: #d7dff7;
}

.text-c17 {
  color: #aebfef;
}

.bg-c17 {
  background-color: #aebfef;
}

.bg-h-c17 {
  background-color: #aebfef;
}

.bc-c17 {
  border-color: #aebfef;
}

.text-c18 {
  color: #6c6c6c;
}

.bg-c18 {
  background-color: #6c6c6c;
}

.bg-h-c18 {
  background-color: #6c6c6c;
}

.bc-c18 {
  border-color: #6c6c6c;
}

.text-c19 {
  color: #27bf2f;
}

.bg-c19 {
  background-color: #27bf2f;
}

.bg-h-c19 {
  background-color: #27bf2f;
}

.bc-c19 {
  border-color: #27bf2f;
}

.text-c20 {
  color: #ff6f06;
}

.bg-c20 {
  background-color: #ff6f06;
}

.bg-h-c20 {
  background-color: #ff6f06;
}

.bc-c20 {
  border-color: #ff6f06;
}

.text-c21 {
  color: #d73e3e;
}

.bg-c21 {
  background-color: #d73e3e;
}

.bg-h-c21 {
  background-color: #d73e3e;
}

.bc-c21 {
  border-color: #d73e3e;
}

/* Font Size */
.fs-38 {
  font-size: 38px;
}

.fs-37 {
  font-size: 37px;
}

.fs-36 {
  font-size: 36px;
}

.fs-35 {
  font-size: 35px;
}

.fs-34 {
  font-size: 34px;
}

.fs-33 {
  font-size: 33px;
}

.fs-32 {
  font-size: 32px;
}

.fs-31 {
  font-size: 31px;
}

.fs-30 {
  font-size: 30px;
}

.fs-29 {
  font-size: 29px;
}

.fs-28 {
  font-size: 28px;
}

.fs-27 {
  font-size: 27px;
}

.fs-26 {
  font-size: 26px;
}

.fs-25 {
  font-size: 25px;
}

.fs-24 {
  font-size: 24px;
}

.fs-23 {
  font-size: 23px;
}

.fs-22 {
  font-size: 22px;
}

.fs-21 {
  font-size: 21px;
}

.fs-20 {
  font-size: 20px;
}

.fs-19 {
  font-size: 19px;
}

.fs-18 {
  font-size: 18px;
}

.fs-17 {
  font-size: 17px;
}

.fs-16 {
  font-size: 16px;
}

.fs-15 {
  font-size: 15px;
}

.fs-14 {
  font-size: 14px;
}

.fs-13 {
  font-size: 13px;
}

.fs-12 {
  font-size: 12px;
}

.fs-11 {
  font-size: 11px;
}

.fs-10 {
  font-size: 10px;
}

.fs-9 {
  font-size: 9px;
}

.line-height-38 {
  line-height: 38px;
}

.line-height-37 {
  line-height: 37px;
}

.line-height-36 {
  line-height: 36px;
}

.line-height-35 {
  line-height: 35px;
}

.line-height-34 {
  line-height: 34px;
}

.line-height-33 {
  line-height: 33px;
}

.line-height-32 {
  line-height: 32px;
}

.line-height-31 {
  line-height: 31px;
}

.line-height-30 {
  line-height: 30px;
}

.line-height-29 {
  line-height: 29px;
}

.line-height-28 {
  line-height: 28px;
}

.line-height-27 {
  line-height: 27px;
}

.line-height-26 {
  line-height: 26px;
}

.line-height-25 {
  line-height: 25px;
}

.line-height-24 {
  line-height: 24px;
}

.line-height-23 {
  line-height: 23px;
}

.line-height-22 {
  line-height: 22px;
}

.line-height-21 {
  line-height: 21px;
}

.line-height-20 {
  line-height: 20px;
}

.line-height-19 {
  line-height: 19px;
}

.line-height-18 {
  line-height: 18px;
}

.line-height-17 {
  line-height: 17px;
}

.line-height-16 {
  line-height: 16px;
}

.line-height-15 {
  line-height: 15px;
}

.line-height-14 {
  line-height: 14px;
}

.line-height-13 {
  line-height: 13px;
}

.line-height-12 {
  line-height: 12px;
}

.line-height-11 {
  line-height: 11px;
}

.line-height-10 {
  line-height: 10px;
}

.line-height-9 {
  line-height: 9px;
}

/* Font-weight */
.fw-800 {
  font-weight: 800;
}

.fw-700 {
  font-weight: 700;
}

.fw-600 {
  font-weight: 600;
}

.fw-500 {
  font-weight: 500;
}

/* Height */
.h-700 {
  height: 700;
}

.h-650 {
  height: 650;
}

.h-600 {
  height: 600;
}

.h-550 {
  height: 550;
}

.h-500 {
  height: 500;
}

.h-450 {
  height: 450;
}

.mob-title {
  font-family: Poppins;
  font-style: normal;
  font-size: 16px;
  font-weight: 500;
  line-height: 34px;
}

@media (max-width: 480px) {
  .search-bar,
  .sidebar-icon-only .sidebar-list-items,
  .date,
  .search-bar2 {
    width: 100% !important;
  }
  .userdropdown .dropdown-toggle::after {
    margin-left: 4.255em !important;
  }
  .coin-icon {
    padding-left: 0px !important;
  }
  h3,
  h4 {
    font-size: 16px !important;
  }
}
@media screen and (min-width: 820px) {
  .search-bar,
  .sidebar-icon-only .sidebar-list-items,
  .date,
  .search-bar2 {
    width: 80% !important;
  }
}
@font-face {
  font-family: Poppins;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
@font-face {
  font-family: Poppins-regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
@font-face {
  font-family: Poppins-heavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
@font-face {
  font-family: Poppins-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
@font-face {
  font-family: Poppins-Bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.srv-validation-message {
  color: black;
}

* {
  box-sizing: border-box !important;
}

.chatbotIcon {
  position: fixed;
  bottom: 5px;
  right: 5px;
  width: 50px;
  height: 50px;
  border-radius: 100px;
  background-color: #2A7A7B;
  cursor: pointer;
}

.chatbotCloseContainer {
  position: relative;
}

.chatbotClose {
  position: absolute;
  top: -15px;
  right: 0px;
  z-index: 999;
  border-radius: 100px;
  border: 0;
  background-color: tomato;
  color: white;
}

.react-chatbot-kit-chat-container {
  width: 400px !important;
  border: 1px solid lightgray;
  border-radius: 5px;
}

.react-chatbot-kit-chat-bot-message {
  margin-left: 0px !important;
}

.chatbotApp {
  position: fixed;
  bottom: 60px;
  right: 10px;
  display: none;
  animation: chatbotAppAnim 0.5s 1;
  z-index: 9;
}

@keyframes chatbotAppAnim {
  from {
    height: 0px;
  }
  to {
    height: 600px;
  }
}
.rotateIcon {
  animation: rotateIconAnim 0.2s 1;
}

@keyframes rotateIconAnim {
  from {
    transform: rotate(360deg);
    background-color: black;
  }
  to {
    transform: rotate(0deg);
  }
}
.appLogo2 {
  width: 30px;
  height: 30px;
  background-color: transparent;
  border-radius: 100px;
  margin: 5px;
}

@media screen and (max-width: 480px) {
  .react-chatbot-kit-chat-container {
    width: 340px !important;
  }
}
html,
body {
  scroll-behavior: smooth;
}

.badge-primary,
dropdown-item:active,
.dropdown-item:focus,
.btn-default:focus {
  background-color: #2A7A7B !important;
  color: white;
}

.link-text:hover,
.sidebar-list-item:hover {
  color: #2A7A7B !important;
}

.dropdown-menu.show {
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/index.scss","webpack://./src/assets/scss/default/default.scss","webpack://./src/assets/scss/abstracts/variables.scss","webpack://./src/assets/scss/abstracts/functions.scss","webpack://./src/assets/scss/default/utility.scss","webpack://./node_modules/swiper/swiper.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/assets/scss/auth/login.scss","webpack://./src/assets/scss/common.scss","webpack://./src/assets/scss/layouts/mobile.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACG,SAAA;EACA,6KAAA;EACA,mCAAA;EACA,kCAAA;ADGH;;ACAA;EACG,uFAAA;ADGH;;AE6DA,UAAA;AA2BE;EACE,cA3BO;AFzDX;;AEsFE;EACE,yBA9BO;AFrDX;;AEqFE;EACE,yBAjCO;AFjDX;;AEoFE;EACE,qBApCO;AF7CX;;AEuEE;EACE,cA3BO;AFzCX;;AEsEE;EACE,yBA9BO;AFrCX;;AEqEE;EACE,yBAjCO;AFjCX;;AEoEE;EACE,qBApCO;AF7BX;;AEuDE;EACE,cA3BO;AFzBX;;AEsDE;EACE,yBA9BO;AFrBX;;AEqDE;EACE,yBAjCO;AFjBX;;AEoDE;EACE,qBApCO;AFbX;;AEuCE;EACE,cA3BO;AFTX;;AEsCE;EACE,yBA9BO;AFLX;;AEqCE;EACE,yBAjCO;AFDX;;AEoCE;EACE,qBApCO;AFGX;;AEuBE;EACE,cA3BO;AFOX;;AEsBE;EACE,yBA9BO;AFWX;;AEqBE;EACE,yBAjCO;AFeX;;AEoBE;EACE,qBApCO;AFmBX;;AEOE;EACE,cA3BO;AFuBX;;AEME;EACE,yBA9BO;AF2BX;;AEKE;EACE,yBAjCO;AF+BX;;AEIE;EACE,qBApCO;AFmCX;;AETE;EACE,cA3BO;AFuCX;;AEVE;EACE,yBA9BO;AF2CX;;AEXE;EACE,yBAjCO;AF+CX;;AEZE;EACE,qBApCO;AFmDX;;AEzBE;EACE,cA3BO;AFuDX;;AE1BE;EACE,yBA9BO;AF2DX;;AE3BE;EACE,yBAjCO;AF+DX;;AE5BE;EACE,qBApCO;AFmEX;;AEzCE;EACE,cA3BO;AFuEX;;AE1CE;EACE,yBA9BO;AF2EX;;AE3CE;EACE,yBAjCO;AF+EX;;AE5CE;EACE,qBApCO;AFmFX;;AEzDE;EACE,cA3BO;AFuFX;;AE1DE;EACE,yBA9BO;AF2FX;;AE3DE;EACE,yBAjCO;AF+FX;;AE5DE;EACE,qBApCO;AFmGX;;AEzEE;EACE,cA3BO;AFuGX;;AE1EE;EACE,yBA9BO;AF2GX;;AE3EE;EACE,yBAjCO;AF+GX;;AE5EE;EACE,qBApCO;AFmHX;;AEzFE;EACE,cA3BO;AFuHX;;AE1FE;EACE,yBA9BO;AF2HX;;AE3FE;EACE,yBAjCO;AF+HX;;AE5FE;EACE,qBApCO;AFmIX;;AEzGE;EACE,cA3BO;AFuIX;;AE1GE;EACE,yBA9BO;AF2IX;;AE3GE;EACE,yBAjCO;AF+IX;;AE5GE;EACE,qBApCO;AFmJX;;AEzHE;EACE,cA3BO;AFuJX;;AE1HE;EACE,yBA9BO;AF2JX;;AE3HE;EACE,yBAjCO;AF+JX;;AE5HE;EACE,qBApCO;AFmKX;;AEzIE;EACE,cA3BO;AFuKX;;AE1IE;EACE,yBA9BO;AF2KX;;AE3IE;EACE,yBAjCO;AF+KX;;AE5IE;EACE,qBApCO;AFmLX;;AEzJE;EACE,cA3BO;AFuLX;;AE1JE;EACE,yBA9BO;AF2LX;;AE3JE;EACE,yBAjCO;AF+LX;;AE5JE;EACE,qBApCO;AFmMX;;AEzKE;EACE,cA3BO;AFuMX;;AE1KE;EACE,yBA9BO;AF2MX;;AE3KE;EACE,yBAjCO;AF+MX;;AE5KE;EACE,qBApCO;AFmNX;;AEzLE;EACE,cA3BO;AFuNX;;AE1LE;EACE,yBA9BO;AF2NX;;AE3LE;EACE,yBAjCO;AF+NX;;AE5LE;EACE,qBApCO;AFmOX;;AEzME;EACE,cA3BO;AFuOX;;AE1ME;EACE,yBA9BO;AF2OX;;AE3ME;EACE,yBAjCO;AF+OX;;AE5ME;EACE,qBApCO;AFmPX;;AEzNE;EACE,cA3BO;AFuPX;;AE1NE;EACE,yBA9BO;AF2PX;;AE3NE;EACE,yBAjCO;AF+PX;;AE5NE;EACE,qBApCO;AFmQX;;AEzOE;EACE,cA3BO;AFuQX;;AE1OE;EACE,yBA9BO;AF2QX;;AE3OE;EACE,yBAjCO;AF+QX;;AE5OE;EACE,qBApCO;AFmRX;;AGrVA,cAAA;AAGE;EACE,eAAA;AHsVJ;;AGvVE;EACE,eAAA;AH0VJ;;AG3VE;EACE,eAAA;AH8VJ;;AG/VE;EACE,eAAA;AHkWJ;;AGnWE;EACE,eAAA;AHsWJ;;AGvWE;EACE,eAAA;AH0WJ;;AG3WE;EACE,eAAA;AH8WJ;;AG/WE;EACE,eAAA;AHkXJ;;AGnXE;EACE,eAAA;AHsXJ;;AGvXE;EACE,eAAA;AH0XJ;;AG3XE;EACE,eAAA;AH8XJ;;AG/XE;EACE,eAAA;AHkYJ;;AGnYE;EACE,eAAA;AHsYJ;;AGvYE;EACE,eAAA;AH0YJ;;AG3YE;EACE,eAAA;AH8YJ;;AG/YE;EACE,eAAA;AHkZJ;;AGnZE;EACE,eAAA;AHsZJ;;AGvZE;EACE,eAAA;AH0ZJ;;AG3ZE;EACE,eAAA;AH8ZJ;;AG/ZE;EACE,eAAA;AHkaJ;;AGnaE;EACE,eAAA;AHsaJ;;AGvaE;EACE,eAAA;AH0aJ;;AG3aE;EACE,eAAA;AH8aJ;;AG/aE;EACE,eAAA;AHkbJ;;AGnbE;EACE,eAAA;AHsbJ;;AGvbE;EACE,eAAA;AH0bJ;;AG3bE;EACE,eAAA;AH8bJ;;AG/bE;EACE,eAAA;AHkcJ;;AGncE;EACE,eAAA;AHscJ;;AGvcE;EACE,cAAA;AH0cJ;;AGlcE;EACE,iBAAA;AHqcJ;;AGtcE;EACE,iBAAA;AHycJ;;AG1cE;EACE,iBAAA;AH6cJ;;AG9cE;EACE,iBAAA;AHidJ;;AGldE;EACE,iBAAA;AHqdJ;;AGtdE;EACE,iBAAA;AHydJ;;AG1dE;EACE,iBAAA;AH6dJ;;AG9dE;EACE,iBAAA;AHieJ;;AGleE;EACE,iBAAA;AHqeJ;;AGteE;EACE,iBAAA;AHyeJ;;AG1eE;EACE,iBAAA;AH6eJ;;AG9eE;EACE,iBAAA;AHifJ;;AGlfE;EACE,iBAAA;AHqfJ;;AGtfE;EACE,iBAAA;AHyfJ;;AG1fE;EACE,iBAAA;AH6fJ;;AG9fE;EACE,iBAAA;AHigBJ;;AGlgBE;EACE,iBAAA;AHqgBJ;;AGtgBE;EACE,iBAAA;AHygBJ;;AG1gBE;EACE,iBAAA;AH6gBJ;;AG9gBE;EACE,iBAAA;AHihBJ;;AGlhBE;EACE,iBAAA;AHqhBJ;;AGthBE;EACE,iBAAA;AHyhBJ;;AG1hBE;EACE,iBAAA;AH6hBJ;;AG9hBE;EACE,iBAAA;AHiiBJ;;AGliBE;EACE,iBAAA;AHqiBJ;;AGtiBE;EACE,iBAAA;AHyiBJ;;AG1iBE;EACE,iBAAA;AH6iBJ;;AG9iBE;EACE,iBAAA;AHijBJ;;AGljBE;EACE,iBAAA;AHqjBJ;;AGtjBE;EACE,gBAAA;AHyjBJ;;AGpjBA,gBAAA;AAGE;EACE,gBAHC;AHwjBL;;AGtjBE;EACE,gBAEG;AHujBP;;AG1jBE;EACE,gBAEG;AH2jBP;;AG9jBE;EACE,gBAEG;AH+jBP;;AG5jBA,WAAA;AAGE;EACE,WAHK;AHgkBT;;AG9jBE;EACE,WAEO;AH+jBX;;AGlkBE;EACE,WAEO;AHmkBX;;AGtkBE;EACE,WAEO;AHukBX;;AG1kBE;EACE,WAEO;AH2kBX;;AG9kBE;EACE,WAEO;AH+kBX;;AItnBA;EACE,WFFc;AF2nBhB;AIxnBE;EACE,WFHiB;AF6nBrB;;AIvnBA;EACE,cFFK;AF4nBP;;AIvnBE;EACE,WFXiB;EEYjB,eAAA;AJ0nBJ;;AIvnBA;EACE,UAAA;AJ0nBF;;AIxnBA;EACE,UAAA;AJ2nBF;;AIznBA;EACE,UAAA;AJ4nBF;;AI1nBA;EACE,aAAA;AJ6nBF;;AIznBE;EACE,uBAAA;AJ4nBJ;;AIxnBA;EACE,sBFpCc;AF+pBhB;;AIznBA;EACE,sBFvCc;AFmqBhB;;AIznBA;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AJ4nBF;;AIznBA;EACE,6CAAA;AJ4nBF;;AIznBA;EACE,6CAAA;AJ4nBF;;AIznBA;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EAEA,iBAAA;AJ2nBF;AIznBE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AJ2nBJ;;AItnBE;EACE,gCAAA;AJynBJ;AIxnBI;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,eAAA;AJ0nBN;AIxnBM;EACE,YAAA;EACA,kBAAA;AJ0nBR;AIxnBM;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AJ0nBR;;AIpnBA;EACE,yBAAA;EACA,aAAA;AJunBF;;AKjuBA;EACE,2BAAA;EACA,2DAAA;EAEA,gBAAA;EACA,kBAAA;ALmuBF;AKhuBA;EACE,6BAAA;ALkuBF;;AKhuBA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;ALmuBF;;AKjuBA;EACE,sBAAA;ALouBF;;AKluBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;ALquBF;;AKnuBA;;EAEE,iCAAA;ALsuBF;;AKpuBA;EACE,eAAA;ALuuBF;;AKruBA;EACE,eAAA;EACA,sBAAA;ALwuBF;;AKtuBA;EACE,oCAAA;EACA,cAAA;ALyuBF;;AKvuBA;EACE,mBAAA;AL0uBF;AKzuBE;EACE,mBAAA;AL2uBJ;;AKxuBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;AL2uBF;;AKzuBA;EACE,kBAAA;AL4uBF;;AK1uBA,gBAAA;AAEE;;EAEE,YAAA;AL4uBJ;AKzuBE;EACE,uBAAA;EACA,sCAAA;AL2uBJ;;AKvuBA,eAAA;AACA;EACE,mBAAA;AL0uBF;AKzuBE;;;;;;;EAOE,4BAAA;AL2uBJ;AKzuBE;;;;EAIE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AL2uBJ;AKzuBE;EACE,gFAAA;AL2uBJ;AKzuBE;EACE,iFAAA;AL2uBJ;AKzuBE;EACE,+EAAA;AL2uBJ;AKzuBE;EACE,kFAAA;AL2uBJ;;AKvuBA,aAAA;AAEE;EACE,cAAA;EACA,qBAAA,EAAA,gBAAA;EACA,wBAAA,EAAA,mCAAA;ALyuBJ;AKxuBI;EACE,aAAA;AL0uBN;AKvuBE;EACE,8BAAA;ALyuBJ;;AKruBE;EACE,6BAAA;ALwuBJ;;AKpuBE;EACE,6BAAA;ALuuBJ;;AMj3BA;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,gBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,kOAAA;EACA,6GAAA;APs4BF;;AQr4BA;;;EAGE,sBAAA;ARw4BF;;AQr4BA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;ARw4BF;;AQl4BA;EACE,cAAA;ARq4BF;;AQ33BA;EACE,SAAA;EACA,qNCsO4B;ECjGxB,eAAA;EFnIJ,gBC+O4B;ED9O5B,gBCmP4B;EDlP5B,cCnCS;EDoCT,gBAAA;EACA,sBN7CM;AF26BR;;AQl3BA;EACE,qBAAA;ARq3BF;;AQ52BA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AR+2BF;;AQl2BA;EACE,aAAA;EACA,qBCiN4B;ATopB9B;;AQ91BA;EACE,aAAA;EACA,mBCoF0B;AT6wB5B;;AQt1BA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;ARy1BF;;AQt1BA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ARy1BF;;AQt1BA;;;EAGE,aAAA;EACA,mBAAA;ARy1BF;;AQt1BA;;;;EAIE,gBAAA;ARy1BF;;AQt1BA;EACE,gBCkJ4B;ATusB9B;;AQt1BA;EACE,qBAAA;EACA,cAAA;ARy1BF;;AQt1BA;EACE,gBAAA;ARy1BF;;AQt1BA;;EAEE,mBCqI4B;ATotB9B;;AQt1BA;EEII,cAAA;AVs1BJ;;AQj1BA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;ARo1BF;;AQj1BA;EAAM,eAAA;ARq1BN;;AQp1BA;EAAM,WAAA;ARw1BN;;AQj1BA;EACE,cCXwC;EDYxC,qBCXwC;EDYxC,6BAAA;ARo1BF;AWpgCE;EHmLE,wDCdsC;EDetC,0BCdsC;ATk2B1C;;AQ30BA;EACE,cAAA;EACA,qBAAA;AR80BF;AW7gCE;EHkME,cAAA;EACA,qBAAA;AR80BJ;;AQr0BA;;;;EAIE,iGC0D4B;EClH1B,cAAA;AVi4BJ;;AQr0BA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;ARm0BF;;AQ3zBA;EAEE,gBAAA;AR6zBF;;AQrzBA;EACE,sBAAA;EACA,kBAAA;ARwzBF;;AQrzBA;EAGE,gBAAA;EACA,sBAAA;ARszBF;;AQ9yBA;EACE,yBAAA;ARizBF;;AQ9yBA;EACE,oBC8E4B;ED7E5B,uBC6E4B;ED5E5B,cCtQS;EDuQT,gBAAA;EACA,oBAAA;ARizBF;;AQ1yBA;EAEE,mBAAA;EACA,gCAAA;AR4yBF;;AQpyBA;EAEE,qBAAA;EACA,qBC4JsC;AT0oBxC;;AQhyBA;EAEE,gBAAA;ARkyBF;;AQ1xBA;EACE,UAAA;AR6xBF;;AQ1xBA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AR6xBF;;AQ1xBA;;EAEE,iBAAA;AR6xBF;;AQ1xBA;;EAEE,oBAAA;AR6xBF;;AQvxBA;EACE,eAAA;AR0xBF;;AQpxBA;EACE,iBAAA;ARuxBF;;AQhxBA;;;;EAIE,0BAAA;ARmxBF;;AQ1wBI;;;;EACE,eAAA;ARgxBN;;AQ1wBA;;;;EAIE,UAAA;EACA,kBAAA;AR6wBF;;AQ1wBA;;EAEE,sBAAA;EACA,UAAA;AR6wBF;;AQzwBA;EACE,cAAA;EAEA,gBAAA;AR2wBF;;AQxwBA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;ARqwBF;;AQhwBA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE9OI,iBAAA;EFgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;ARmwBF;;AQhwBA;EACE,wBAAA;ARmwBF;;AQ/vBA;;EAEE,YAAA;ARkwBF;;AQ/vBA;EAKE,oBAAA;EACA,wBAAA;AR8vBF;;AQvvBA;EACE,wBAAA;AR0vBF;;AQlvBA;EACE,aAAA;EACA,0BAAA;ARqvBF;;AQ9uBA;EACE,qBAAA;ARivBF;;AQ9uBA;EACE,kBAAA;EACA,eAAA;ARivBF;;AQ9uBA;EACE,aAAA;ARivBF;;AQ5uBA;EACE,wBAAA;AR+uBF;;AY3sCA;;EAEE,qBHsS4B;EGpS5B,gBHsS4B;EGrS5B,gBHsS4B;ATu6B9B;;AYzsCA;EFqKM,iBAAA;AVwiCN;;AY5sCA;EFoKM,eAAA;AV4iCN;;AY/sCA;EFmKM,kBAAA;AVgjCN;;AYltCA;EFkKM,iBAAA;AVojCN;;AYrtCA;EFiKM,kBAAA;AVwjCN;;AYxtCA;EFgKM,eAAA;AV4jCN;;AY1tCA;EF8JM,kBAAA;EE5JJ,gBHwS4B;ATq7B9B;;AYztCA;EFwJM,eAAA;EEtJJ,gBH2R4B;EG1R5B,gBHkR4B;AT08B9B;;AY1tCA;EFmJM,iBAAA;EEjJJ,gBHuR4B;EGtR5B,gBH6Q4B;ATg9B9B;;AY3tCA;EF8IM,iBAAA;EE5IJ,gBHmR4B;EGlR5B,gBHwQ4B;ATs9B9B;;AY5tCA;EFyIM,iBAAA;EEvIJ,gBH+Q4B;EG9Q5B,gBHmQ4B;AT49B9B;;AYvtCA;EACE,gBHgFO;EG/EP,mBH+EO;EG9EP,SAAA;EACA,wCAAA;AZ0tCF;;AYltCA;;EFkGI,kBAAA;EE/FF,gBH2N4B;AT0/B9B;;AYltCA;;EAEE,cHmQ4B;EGlQ5B,yBH2Q4B;AT08B9B;;AY7sCA;EC/EE,eAAA;EACA,gBAAA;AbgyCF;;AY7sCA;ECpFE,eAAA;EACA,gBAAA;AbqyCF;;AY/sCA;EACE,qBAAA;AZktCF;AYhtCE;EACE,oBHqP0B;AT69B9B;;AYxsCA;EF2DI,cAAA;EEzDF,yBAAA;AZ2sCF;;AYvsCA;EACE,mBHuBO;EC6CH,kBAAA;AVuoCN;;AYvsCA;EACE,cAAA;EF+CE,kBAAA;EE7CF,cH1GS;ATozCX;AYxsCE;EACE,aAAA;AZ0sCJ;;Ac7zCA;ECIE,eAAA;EAGA,YAAA;Af2zCF;;Ac5zCA;EACE,gBLqgCkC;EKpgClC,sBZPM;EYQN,yBAAA;EEEE,sBAAA;EDPF,eAAA;EAGA,YAAA;Afo0CF;;ActzCA;EAEE,qBAAA;AdwzCF;;AcrzCA;EACE,qBAAA;EACA,cAAA;AdwzCF;;AcrzCA;EJ8HI,cAAA;EI5HF,cL3BS;ATm1CX;;AiB/1CA;EPmKI,gBAAA;EOjKF,cfuBK;EetBL,qBAAA;AjBk2CF;AiB/1CE;EACE,cAAA;AjBi2CJ;;AiB51CA;EACE,sBAAA;EPsJE,gBAAA;EOpJF,WfRM;EeSN,yBRDS;EOEP,qBAAA;AhB+1CJ;AiB51CE;EACE,UAAA;EP8IA,eAAA;EO5IA,gBRyQ0B;ATqlC9B;;AiBx1CA;EACE,cAAA;EPqIE,gBAAA;EOnIF,cRjBS;AT42CX;AiBx1CE;EPgIE,kBAAA;EO9HA,cAAA;EACA,kBAAA;AjB01CJ;;AiBr1CA;EACE,iBRikCkC;EQhkClC,kBAAA;AjBw1CF;;AkBh4CE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AnB04CF;;AoBv1CI;EFzCE;IACE,gBT8Le;ETssCrB;AACF;AoB71CI;EFzCE;IACE,gBT8Le;ET2sCrB;AACF;AoBl2CI;EFzCE;IACE,gBT8Le;ETgtCrB;AACF;AoBv2CI;EFzCE;IACE,iBT8Le;ETqtCrB;AACF;AkBx3CE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AnB85CF;;AkBx3CE;EACE,eAAA;EACA,cAAA;AlB23CJ;AkBz3CI;;EAEE,gBAAA;EACA,eAAA;AlB23CN;;AqBj7CE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;ArBy7CJ;;AqBn6CM;EACE,aAAA;EACA,YAAA;EACA,eAAA;ArBs6CR;;AmB14CE;EACE,cAAA;EACA,eAAA;AnB64CJ;;AmB/4CE;EACE,aAAA;EACA,cAAA;AnBk5CJ;;AmBp5CE;EACE,wBAAA;EACA,yBAAA;AnBu5CJ;;AmBz5CE;EACE,aAAA;EACA,cAAA;AnB45CJ;;AmB95CE;EACE,aAAA;EACA,cAAA;AnBi6CJ;;AmBn6CE;EACE,wBAAA;EACA,yBAAA;AnBs6CJ;;AqBz7CM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;AnB47CF;;AqBz7CU;EFbR,qBAAA;EAIA,sBAAA;AnBu8CF;;AqB97CU;EFbR,sBAAA;EAIA,uBAAA;AnB48CF;;AqBn8CU;EFbR,aAAA;EAIA,cAAA;AnBi9CF;;AqBx8CU;EFbR,sBAAA;EAIA,uBAAA;AnBs9CF;;AqB78CU;EFbR,sBAAA;EAIA,uBAAA;AnB29CF;;AqBl9CU;EFbR,aAAA;EAIA,cAAA;AnBg+CF;;AqBv9CU;EFbR,sBAAA;EAIA,uBAAA;AnBq+CF;;AqB59CU;EFbR,sBAAA;EAIA,uBAAA;AnB0+CF;;AqBj+CU;EFbR,aAAA;EAIA,cAAA;AnB++CF;;AqBt+CU;EFbR,sBAAA;EAIA,uBAAA;AnBo/CF;;AqB3+CU;EFbR,sBAAA;EAIA,uBAAA;AnBy/CF;;AqBh/CU;EFbR,cAAA;EAIA,eAAA;AnB8/CF;;AqB/+CM;EAAwB,SAAA;ArBm/C9B;;AqBj/CM;EAAuB,SAAA;ArBq/C7B;;AqBl/CQ;EAAwB,QADb;ArBu/CnB;;AqBt/CQ;EAAwB,QADb;ArB2/CnB;;AqB1/CQ;EAAwB,QADb;ArB+/CnB;;AqB9/CQ;EAAwB,QADb;ArBmgDnB;;AqBlgDQ;EAAwB,QADb;ArBugDnB;;AqBtgDQ;EAAwB,QADb;ArB2gDnB;;AqB1gDQ;EAAwB,QADb;ArB+gDnB;;AqB9gDQ;EAAwB,QADb;ArBmhDnB;;AqBlhDQ;EAAwB,QADb;ArBuhDnB;;AqBthDQ;EAAwB,QADb;ArB2hDnB;;AqB1hDQ;EAAwB,SADb;ArB+hDnB;;AqB9hDQ;EAAwB,SADb;ArBmiDnB;;AqBliDQ;EAAwB,SADb;ArBuiDnB;;AqB/hDY;EFhBV,wBAAA;AnBmjDF;;AqBniDY;EFhBV,yBAAA;AnBujDF;;AqBviDY;EFhBV,gBAAA;AnB2jDF;;AqB3iDY;EFhBV,yBAAA;AnB+jDF;;AqB/iDY;EFhBV,yBAAA;AnBmkDF;;AqBnjDY;EFhBV,gBAAA;AnBukDF;;AqBvjDY;EFhBV,yBAAA;AnB2kDF;;AqB3jDY;EFhBV,yBAAA;AnB+kDF;;AqB/jDY;EFhBV,gBAAA;AnBmlDF;;AqBnkDY;EFhBV,yBAAA;AnBulDF;;AqBvkDY;EFhBV,yBAAA;AnB2lDF;;AoBtlDI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ErBqnDN;EmBzlDA;IACE,cAAA;IACA,eAAA;EnB2lDF;EmB7lDA;IACE,aAAA;IACA,cAAA;EnB+lDF;EmBjmDA;IACE,wBAAA;IACA,yBAAA;EnBmmDF;EmBrmDA;IACE,aAAA;IACA,cAAA;EnBumDF;EmBzmDA;IACE,aAAA;IACA,cAAA;EnB2mDF;EmB7mDA;IACE,wBAAA;IACA,yBAAA;EnB+mDF;EqBloDI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EnBooDA;EqBjoDQ;IFbR,qBAAA;IAIA,sBAAA;EnB8oDA;EqBroDQ;IFbR,sBAAA;IAIA,uBAAA;EnBkpDA;EqBzoDQ;IFbR,aAAA;IAIA,cAAA;EnBspDA;EqB7oDQ;IFbR,sBAAA;IAIA,uBAAA;EnB0pDA;EqBjpDQ;IFbR,sBAAA;IAIA,uBAAA;EnB8pDA;EqBrpDQ;IFbR,aAAA;IAIA,cAAA;EnBkqDA;EqBzpDQ;IFbR,sBAAA;IAIA,uBAAA;EnBsqDA;EqB7pDQ;IFbR,sBAAA;IAIA,uBAAA;EnB0qDA;EqBjqDQ;IFbR,aAAA;IAIA,cAAA;EnB8qDA;EqBrqDQ;IFbR,sBAAA;IAIA,uBAAA;EnBkrDA;EqBzqDQ;IFbR,sBAAA;IAIA,uBAAA;EnBsrDA;EqB7qDQ;IFbR,cAAA;IAIA,eAAA;EnB0rDA;EqB3qDI;IAAwB,SAAA;ErB8qD5B;EqB5qDI;IAAuB,SAAA;ErB+qD3B;EqB5qDM;IAAwB,QADb;ErBgrDjB;EqB/qDM;IAAwB,QADb;ErBmrDjB;EqBlrDM;IAAwB,QADb;ErBsrDjB;EqBrrDM;IAAwB,QADb;ErByrDjB;EqBxrDM;IAAwB,QADb;ErB4rDjB;EqB3rDM;IAAwB,QADb;ErB+rDjB;EqB9rDM;IAAwB,QADb;ErBksDjB;EqBjsDM;IAAwB,QADb;ErBqsDjB;EqBpsDM;IAAwB,QADb;ErBwsDjB;EqBvsDM;IAAwB,QADb;ErB2sDjB;EqB1sDM;IAAwB,SADb;ErB8sDjB;EqB7sDM;IAAwB,SADb;ErBitDjB;EqBhtDM;IAAwB,SADb;ErBotDjB;EqB5sDU;IFhBV,cAAA;EnB+tDA;EqB/sDU;IFhBV,wBAAA;EnBkuDA;EqBltDU;IFhBV,yBAAA;EnBquDA;EqBrtDU;IFhBV,gBAAA;EnBwuDA;EqBxtDU;IFhBV,yBAAA;EnB2uDA;EqB3tDU;IFhBV,yBAAA;EnB8uDA;EqB9tDU;IFhBV,gBAAA;EnBivDA;EqBjuDU;IFhBV,yBAAA;EnBovDA;EqBpuDU;IFhBV,yBAAA;EnBuvDA;EqBvuDU;IFhBV,gBAAA;EnB0vDA;EqB1uDU;IFhBV,yBAAA;EnB6vDA;EqB7uDU;IFhBV,yBAAA;EnBgwDA;AACF;AoB5vDI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ErB0xDN;EmB9vDA;IACE,cAAA;IACA,eAAA;EnBgwDF;EmBlwDA;IACE,aAAA;IACA,cAAA;EnBowDF;EmBtwDA;IACE,wBAAA;IACA,yBAAA;EnBwwDF;EmB1wDA;IACE,aAAA;IACA,cAAA;EnB4wDF;EmB9wDA;IACE,aAAA;IACA,cAAA;EnBgxDF;EmBlxDA;IACE,wBAAA;IACA,yBAAA;EnBoxDF;EqBvyDI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EnByyDA;EqBtyDQ;IFbR,qBAAA;IAIA,sBAAA;EnBmzDA;EqB1yDQ;IFbR,sBAAA;IAIA,uBAAA;EnBuzDA;EqB9yDQ;IFbR,aAAA;IAIA,cAAA;EnB2zDA;EqBlzDQ;IFbR,sBAAA;IAIA,uBAAA;EnB+zDA;EqBtzDQ;IFbR,sBAAA;IAIA,uBAAA;EnBm0DA;EqB1zDQ;IFbR,aAAA;IAIA,cAAA;EnBu0DA;EqB9zDQ;IFbR,sBAAA;IAIA,uBAAA;EnB20DA;EqBl0DQ;IFbR,sBAAA;IAIA,uBAAA;EnB+0DA;EqBt0DQ;IFbR,aAAA;IAIA,cAAA;EnBm1DA;EqB10DQ;IFbR,sBAAA;IAIA,uBAAA;EnBu1DA;EqB90DQ;IFbR,sBAAA;IAIA,uBAAA;EnB21DA;EqBl1DQ;IFbR,cAAA;IAIA,eAAA;EnB+1DA;EqBh1DI;IAAwB,SAAA;ErBm1D5B;EqBj1DI;IAAuB,SAAA;ErBo1D3B;EqBj1DM;IAAwB,QADb;ErBq1DjB;EqBp1DM;IAAwB,QADb;ErBw1DjB;EqBv1DM;IAAwB,QADb;ErB21DjB;EqB11DM;IAAwB,QADb;ErB81DjB;EqB71DM;IAAwB,QADb;ErBi2DjB;EqBh2DM;IAAwB,QADb;ErBo2DjB;EqBn2DM;IAAwB,QADb;ErBu2DjB;EqBt2DM;IAAwB,QADb;ErB02DjB;EqBz2DM;IAAwB,QADb;ErB62DjB;EqB52DM;IAAwB,QADb;ErBg3DjB;EqB/2DM;IAAwB,SADb;ErBm3DjB;EqBl3DM;IAAwB,SADb;ErBs3DjB;EqBr3DM;IAAwB,SADb;ErBy3DjB;EqBj3DU;IFhBV,cAAA;EnBo4DA;EqBp3DU;IFhBV,wBAAA;EnBu4DA;EqBv3DU;IFhBV,yBAAA;EnB04DA;EqB13DU;IFhBV,gBAAA;EnB64DA;EqB73DU;IFhBV,yBAAA;EnBg5DA;EqBh4DU;IFhBV,yBAAA;EnBm5DA;EqBn4DU;IFhBV,gBAAA;EnBs5DA;EqBt4DU;IFhBV,yBAAA;EnBy5DA;EqBz4DU;IFhBV,yBAAA;EnB45DA;EqB54DU;IFhBV,gBAAA;EnB+5DA;EqB/4DU;IFhBV,yBAAA;EnBk6DA;EqBl5DU;IFhBV,yBAAA;EnBq6DA;AACF;AoBj6DI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ErB+7DN;EmBn6DA;IACE,cAAA;IACA,eAAA;EnBq6DF;EmBv6DA;IACE,aAAA;IACA,cAAA;EnBy6DF;EmB36DA;IACE,wBAAA;IACA,yBAAA;EnB66DF;EmB/6DA;IACE,aAAA;IACA,cAAA;EnBi7DF;EmBn7DA;IACE,aAAA;IACA,cAAA;EnBq7DF;EmBv7DA;IACE,wBAAA;IACA,yBAAA;EnBy7DF;EqB58DI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EnB88DA;EqB38DQ;IFbR,qBAAA;IAIA,sBAAA;EnBw9DA;EqB/8DQ;IFbR,sBAAA;IAIA,uBAAA;EnB49DA;EqBn9DQ;IFbR,aAAA;IAIA,cAAA;EnBg+DA;EqBv9DQ;IFbR,sBAAA;IAIA,uBAAA;EnBo+DA;EqB39DQ;IFbR,sBAAA;IAIA,uBAAA;EnBw+DA;EqB/9DQ;IFbR,aAAA;IAIA,cAAA;EnB4+DA;EqBn+DQ;IFbR,sBAAA;IAIA,uBAAA;EnBg/DA;EqBv+DQ;IFbR,sBAAA;IAIA,uBAAA;EnBo/DA;EqB3+DQ;IFbR,aAAA;IAIA,cAAA;EnBw/DA;EqB/+DQ;IFbR,sBAAA;IAIA,uBAAA;EnB4/DA;EqBn/DQ;IFbR,sBAAA;IAIA,uBAAA;EnBggEA;EqBv/DQ;IFbR,cAAA;IAIA,eAAA;EnBogEA;EqBr/DI;IAAwB,SAAA;ErBw/D5B;EqBt/DI;IAAuB,SAAA;ErBy/D3B;EqBt/DM;IAAwB,QADb;ErB0/DjB;EqBz/DM;IAAwB,QADb;ErB6/DjB;EqB5/DM;IAAwB,QADb;ErBggEjB;EqB//DM;IAAwB,QADb;ErBmgEjB;EqBlgEM;IAAwB,QADb;ErBsgEjB;EqBrgEM;IAAwB,QADb;ErBygEjB;EqBxgEM;IAAwB,QADb;ErB4gEjB;EqB3gEM;IAAwB,QADb;ErB+gEjB;EqB9gEM;IAAwB,QADb;ErBkhEjB;EqBjhEM;IAAwB,QADb;ErBqhEjB;EqBphEM;IAAwB,SADb;ErBwhEjB;EqBvhEM;IAAwB,SADb;ErB2hEjB;EqB1hEM;IAAwB,SADb;ErB8hEjB;EqBthEU;IFhBV,cAAA;EnByiEA;EqBzhEU;IFhBV,wBAAA;EnB4iEA;EqB5hEU;IFhBV,yBAAA;EnB+iEA;EqB/hEU;IFhBV,gBAAA;EnBkjEA;EqBliEU;IFhBV,yBAAA;EnBqjEA;EqBriEU;IFhBV,yBAAA;EnBwjEA;EqBxiEU;IFhBV,gBAAA;EnB2jEA;EqB3iEU;IFhBV,yBAAA;EnB8jEA;EqB9iEU;IFhBV,yBAAA;EnBikEA;EqBjjEU;IFhBV,gBAAA;EnBokEA;EqBpjEU;IFhBV,yBAAA;EnBukEA;EqBvjEU;IFhBV,yBAAA;EnB0kEA;AACF;AoBtkEI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ErBomEN;EmBxkEA;IACE,cAAA;IACA,eAAA;EnB0kEF;EmB5kEA;IACE,aAAA;IACA,cAAA;EnB8kEF;EmBhlEA;IACE,wBAAA;IACA,yBAAA;EnBklEF;EmBplEA;IACE,aAAA;IACA,cAAA;EnBslEF;EmBxlEA;IACE,aAAA;IACA,cAAA;EnB0lEF;EmB5lEA;IACE,wBAAA;IACA,yBAAA;EnB8lEF;EqBjnEI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EnBmnEA;EqBhnEQ;IFbR,qBAAA;IAIA,sBAAA;EnB6nEA;EqBpnEQ;IFbR,sBAAA;IAIA,uBAAA;EnBioEA;EqBxnEQ;IFbR,aAAA;IAIA,cAAA;EnBqoEA;EqB5nEQ;IFbR,sBAAA;IAIA,uBAAA;EnByoEA;EqBhoEQ;IFbR,sBAAA;IAIA,uBAAA;EnB6oEA;EqBpoEQ;IFbR,aAAA;IAIA,cAAA;EnBipEA;EqBxoEQ;IFbR,sBAAA;IAIA,uBAAA;EnBqpEA;EqB5oEQ;IFbR,sBAAA;IAIA,uBAAA;EnBypEA;EqBhpEQ;IFbR,aAAA;IAIA,cAAA;EnB6pEA;EqBppEQ;IFbR,sBAAA;IAIA,uBAAA;EnBiqEA;EqBxpEQ;IFbR,sBAAA;IAIA,uBAAA;EnBqqEA;EqB5pEQ;IFbR,cAAA;IAIA,eAAA;EnByqEA;EqB1pEI;IAAwB,SAAA;ErB6pE5B;EqB3pEI;IAAuB,SAAA;ErB8pE3B;EqB3pEM;IAAwB,QADb;ErB+pEjB;EqB9pEM;IAAwB,QADb;ErBkqEjB;EqBjqEM;IAAwB,QADb;ErBqqEjB;EqBpqEM;IAAwB,QADb;ErBwqEjB;EqBvqEM;IAAwB,QADb;ErB2qEjB;EqB1qEM;IAAwB,QADb;ErB8qEjB;EqB7qEM;IAAwB,QADb;ErBirEjB;EqBhrEM;IAAwB,QADb;ErBorEjB;EqBnrEM;IAAwB,QADb;ErBurEjB;EqBtrEM;IAAwB,QADb;ErB0rEjB;EqBzrEM;IAAwB,SADb;ErB6rEjB;EqB5rEM;IAAwB,SADb;ErBgsEjB;EqB/rEM;IAAwB,SADb;ErBmsEjB;EqB3rEU;IFhBV,cAAA;EnB8sEA;EqB9rEU;IFhBV,wBAAA;EnBitEA;EqBjsEU;IFhBV,yBAAA;EnBotEA;EqBpsEU;IFhBV,gBAAA;EnButEA;EqBvsEU;IFhBV,yBAAA;EnB0tEA;EqB1sEU;IFhBV,yBAAA;EnB6tEA;EqB7sEU;IFhBV,gBAAA;EnBguEA;EqBhtEU;IFhBV,yBAAA;EnBmuEA;EqBntEU;IFhBV,yBAAA;EnBsuEA;EqBttEU;IFhBV,gBAAA;EnByuEA;EqBztEU;IFhBV,yBAAA;EnB4uEA;EqB5tEU;IFhBV,yBAAA;EnB+uEA;AACF;AsBnyEA;EACE,WAAA;EACA,mBbiIO;EahIP,cbSS;AT4xEX;AsBlyEE;;EAEE,gBbmV0B;EalV1B,mBAAA;EACA,6BAAA;AtBoyEJ;AsBjyEE;EACE,sBAAA;EACA,gCAAA;AtBmyEJ;AsBhyEE;EACE,6BAAA;AtBkyEJ;;AsBxxEE;;EAEE,eb6T0B;AT89D9B;;AsBlxEA;EACE,yBAAA;AtBqxEF;AsBnxEE;;EAEE,yBAAA;AtBqxEJ;AsBjxEI;;EAEE,wBAAA;AtBmxEN;;AsB7wEE;;;;EAIE,SAAA;AtBgxEJ;;AsBvwEE;EACE,qCbyR0B;ATi/D9B;;AWz0EE;EW2EI,cbvEK;EawEL,sCb8QwB;ATo/D9B;;AuBp1EI;;;EAGE,yCD2F+B;AtB4vErC;AuBn1EM;;;;EAIE,qCDmFyE;AtBkwEjF;;AW11EE;EYiBM,qEAJe;AvBi1EvB;AuB30EQ;;EAEE,qEARa;AvBq1EvB;;AuBx2EI;;;EAGE,4CD2F+B;AtBgxErC;AuBv2EM;;;;EAIE,wCDmFyE;AtBsxEjF;;AW92EE;EYiBM,qEAJe;AvBq2EvB;AuB/1EQ;;EAEE,qEARa;AvBy2EvB;;AuB53EI;;;EAGE,2CD2F+B;AtBoyErC;AuB33EM;;;;EAIE,uCDmFyE;AtB0yEjF;;AWl4EE;EYiBM,qEAJe;AvBy3EvB;AuBn3EQ;;EAEE,qEARa;AvB63EvB;;AuBh5EI;;;EAGE,6CD2F+B;AtBwzErC;AuB/4EM;;;;EAIE,yCDmFyE;AtB8zEjF;;AWt5EE;EYiBM,qEAJe;AvB64EvB;AuBv4EQ;;EAEE,qEARa;AvBi5EvB;;AuBp6EI;;;EAGE,0CD2F+B;AtB40ErC;AuBn6EM;;;;EAIE,sCDmFyE;AtBk1EjF;;AW16EE;EYiBM,2CAJe;AvBi6EvB;AuB35EQ;;EAEE,2CARa;AvBq6EvB;;AuBx7EI;;;EAGE,4CD2F+B;AtBg2ErC;AuBv7EM;;;;EAIE,wCDmFyE;AtBs2EjF;;AW97EE;EYiBM,qEAJe;AvBq7EvB;AuB/6EQ;;EAEE,qEARa;AvBy7EvB;;AuB58EI;;;EAGE,4CD2F+B;AtBo3ErC;AuB38EM;;;;EAIE,wCDmFyE;AtB03EjF;;AWl9EE;EYiBM,+CAJe;AvBy8EvB;AuBn8EQ;;EAEE,+CARa;AvB68EvB;;AuBh+EI;;;EAGE,6CD2F+B;AtBw4ErC;AuB/9EM;;;;EAIE,yCDmFyE;AtB84EjF;;AWt+EE;EYiBM,6DAJe;AvB69EvB;AuBv9EQ;;EAEE,6DARa;AvBi+EvB;;AuBp/EI;;;EAGE,sCd6VwB;AT0pE9B;;AWp/EE;EYiBM,sCAJe;AvB2+EvB;AuBr+EQ;;EAEE,sCARa;AvB++EvB;;AsBv5EI;EACE,WpB1GE;EoB2GF,yBbpGK;EaqGL,uDbiQwB;ATypE9B;AsBr5EI;EACE,cb5GK;Ea6GL,yBblHK;EamHL,qBblHK;ATygFX;;AsBl5EA;EACE,WpB1HM;EoB2HN,yBbpHS;ATygFX;AsBn5EE;;;EAGE,uDb6O0B;ATwqE9B;AsBl5EE;EACE,SAAA;AtBo5EJ;AsBh5EI;EACE,2CbiOwB;ATirE9B;AWvhFE;EW4IM,WpBhJA;EoBiJA,4Cb2NsB;ATmrE9B;;AoB99EI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EtBg4EN;EsB73EM;IACE,SAAA;EtB+3ER;AACF;AoB1+EI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EtB24EN;EsBx4EM;IACE,SAAA;EtB04ER;AACF;AoBr/EI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EtBs5EN;EsBn5EM;IACE,SAAA;EtBq5ER;AACF;AoBhgFI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EtBi6EN;EsB95EM;IACE,SAAA;EtBg6ER;AACF;AsB16EI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AtB26ER;AsBx6EQ;EACE,SAAA;AtB06EV;;AwBvlFA;EACE,cAAA;EACA,WAAA;EACA,mCf2esC;Ee1etC,yBAAA;Ed0KI,eAAA;EcvKJ,gBfmR4B;EelR5B,gBfuR4B;EetR5B,cfDS;EeET,sBtBRM;EsBSN,4BAAA;EACA,yBAAA;ERAE,sBAAA;ESFE,wEDQJ;AxBqlFF;AyBzlFM;EDdN;ICeQ,gBAAA;EzB4lFN;AACF;AwBvlFE;EACE,6BAAA;EACA,SAAA;AxBylFJ;A0BzmFE;EACE,cAAA;EACA,sBxBPI;EwBQJ,iEjBsdoC;EiBrdpC,UAAA;EAKE,iDjBqXwB;ATkvE9B;AwBzlFE;EACE,cfxBO;Ee0BP,UAAA;AxB0lFJ;AwBllFE;EAEE,yBfxCO;Ee0CP,UAAA;AxBklFJ;;AwB1kFE;;;;EACE,gBAAA;AxBglFJ;;AwB1kFE;EACE,kBAAA;EACA,0BAAA;AxB6kFJ;AwB1kFE;EAME,cf/DO;EegEP,sBtBtEI;AF6oFR;;AwBlkFA;;EAEE,cAAA;EACA,WAAA;AxBqkFF;;AwB3jFA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EdiEE,kBAAA;Ec/DF,gBfgM4B;AT83E9B;;AwB3jFA;EACE,+BAAA;EACA,kCAAA;Ed0EI,kBAAA;EcxEJ,gBf6H4B;ATi8E9B;;AwB3jFA;EACE,gCAAA;EACA,mCAAA;EdmEI,mBAAA;EcjEJ,gBfuH4B;ATu8E9B;;AwBrjFA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EdoDI,eAAA;EclDJ,gBfmK4B;EelK5B,cfnHS;EeoHT,6BAAA;EACA,yBAAA;EACA,mBAAA;AxBwjFF;AwBtjFE;EAEE,gBAAA;EACA,eAAA;AxBujFJ;;AwB3iFA;EACE,kCf6VsC;Ee5VtC,uBAAA;Ed2BI,mBAAA;EczBJ,gBf+E4B;EOxN1B,qBAAA;AhBwrFJ;;AwB3iFA;EACE,gCfsVsC;EerVtC,oBAAA;EdmBI,kBAAA;EcjBJ,gBfsE4B;EOvN1B,qBAAA;AhBgsFJ;;AwBziFE;EAEE,YAAA;AxB2iFJ;;AwBviFA;EACE,YAAA;AxB0iFF;;AwBliFA;EACE,mBf2UsC;AT0tExC;;AwBliFA;EACE,cAAA;EACA,mBf4TsC;ATyuExC;;AwB7hFA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AxBgiFF;AwB9hFE;;EAEE,kBAAA;EACA,iBAAA;AxBgiFJ;;AwBvhFA;EACE,kBAAA;EACA,cAAA;EACA,qBfiSsC;ATyvExC;;AwBvhFA;EACE,kBAAA;EACA,kBf6RsC;Ee5RtC,qBAAA;AxB0hFF;AwBvhFE;EAEE,cfzNO;ATivFX;;AwBphFA;EACE,gBAAA;AxBuhFF;;AwBphFA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf8QsC;ATywExC;AwBphFE;EACE,gBAAA;EACA,aAAA;EACA,uBfyQoC;EexQpC,cAAA;AxBshFJ;;A0BnuFE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;ECtVpC,kBAAA;EgBnHA,cFqNqC;AxBihFzC;;A0BnuFE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,mBAAA;EgBtHF,gBjBuO0B;EiBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;AhBqxFJ;A0BluFI;EAEE,SAAA;A1BmuFN;;A0B9tFI;;;;EAEE,cAAA;A1BmuFN;;A0BjxFI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A1B+tFR;A0B5tFM;EACE,qBFuKiC;EEtKjC,gDAAA;A1B8tFR;;A0B9xFI;EAyEI,8BAAA;EACA,wCAAA;A1BytFR;;A0BnyFI;EAmFI,oCjB6XgC;EiB5XhC,kFAAA;A1BotFR;;A0BxyFI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,wNAAA;A1B+sFR;A0B5sFM;EACE,qBFmIiC;EElIjC,gDAAA;A1B8sFR;;A0BvsFM;EACE,cF0HiC;AxBglFzC;A0BvsFM;;;EAEE,cAAA;A1B0sFR;;A0BnsFM;EACE,cF6GiC;AxBylFzC;A0BpsFQ;EACE,qBF0G+B;AxB4lFzC;A0BjsFQ;EACE,sCAAA;EC5JN,0CD6J2B;A1BmsF/B;A0B9rFQ;EACE,gDAAA;A1BgsFV;A0B7rFQ;EACE,qBFyF+B;AxBsmFzC;;A0BtrFM;EACE,qBF+EiC;AxB0mFzC;A0BrrFQ;EACE,qBF0E+B;EEzE/B,gDAAA;A1BurFV;;A0Bx0FE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;ECtVpC,kBAAA;EgBnHA,cFqNqC;AxBsnFzC;;A0Bx0FE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,mBAAA;EgBtHF,gBjBuO0B;EiBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;AhB03FJ;A0Bv0FI;EAEE,SAAA;A1Bw0FN;;A0Bn0FI;;;;EAEE,cAAA;A1Bw0FN;;A0Bt3FI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A1Bo0FR;A0Bj0FM;EACE,qBFuKiC;EEtKjC,gDAAA;A1Bm0FR;;A0Bn4FI;EAyEI,8BAAA;EACA,wCAAA;A1B8zFR;;A0Bx4FI;EAmFI,oCjB6XgC;EiB5XhC,kFAAA;A1ByzFR;;A0B74FI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,wNAAA;A1BozFR;A0BjzFM;EACE,qBFmIiC;EElIjC,gDAAA;A1BmzFR;;A0B5yFM;EACE,cF0HiC;AxBqrFzC;A0B5yFM;;;EAEE,cAAA;A1B+yFR;;A0BxyFM;EACE,cF6GiC;AxB8rFzC;A0BzyFQ;EACE,qBF0G+B;AxBisFzC;A0BtyFQ;EACE,gEAAA;EC5JN,oED6J2B;A1BwyF/B;A0BnyFQ;EACE,gDAAA;A1BqyFV;A0BlyFQ;EACE,qBFyF+B;AxB2sFzC;;A0B3xFM;EACE,qBF+EiC;AxB+sFzC;A0B1xFQ;EACE,qBF0E+B;EEzE/B,gDAAA;A1B4xFV;;AwBvsFA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AxB0sFF;AwBrsFE;EACE,WAAA;AxBusFJ;AoBt6FI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;ExBqsFJ;EwBjsFE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;ExBmsFJ;EwB/rFE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;ExBisFJ;EwB7rFE;IACE,qBAAA;ExB+rFJ;EwB5rFE;;IAEE,WAAA;ExB8rFJ;EwBzrFE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;ExB2rFJ;EwBzrFE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBfgLkC;Ie/KlC,cAAA;ExB2rFJ;EwBxrFE;IACE,mBAAA;IACA,uBAAA;ExB0rFJ;EwBxrFE;IACE,gBAAA;ExB0rFJ;AACF;;A4B5gGA;EACE,qBAAA;EAEA,gBnBuR4B;EmBtR5B,cnBMS;EmBLT,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,yBAAA;EnB4EI,eAAA;EmB1EJ,gBpB2L4B;EOnR1B,sBAAA;ESFE,qIGGJ;A5B+gGF;AyB9gGM;EGdN;IHeQ,gBAAA;EzBihGN;AACF;AW3hGE;EiBUE,cnBNO;EmBOP,qBAAA;A5BohGJ;A4BjhGE;EAEE,UAAA;EACA,iDnB8W0B;AToqF9B;A4B9gGE;EAEE,anBkZ0B;AT6nF9B;A4B3gGE;EACE,eAAA;A5B6gGJ;A4B//FA;;EAEE,oBAAA;A5BigGF;;A4Bx/FE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ATm/Ff;AWnjGE;EkBAE,WAAA;EFNA,oEED2D;EAS3D,gEATqG;A7B+jGzG;A6BnjGE;EAEE,WAAA;EFbA,oEED2D;EAgB3D,gEAhBqG;EAqBnG,oDAAA;A7BgjGN;A6B3iGE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ATmgGf;A6BriGE;EAGE,WAAA;EACA,oEAzC+I;EA6C/I,oCA7CyL;A7B+kG7L;A6BhiGI;EAKI,oDAAA;A7B8hGR;;A4BthGE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ATihGf;AWjlGE;EkBAE,WAAA;EFNA,mEED2D;EAS3D,8DATqG;A7B6lGzG;A6BjlGE;EAEE,WAAA;EFbA,mEED2D;EAgB3D,8DAhBqG;EAqBnG,wDAAA;A7B8kGN;A6BzkGE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ATiiGf;A6BnkGE;EAGE,WAAA;EACA,kEAzC+I;EA6C/I,8DA7CyL;A7B6mG7L;A6B9jGI;EAKI,wDAAA;A7B4jGR;;A4BpjGE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AT+iGf;AW/mGE;EkBAE,WAAA;EFNA,0CED2D;EAS3D,mCATqG;A7B2nGzG;A6B/mGE;EAEE,WAAA;EFbA,0CED2D;EAgB3D,mCAhBqG;EAqBnG,wDAAA;A7B4mGN;A6BvmGE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AT+jGf;A6BjmGE;EAGE,WAAA;EACA,uCAzC+I;EA6C/I,qCA7CyL;A7B2oG7L;A6B5lGI;EAKI,wDAAA;A7B0lGR;;A4BllGE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AT6kGf;AW7oGE;EkBAE,WAAA;EFNA,iDED2D;EAS3D,gEATqG;A7BypGzG;A6B7oGE;EAEE,WAAA;EFbA,iDED2D;EAgB3D,gEAhBqG;EAqBnG,wDAAA;A7B0oGN;A6BroGE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AT6lGf;A6B/nGE;EAGE,WAAA;EACA,oEAzC+I;EA6C/I,gEA7CyL;A7ByqG7L;A6B1nGI;EAKI,wDAAA;A7BwnGR;;A4BhnGE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AT2mGf;AW3qGE;EkBAE,cAAA;EFNA,0CED2D;EAS3D,iCATqG;A7BurGzG;A6B3qGE;EAEE,cAAA;EFbA,0CED2D;EAgB3D,iCAhBqG;EAqBnG,sDAAA;A7BwqGN;A6BnqGE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AT2nGf;A6B7pGE;EAGE,cAAA;EACA,qCAzC+I;EA6C/I,sCA7CyL;A7BusG7L;A6BxpGI;EAKI,sDAAA;A7BspGR;;A4B9oGE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ATyoGf;AWzsGE;EkBAE,WAAA;EFNA,iEED2D;EAS3D,+DATqG;A7BqtGzG;A6BzsGE;EAEE,WAAA;EFbA,iEED2D;EAgB3D,+DAhBqG;EAqBnG,sDAAA;A7BssGN;A6BjsGE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ATypGf;A6B3rGE;EAGE,WAAA;EACA,mEAzC+I;EA6C/I,+DA7CyL;A7BquG7L;A6BtrGI;EAKI,sDAAA;A7BorGR;;A4B5qGE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ATuqGf;AWvuGE;EkBAE,cAAA;EFNA,kDED2D;EAS3D,wCATqG;A7BmvGzG;A6BvuGE;EAEE,cAAA;EFbA,kDED2D;EAgB3D,wCAhBqG;EAqBnG,yDAAA;A7BouGN;A6B/tGE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ATurGf;A6BztGE;EAGE,cAAA;EACA,4CAzC+I;EA6C/I,8CA7CyL;A7BmwG7L;A6BptGI;EAKI,yDAAA;A7BktGR;;A4B1sGE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ATqsGf;AWrwGE;EkBAE,WAAA;EFNA,2DED2D;EAS3D,qDATqG;A7BixGzG;A6BrwGE;EAEE,WAAA;EFbA,2DED2D;EAgB3D,qDAhBqG;EAqBnG,uDAAA;A7BkwGN;A6B7vGE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ATqtGf;A6BvvGE;EAGE,WAAA;EACA,yDAzC+I;EA6C/I,uDA7CyL;A7BiyG7L;A6BlvGI;EAKI,uDAAA;A7BgvGR;;A4BluGE;ECPA,cpBYa;EoBXb,qBpBWa;ATkuGf;AWlyGE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ATuuGf;A6B1uGE;EAEE,gDAAA;A7B2uGJ;A6BxuGE;EAEE,cpBJW;EoBKX,6BAAA;A7ByuGJ;A6BtuGE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ATmvGf;A6BpuGI;EAKI,gDAAA;A7BkuGR;;A4B3vGE;ECPA,cpBYa;EoBXb,qBpBWa;AT2vGf;AW3zGE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ATgwGf;A6BnwGE;EAEE,iDAAA;A7BowGJ;A6BjwGE;EAEE,cpBJW;EoBKX,6BAAA;A7BkwGJ;A6B/vGE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AT4wGf;A6B7vGI;EAKI,iDAAA;A7B2vGR;;A4BpxGE;ECPA,cpBYa;EoBXb,qBpBWa;AToxGf;AWp1GE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ATyxGf;A6B5xGE;EAEE,+CAAA;A7B6xGJ;A6B1xGE;EAEE,cpBJW;EoBKX,6BAAA;A7B2xGJ;A6BxxGE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ATqyGf;A6BtxGI;EAKI,+CAAA;A7BoxGR;;A4B7yGE;ECPA,cpBYa;EoBXb,qBpBWa;AT6yGf;AW72GE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ATkzGf;A6BrzGE;EAEE,gDAAA;A7BszGJ;A6BnzGE;EAEE,cpBJW;EoBKX,6BAAA;A7BozGJ;A6BjzGE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AT8zGf;A6B/yGI;EAKI,gDAAA;A7B6yGR;;A4Bt0GE;ECPA,cpBYa;EoBXb,qBpBWa;ATs0Gf;AWt4GE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AT20Gf;A6B90GE;EAEE,+CAAA;A7B+0GJ;A6B50GE;EAEE,cpBJW;EoBKX,6BAAA;A7B60GJ;A6B10GE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ATu1Gf;A6Bx0GI;EAKI,+CAAA;A7Bs0GR;;A4B/1GE;ECPA,cpBYa;EoBXb,qBpBWa;AT+1Gf;AW/5GE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ATo2Gf;A6Bv2GE;EAEE,+CAAA;A7Bw2GJ;A6Br2GE;EAEE,cpBJW;EoBKX,6BAAA;A7Bs2GJ;A6Bn2GE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ATg3Gf;A6Bj2GI;EAKI,+CAAA;A7B+1GR;;A4Bx3GE;ECPA,cpBYa;EoBXb,qBpBWa;ATw3Gf;AWx7GE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AT63Gf;A6Bh4GE;EAEE,iDAAA;A7Bi4GJ;A6B93GE;EAEE,cpBJW;EoBKX,6BAAA;A7B+3GJ;A6B53GE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ATy4Gf;A6B13GI;EAKI,iDAAA;A7Bw3GR;;A4Bj5GE;ECPA,cpBYa;EoBXb,qBpBWa;ATi5Gf;AWj9GE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ATs5Gf;A6Bz5GE;EAEE,8CAAA;A7B05GJ;A6Bv5GE;EAEE,cpBJW;EoBKX,6BAAA;A7Bw5GJ;A6Br5GE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ATk6Gf;A6Bn5GI;EAKI,8CAAA;A7Bi5GR;;A4B/5GA;EACE,gBnB6M4B;EmB5M5B,cnB2FwC;EmB1FxC,qBnB2FwC;ATu0G1C;AW3+GE;EiB4EE,wDnByFsC;EmBxFtC,0BnByFsC;ATy0G1C;A4B/5GE;EAEE,0BnBoFsC;AT40G1C;A4B75GE;EAEE,cnBtFO;EmBuFP,oBAAA;A5B85GJ;;A4Bn5GA;ECPE,oBAAA;EnB4EI,kBAAA;EmB1EJ,gBpB+H4B;EOvN1B,qBAAA;AhBu/GJ;;A4Bt5GA;ECXE,uBAAA;EnB4EI,mBAAA;EmB1EJ,gBpBgI4B;EOxN1B,qBAAA;AhB8/GJ;;A4Bp5GA;EACE,cAAA;EACA,WAAA;A5Bu5GF;A4Bp5GE;EACE,kBnBwT0B;AT8lG9B;;A4B94GE;;;EACE,WAAA;A5Bm5GJ;;A8B9hHA;ELgBM,gCKfJ;A9BiiHF;AyB9gHM;EKpBN;ILqBQ,gBAAA;EzBihHN;AACF;A8BpiHE;EACE,UAAA;A9BsiHJ;;A8BjiHE;EACE,aAAA;A9BoiHJ;;A8BhiHA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A9BmiHF;AyBjiHM;EKNN;ILOQ,gBAAA;EzBoiHN;AACF;A8BtiHE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;A9BwiHJ;AyB3iHM;EKAJ;ILCM,gBAAA;EzB8iHN;AACF;;A+BnkHA;;;;EAIE,kBAAA;A/BskHF;;A+BnkHA;EACE,mBAAA;A/BskHF;AgCljHI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AhCqlHF;AgChiHI;EACE,cAAA;AhCkiHN;;A+B5kHA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBypBkC;EsBxpBlC,aAAA;EACA,WAAA;EACA,gBtBiuBkC;EsBhuBlC,iBAAA;EACA,oBAAA;ErB2JI,eAAA;EqBzJJ,ctBXS;EsBYT,gBAAA;EACA,gBAAA;EACA,sB7BtBM;E6BuBN,4BAAA;EACA,qCAAA;EfdE,sBAAA;AhB8lHJ;;A+BvkHI;EACE,WAAA;EACA,OAAA;A/B0kHN;;A+BvkHI;EACE,QAAA;EACA,UAAA;A/B0kHN;;AoB9jHI;EWnBA;IACE,WAAA;IACA,OAAA;E/BqlHJ;E+BllHE;IACE,QAAA;IACA,UAAA;E/BolHJ;AACF;AoBzkHI;EWnBA;IACE,WAAA;IACA,OAAA;E/B+lHJ;E+B5lHE;IACE,QAAA;IACA,UAAA;E/B8lHJ;AACF;AoBnlHI;EWnBA;IACE,WAAA;IACA,OAAA;E/BymHJ;E+BtmHE;IACE,QAAA;IACA,UAAA;E/BwmHJ;AACF;AoB7lHI;EWnBA;IACE,WAAA;IACA,OAAA;E/BmnHJ;E+BhnHE;IACE,QAAA;IACA,UAAA;E/BknHJ;AACF;A+B3mHE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtB+rBgC;AT86FpC;AgC5oHI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AhCwqHF;AgC1nHI;EACE,cAAA;AhC4nHN;;A+BjnHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtBirBgC;ATm8FpC;AgCjqHI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AhCsrHF;AgC/oHI;EACE,cAAA;AhCipHN;A+B5nHI;EACE,iBAAA;A/B8nHN;;A+BxnHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtBgqBgC;AT29FpC;AgCzrHI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;AhC2rHN;AgChrHM;EACE,aAAA;AhCkrHR;AgC/qHM;EACE,qBAAA;EACA,qBvB4MsB;EuB3MtB,uBvB0MsB;EuBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;AhCgtHF;AgC/qHI;EACE,cAAA;AhCirHN;A+B3oHI;EACE,iBAAA;A/B6oHN;;A+BroHE;EAIE,WAAA;EACA,YAAA;A/BqoHJ;;A+BhoHA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AjCkvHF;;A+BhoHA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBtBiK4B;EsBhK5B,ctBhHS;EsBiHT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A/BkoHF;AWvvHE;EoBoIE,+CtBonBgC;EsBnnBhC,qBAAA;EJ/IA,yBlBGO;ATmwHX;A+BnnHE;EAEE,W7BnJI;E6BoJJ,qBAAA;EJtJA,yBlBoP0B;ATuhH9B;A+BjnHE;EAEE,ctBtJO;EsBuJP,oBAAA;EACA,6BAAA;A/BknHJ;;A+B1mHA;EACE,cAAA;A/B6mHF;;A+BzmHA;EACE,cAAA;EACA,sBtBimBkC;EsBhmBlC,gBAAA;ErBAI,mBAAA;EqBEJ,ctBzKS;EsB0KT,mBAAA;A/B4mHF;;A+BxmHA;EACE,cAAA;EACA,uBAAA;EACA,ctB9KS;ATyxHX;;AkCtyHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AlCyyHF;AkCvyHE;;EACE,kBAAA;EACA,cAAA;AlC0yHJ;AWzyHE;;EuBII,UAAA;AlCyyHN;AkCvyHI;;;;EAGE,UAAA;AlC0yHN;;AkCpyHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AlCuyHF;AkCryHE;EACE,WAAA;AlCuyHJ;;AkCjyHE;;EAEE,iBAAA;AlCoyHJ;AkChyHE;;ElBXE,0BAAA;EACA,6BAAA;AhB+yHJ;AkChyHE;;ElBFE,yBAAA;EACA,4BAAA;AhBsyHJ;;AkCnxHA;EACE,wBAAA;EACA,uBAAA;AlCsxHF;AkCpxHE;EAGE,cAAA;AlCoxHJ;AkCjxHE;EACE,eAAA;AlCmxHJ;;AkC/wHA;EACE,uBAAA;EACA,sBAAA;AlCkxHF;;AkC/wHA;EACE,sBAAA;EACA,qBAAA;AlCkxHF;;AkC9vHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AlCiwHF;AkC/vHE;;EAEE,WAAA;AlCiwHJ;AkC9vHE;;EAEE,gBAAA;AlCgwHJ;AkC5vHE;;ElBrFE,6BAAA;EACA,4BAAA;AhBq1HJ;AkC5vHE;;ElBxGE,yBAAA;EACA,0BAAA;AhBw2HJ;;AkC7uHE;;EAEE,gBAAA;AlCgvHJ;AkC9uHI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;AlCkvHN;;AmC34HA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AnC84HF;AmC54HE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AnC84HJ;AmC54HI;;;;;;;;;;;;EAGE,iBAAA;AnCu5HN;AmCl5HE;;;EAGE,UAAA;AnCo5HJ;AmCh5HE;EACE,UAAA;AnCk5HJ;AmC74HI;;EnBIA,yBAAA;EACA,4BAAA;AhB64HJ;AmC74HE;EACE,aAAA;EACA,mBAAA;AnC+4HJ;AmC74HI;EnBnBA,0BAAA;EACA,6BAAA;AhBm6HJ;AmC/4HI;EnBPA,yBAAA;EACA,4BAAA;AhBy5HJ;AmC/4HI;;;;EnBzBA,0BAAA;EACA,6BAAA;AhB86HJ;AmC74HI;;;;EnBlCA,0BAAA;EACA,6BAAA;AhBq7HJ;;AmCp4HA;;EAEE,aAAA;AnCu4HF;AmCl4HE;;EACE,kBAAA;EACA,UAAA;AnCq4HJ;AmCn4HI;;EACE,UAAA;AnCs4HN;AmCl4HE;;;;;;;;EAIE,iBAAA;AnCw4HJ;;AmCp4HA;EAAuB,kBAAA;AnCw4HvB;;AmCv4HA;EAAsB,iBAAA;AnC24HtB;;AmCn4HA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EzB2DI,eAAA;EyBzDJ,gB1BqK4B;E0BpK5B,gB1ByK4B;E0BxK5B,c1B/GS;E0BgHT,kBAAA;EACA,mBAAA;EACA,yB1BvHS;E0BwHT,yBAAA;EnB/GE,sBAAA;AhBs/HJ;AmCn4HE;;EAEE,aAAA;AnCq4HJ;;AmC33HA;;EAEE,gC1BmWsC;AT2hHxC;;AmC33HA;;;;;;EAME,oBAAA;EzBwBI,kBAAA;EyBtBJ,gB1B2E4B;EOvN1B,qBAAA;AhB2gIJ;;AmC33HA;;EAEE,kC1BiVsC;AT6iHxC;;AmC33HA;;;;;;EAME,uBAAA;EzBOI,mBAAA;EyBLJ,gB1B2D4B;EOxN1B,qBAAA;AhB4hIJ;;AmC33HA;;EAEE,sBAAA;AnC83HF;;AmCn3HA;;;;;;;;EnB9JI,0BAAA;EACA,6BAAA;AhB4hIJ;;AmCp3HA;;;;;;EnB3JI,yBAAA;EACA,4BAAA;AhBwhIJ;;AoChkIA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;ApCmkIF;;AoChkIA;EACE,oBAAA;EACA,kB3ByfsC;AT0kHxC;;AoChkIA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W3BqfsC;E2BpftC,eAAA;EACA,UAAA;ApCmkIF;AoCjkIE;EACE,WlCxBI;EkCyBJ,qB3ByN0B;EkBpP1B,yBlBoP0B;AT22H9B;AoC/jIE;EAKI,iD3BgWwB;AT6tH9B;AoCzjIE;EACE,iE3BsboC;ATqoHxC;AoCxjIE;EACE,WlC5CI;EkC6CJ,wC3Bkf4C;E2Bjf5C,oC3Bif4C;ATykHhD;AoCnjII;EACE,c3BjDK;ATsmIX;AoCnjIM;EACE,yB3BxDG;AT6mIX;;AoC3iIA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;ApC6iIF;AoCziIE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W3BwboC;E2BvbpC,Y3BuboC;E2BtbpC,oBAAA;EACA,WAAA;EACA,sBlCpFI;EkCqFJ,yBAAA;ApC2iIJ;AoCtiIE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W3ByaoC;E2BxapC,Y3BwaoC;E2BvapC,WAAA;EACA,iCAAA;ApCwiIJ;;AoC9hIE;EpBlGE,sBAAA;AhBooIJ;AoC7hII;EACE,yDAAA;ApC+hIN;AoC1hII;EACE,qB3B0HwB;EkBpP1B,yBlBoP0B;ATm6H9B;AoCzhII;EACE,yDAAA;ApC2hIN;AoCthII;ETpIA,yClByhB4C;ATooHhD;AoCthII;ETvIA,yClByhB4C;ATuoHhD;;AoC9gIE;EAEE,kB3B0Z4C;ATsnHhD;AoC5gII;EACE,yDAAA;ApC8gIN;AoCzgII;ET9JA,yClByhB4C;ATipHhD;;AoCjgIA;EACE,qBAAA;ApCogIF;AoCjgII;EACE,cAAA;EACA,c3BkY0C;E2BjY1C,mBAAA;EAEA,qB3BgY0C;ATkoHhD;AoC//HI;EACE,wBAAA;EACA,0BAAA;EACA,uB3B2X0C;E2B1X1C,wB3B0X0C;E2BzX1C,yB3BpLK;E2BsLL,qB3BsX0C;EgBxiB1C,yIWmLA;ApCggIN;AyB/qIM;EWuKF;IXtKI,gBAAA;EzBkrIN;AACF;AoChgII;EACE,sBlCjME;EkCkMF,8BAAA;ApCkgIN;AoC7/HI;ETzMA,yClByhB4C;ATgrHhD;;AoCn/HA;EACE,qBAAA;EACA,WAAA;EACA,mC3BqRsC;E2BpRtC,0CAAA;E1B5CI,eAAA;E0B+CJ,gB3B6D4B;E2B5D5B,gB3BiE4B;E2BhE5B,c3BvNS;E2BwNT,sBAAA;EACA,gGAAA;EACA,yBAAA;EpBtNE,sBAAA;EoByNF,gBAAA;ApCo/HF;AoCl/HE;EACE,iE3BwPoC;E2BvPpC,UAAA;EAKE,iD3BmW8B;AT6oHpC;AoC7+HI;EAME,c3B/OK;E2BgPL,sBlCtPE;AFguIR;AoCt+HE;EAEE,YAAA;EACA,sB3B+H0B;E2B9H1B,sBAAA;ApCu+HJ;AoCp+HE;EACE,c3B7PO;E2B8PP,yB3BlQO;ATwuIX;AoCl+HE;EACE,aAAA;ApCo+HJ;AoCh+HE;EACE,kBAAA;EACA,0BAAA;ApCk+HJ;;AoC99HA;EACE,kC3B0NsC;E2BzNtC,oB3BiH4B;E2BhH5B,uB3BgH4B;E2B/G5B,oB3BgH4B;EC1NxB,mBAAA;AV4kIN;;AoC99HA;EACE,gC3BmNsC;E2BlNtC,mB3B8G4B;E2B7G5B,sB3B6G4B;E2B5G5B,kB3B6G4B;EC/NxB,kBAAA;AVolIN;;AoCz9HA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC3BiMsC;E2BhMtC,gBAAA;ApC49HF;;AoCz9HA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC3ByLsC;E2BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;ApC49HF;AoC19HE;EACE,iE3BqKoC;E2BpKpC,iD3ByE0B;ATm5H9B;AoCx9HE;EAEE,yB3B/TO;ATwxIX;AoCr9HI;EACE,iB3B2Ta;AT4pHnB;AoCn9HE;EACE,0BAAA;ApCq9HJ;;AoCj9HA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC3BwJsC;E2BvJtC,yBAAA;EACA,gBAAA;EAEA,gB3BhE4B;E2BiE5B,gB3B5D4B;E2B6D5B,c3BpVS;E2BqVT,sBlC3VM;EkC4VN,yBAAA;EpBlVE,sBAAA;AhBsyIJ;AoCh9HE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B3BiIoC;E2BhIpC,yBAAA;EACA,gB3B5E0B;E2B6E1B,c3BpWO;E2BqWP,iBAAA;ET7WA,yBlBGO;E2B4WP,oBAAA;EpBnWA,kCAAA;AhBszIJ;;AoCx8HA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;ApC28HF;AoCz8HE;EACE,UAAA;ApC28HJ;AoCv8HI;EAA0B,iE3BoOe;ATsuH7C;AoCz8HI;EAA0B,iE3BmOe;ATyuH7C;AoC38HI;EAA0B,iE3BkOe;AT4uH7C;AoC38HE;EACE,SAAA;ApC68HJ;AoC18HE;EACE,W3BoNyC;E2BnNzC,Y3BmNyC;E2BlNzC,oBAAA;ETlZA,yBlBoP0B;E2BgK1B,S3BmNyC;EO3lBzC,mBAAA;ESFE,oHW6YF;EX7YE,4GW6YF;ApC28HJ;AyBp1IM;EWiYJ;IXhYM,wBAAA;IAAA,gBAAA;EzBu1IN;AACF;AoCx9HE;EASE,gBAAA;ApCk9HJ;AoCh9HI;ET1ZA,wClB4mByC;ATiwH7C;AoC98HE;EACE,W3B6LgC;E2B5LhC,c3B6LgC;E2B5LhC,kBAAA;EACA,e3B4LgC;E2B3LhC,yB3BhaO;E2BiaP,yBAAA;EpBzZA,mBAAA;AhB02IJ;AoC58HE;EACE,W3ByLyC;E2BxLzC,Y3BwLyC;EkBpmBzC,yBlBoP0B;E2B0L1B,S3ByLyC;EO3lBzC,mBAAA;ESFE,iHWuaF;EXvaE,4GWuaF;ApC68HJ;AyBh3IM;EW4ZJ;IX3ZM,qBAAA;IAAA,gBAAA;EzBm3IN;AACF;AoCz9HE;EAQE,gBAAA;ApCo9HJ;AoCl9HI;ETpbA,wClB4mByC;AT6xH7C;AoCh9HE;EACE,W3BmKgC;E2BlKhC,c3BmKgC;E2BlKhC,kBAAA;EACA,e3BkKgC;E2BjKhC,yB3B1bO;E2B2bP,yBAAA;EpBnbA,mBAAA;AhBs4IJ;AoC98HE;EACE,W3B+JyC;E2B9JzC,Y3B8JyC;E2B7JzC,aAAA;EACA,oB3BrE0B;E2BsE1B,mB3BtE0B;EkBnY1B,yBlBoP0B;E2BuN1B,S3B4JyC;EO3lBzC,mBAAA;ESFE,gHWocF;EXpcE,4GWocF;ApC+8HJ;AyB/4IM;EWsbJ;IXrbM,oBAAA;IAAA,gBAAA;EzBk5IN;AACF;AoC99HE;EAWE,gBAAA;ApCs9HJ;AoCp9HI;ETjdA,wClB4mByC;AT4zH7C;AoCl9HE;EACE,W3BsIgC;E2BrIhC,c3BsIgC;E2BrIhC,kBAAA;EACA,e3BqIgC;E2BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;ApCo9HJ;AoCh9HE;EACE,yB3B9dO;EOQP,mBAAA;AhBy6IJ;AoC/8HE;EACE,kBAAA;EACA,yB3BpeO;EOQP,mBAAA;AhB86IJ;AoC78HI;EACE,yB3BxeK;ATu7IX;AoC58HI;EACE,eAAA;ApC88HN;AoC38HI;EACE,yB3BhfK;AT67IX;AoC18HI;EACE,eAAA;ApC48HN;AoCz8HI;EACE,yB3BxfK;ATm8IX;;AoCt8HA;;;EXzfM,4GW4fJ;ApCy8HF;AyBj8IM;EWqfN;;;IXpfQ,gBAAA;EzBs8IN;AACF;;AqCv9IA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArC09IF;;AqCv9IA;EACE,cAAA;EACA,oBAAA;ArC09IF;AWz9IE;E0BGE,qBAAA;ArCy9IJ;AqCr9IE;EACE,c5BXO;E4BYP,oBAAA;EACA,eAAA;ArCu9IJ;;AqC/8IA;EACE,gCAAA;ArCk9IF;AqCh9IE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,+BAAA;EACA,gCAAA;AhBg+IJ;AW5+IE;E0B6BI,kBAAA;EACA,qC5BipB8B;ATi0HpC;AqC/8II;EACE,c5BrCK;E4BsCL,6BAAA;EACA,yBAAA;ArCi9IN;AqC78IE;;EAEE,c5B5CO;E4B6CP,sBnCnDI;EmCoDJ,kC5BsoBgC;ATy0HpC;AqC58IE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;AhBo/IJ;;AqCn8IE;EACE,gBAAA;EACA,SAAA;ErB7DA,sBAAA;AhBogJJ;AqCn8IE;;EAEE,WnC7EI;EmC8EJ,yB5BoK0B;ATiyI9B;;AqC37IE;;EAEE,cAAA;EACA,kBAAA;ArC87IJ;;AqCz7IE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ArC47IJ;;AqCl7IE;EACE,aAAA;ArCq7IJ;AqCn7IE;EACE,cAAA;ArCq7IJ;;AsC9hJA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AtCiiJF;AsC7hJE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AtCoiJJ;AsChhJA;EACE,qBAAA;EACA,sB7BkqBkC;E6BjqBlC,yB7BiqBkC;E6BhqBlC,kB7BgFO;EC6CH,kBAAA;E4B3HJ,oBAAA;EACA,mBAAA;AtCkhJF;AW5jJE;E2B6CE,qBAAA;AtCkhJJ;;AsCzgJA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtC4gJF;AsC1gJE;EACE,gBAAA;EACA,eAAA;AtC4gJJ;AsCzgJE;EACE,gBAAA;EACA,WAAA;AtC2gJJ;;AsClgJA;EACE,qBAAA;EACA,mB7BylBkC;E6BxlBlC,sB7BwlBkC;AT66HpC;;AsCz/IA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AtC0/IF;;AsCt/IA;EACE,wBAAA;E5B8DI,kBAAA;E4B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,sBAAA;AhBkmJJ;AWpmJE;E2B8GE,qBAAA;AtCy/IJ;;AsCn/IA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AtCs/IF;;AsCn/IA;EACE,gB7BglBkC;E6B/kBlC,gBAAA;AtCs/IF;;AoB5jJI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EtCm/IR;AACF;AoBrlJI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EtCw+IN;EsCt+IM;IACE,mBAAA;EtCw+IR;EsCt+IQ;IACE,kBAAA;EtCw+IV;EsCr+IQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;ET+8HlC;EsCl+IM;;;;;;IACE,iBAAA;EtCy+IR;EsC39IM;IACE,iBAAA;EtC69IR;EsC19IM;IACE,wBAAA;IAGA,gBAAA;EtC09IR;EsCv9IM;IACE,aAAA;EtCy9IR;AACF;AoB1mJI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EtCgiJR;AACF;AoBloJI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EtCqhJN;EsCnhJM;IACE,mBAAA;EtCqhJR;EsCnhJQ;IACE,kBAAA;EtCqhJV;EsClhJQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;ET4/HlC;EsC/gJM;;;;;;IACE,iBAAA;EtCshJR;EsCxgJM;IACE,iBAAA;EtC0gJR;EsCvgJM;IACE,wBAAA;IAGA,gBAAA;EtCugJR;EsCpgJM;IACE,aAAA;EtCsgJR;AACF;AoBvpJI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EtC6kJR;AACF;AoB/qJI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EtCkkJN;EsChkJM;IACE,mBAAA;EtCkkJR;EsChkJQ;IACE,kBAAA;EtCkkJV;EsC/jJQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;ETyiIlC;EsC5jJM;;;;;;IACE,iBAAA;EtCmkJR;EsCrjJM;IACE,iBAAA;EtCujJR;EsCpjJM;IACE,wBAAA;IAGA,gBAAA;EtCojJR;EsCjjJM;IACE,aAAA;EtCmjJR;AACF;AoBpsJI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EtC0nJR;AACF;AoB5tJI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EtC+mJN;EsC7mJM;IACE,mBAAA;EtC+mJR;EsC7mJQ;IACE,kBAAA;EtC+mJV;EsC5mJQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;ETslIlC;EsCzmJM;;;;;;IACE,iBAAA;EtCgnJR;EsClmJM;IACE,iBAAA;EtComJR;EsCjmJM;IACE,wBAAA;IAGA,gBAAA;EtCimJR;EsC9lJM;IACE,aAAA;EtCgmJR;AACF;AsC/pJQ;;;;;;EACE,gBAAA;EACA,eAAA;AtCsqJV;AsC1qJI;EAoBI,qBAAA;EACA,2BAAA;AtCypJR;AsCvpJQ;EACE,mBAAA;AtCypJV;AsCvpJU;EACE,kBAAA;AtCypJZ;AsCtpJU;EACE,qB7ByhBwB;E6BxhBxB,oB7BwhBwB;ATgoIpC;AsCnpJQ;;;;;;EACE,iBAAA;AtC0pJV;AsC5oJQ;EACE,iBAAA;AtC8oJV;AsC3oJQ;EACE,wBAAA;EAGA,gBAAA;AtC2oJV;AsCxoJQ;EACE,aAAA;AtC0oJV;;AsC5nJE;EACE,yB7BigBgC;AT8nIpC;AWv1JE;E2B2NI,yB7B8f8B;ATioIpC;AsC1nJI;EACE,yB7Bsf8B;ATsoIpC;AW71JE;E2BoOM,yB7Bof4B;ATwoIpC;AsCznJM;EACE,yB7Bkf4B;ATyoIpC;AsCvnJI;;;;EAIE,yB7Bye8B;ATgpIpC;AsCrnJE;EACE,yB7BkegC;E6BjehC,gC7BsegC;ATipIpC;AsCpnJE;EACE,yDAAA;AtCsnJJ;AsCnnJE;EACE,yB7BydgC;AT4pIpC;AsCpnJI;EACE,yB7Byd8B;AT6pIpC;AWt3JE;E2BmQM,yB7Bsd4B;ATgqIpC;;AsC9mJE;EACE,WpCpRI;AFq4JR;AW73JE;E2B+QI,WpCvRE;AFw4JR;AsC5mJI;EACE,+B7B2b8B;ATmrIpC;AWn4JE;E2BwRM,gC7Byb4B;ATqrIpC;AsC3mJM;EACE,gC7Bub4B;ATsrIpC;AsCzmJI;;;;EAIE,WpC5SE;AFu5JR;AsCvmJE;EACE,+B7BuagC;E6BtahC,sC7B2agC;AT8rIpC;AsCtmJE;EACE,yDAAA;AtCwmJJ;AsCrmJE;EACE,+B7B8ZgC;ATysIpC;AsCtmJI;EACE,WpC5TE;AFo6JR;AW55JE;E2BuTM,WpC/TA;AFu6JR;;AuC36JA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBrCHM;EqCIN,2BAAA;EACA,sCAAA;EvBKE,sBAAA;AhBy6JJ;AuC36JE;EACE,eAAA;EACA,cAAA;AvC66JJ;AuC16JE;EACE,mBAAA;EACA,sBAAA;AvC46JJ;AuC16JI;EACE,mBAAA;EvBCF,2CAAA;EACA,4CAAA;AhB46JJ;AuC16JI;EACE,sBAAA;EvBUF,+CAAA;EACA,8CAAA;AhBm6JJ;AuCv6JE;;EAEE,aAAA;AvCy6JJ;;AuCr6JA;EAGE,cAAA;EAGA,eAAA;EACA,gB9BgxBkC;ATopIpC;;AuCh6JA;EACE,sB9B0wBkC;ATypIpC;;AuCh6JA;EACE,qBAAA;EACA,gBAAA;AvCm6JF;;AuCh6JA;EACE,gBAAA;AvCm6JF;;AWx9JE;E4B0DE,qBAAA;AvCk6JJ;AuC/5JE;EACE,oB9ByvBgC;ATwqIpC;;AuCz5JA;EACE,wBAAA;EACA,gBAAA;EAEA,qC9BkvBkC;E8BjvBlC,6CAAA;AvC25JF;AuCz5JE;EvBvEE,0DAAA;AhBm+JJ;;AuCv5JA;EACE,wBAAA;EAEA,qC9BuuBkC;E8BtuBlC,0CAAA;AvCy5JF;AuCv5JE;EvBlFE,0DAAA;AhB4+JJ;;AuCh5JA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AvCm5JF;;AuCh5JA;EACE,uBAAA;EACA,sBAAA;AvCm5JF;;AuC/4JA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB9B6sBkC;EO5zBhC,kCAAA;AhBkgKJ;;AuC/4JA;;;EAGE,cAAA;EACA,WAAA;AvCk5JF;;AuC/4JA;;EvBjHI,2CAAA;EACA,4CAAA;AhBqgKJ;;AuCh5JA;;EvBxGI,+CAAA;EACA,8CAAA;AhB6/JJ;;AuC74JE;EACE,mB9BqrBgC;AT2tIpC;AoB/+JI;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EvCg5JF;EuC94JE;IAEE,SAAA;IACA,kB9ByqB8B;I8BxqB9B,gBAAA;IACA,iB9BuqB8B;ETwuIlC;AACF;;AuCn4JE;EACE,mB9BypBgC;AT6uIpC;AoBjgKI;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EvCs4JF;EuCn4JE;IAEE,SAAA;IACA,gBAAA;EvCo4JJ;EuCl4JI;IACE,cAAA;IACA,cAAA;EvCo4JN;EuC/3JM;IvBzKJ,0BAAA;IACA,6BAAA;EhB2iKF;EuCh4JQ;;IAGE,0BAAA;EvCi4JV;EuC/3JQ;;IAGE,6BAAA;EvCg4JV;EuC53JM;IvB1KJ,yBAAA;IACA,4BAAA;EhByiKF;EuC73JQ;;IAGE,yBAAA;EvC83JV;EuC53JQ;;IAGE,4BAAA;EvC63JV;AACF;;AuCh3JE;EACE,sB9B8kBgC;ATqyIpC;AoB3iKI;EmBsLJ;IAMI,e9B2lBgC;I8B1lBhC,mB9B2lBgC;I8B1lBhC,UAAA;IACA,SAAA;EvCm3JF;EuCj3JE;IACE,qBAAA;IACA,WAAA;EvCm3JJ;AACF;;AuC12JA;EACE,qBAAA;AvC62JF;AuC32JE;EACE,gBAAA;AvC62JJ;AuC32JI;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;AhBqlKJ;AuC32JI;EvBzPA,yBAAA;EACA,0BAAA;AhBumKJ;AuC32JI;EvBtQA,gBAAA;EuBwQE,mBAAA;AvC62JN;;AwCvoKA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BqiCkC;E+BniClC,gBAAA;EACA,yB/BES;EOSP,sBAAA;AhB+nKJ;;AwCpoKE;EACE,oB/ByhCgC;AT8mIpC;AwCroKI;EACE,WAAA;EACA,qB/BqhC8B;E+BphC9B,c/BNK;E+BOL,YAAA;AxCuoKN;AwC7nKE;EACE,0BAAA;AxC+nKJ;AwC5nKE;EACE,qBAAA;AxC8nKJ;AwC3nKE;EACE,c/B1BO;ATupKX;;AyCpqKA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,sBAAA;AhBypKJ;;AyCrqKA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhCoxBkC;EgCnxBlC,chCmKwC;EgCjKxC,yBvC6Bc;EuC5Bd,yBAAA;AzCuqKF;AyCrqKE;EACE,UAAA;EACA,wDhC8JsC;EgC7JtC,qBAAA;EACA,yBhCZO;EgCaP,qBhCZO;ATmrKX;AyCpqKE;EACE,UAAA;EACA,UhC4wBgC;EgC3wBhC,iDhC+W0B;ATuzJ9B;;AyChqKI;EACE,cAAA;EzBaF,+BAAA;EACA,kCAAA;AhBupKJ;AyChqKI;EzBNA,gCAAA;EACA,mCAAA;AhByqKJ;AyC/pKE;EACE,UAAA;EACA,WvCvCI;EuCwCJ,yBhC0M0B;EgCzM1B,qBhCyM0B;ATw9J9B;AyC9pKE;EACE,chCxCO;EgCyCP,oBAAA;EAEA,YAAA;EACA,sBvCjDI;EuCkDJ,qBhChDO;AT+sKX;;A0CttKE;EACE,uBAAA;EhCgLE,kBAAA;EgC9KF,gBjCmO0B;ATs/J9B;A0CptKM;E1BqCF,8BAAA;EACA,iCAAA;AhBkrKJ;A0CntKM;E1BkBF,+BAAA;EACA,kCAAA;AhBosKJ;;A0CpuKE;EACE,uBAAA;EhCgLE,mBAAA;EgC9KF,gBjCoO0B;ATmgK9B;A0CluKM;E1BqCF,8BAAA;EACA,iCAAA;AhBgsKJ;A0CjuKM;E1BkBF,+BAAA;EACA,kCAAA;AhBktKJ;;A2ChvKA;EACE,qBAAA;EACA,qBAAA;EjC6JE,cAAA;EiC3JF,gBlCwR4B;EkCvR5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,sBAAA;ESFE,qIkBDJ;A3CmvKF;AyB9uKM;EkBfN;IlBgBQ,gBAAA;EzBivKN;AACF;AWvvKE;EgCGI,qBAAA;A3CuvKN;;A2ClvKE;EACE,aAAA;A3CqvKJ;;A2ChvKA;EACE,kBAAA;EACA,SAAA;A3CmvKF;;A2C5uKA;EACE,oBlCi4BkC;EkCh4BlC,mBlCg4BkC;EOv5BhC,oBAAA;AhBuwKJ;;A2CvuKE;ECjDA,WAAA;EACA,yBnC0Ea;ATktKf;AW9wKE;EiCVI,WAAA;EACA,oEAAA;A5C2xKN;A4CxxKI;EAEE,UAAA;EACA,gDAAA;A5CyxKN;;A2CpvKE;ECjDA,WAAA;EACA,yBnC0Ea;AT+tKf;AW3xKE;EiCVI,WAAA;EACA,kEAAA;A5CwyKN;A4CryKI;EAEE,UAAA;EACA,iDAAA;A5CsyKN;;A2CjwKE;ECjDA,WAAA;EACA,yBnC0Ea;AT4uKf;AWxyKE;EiCVI,WAAA;EACA,uCAAA;A5CqzKN;A4ClzKI;EAEE,UAAA;EACA,+CAAA;A5CmzKN;;A2C9wKE;ECjDA,WAAA;EACA,yBnC0Ea;ATyvKf;AWrzKE;EiCVI,WAAA;EACA,oEAAA;A5Ck0KN;A4C/zKI;EAEE,UAAA;EACA,gDAAA;A5Cg0KN;;A2C3xKE;ECjDA,cAAA;EACA,yBnC0Ea;ATswKf;AWl0KE;EiCVI,cAAA;EACA,qCAAA;A5C+0KN;A4C50KI;EAEE,UAAA;EACA,+CAAA;A5C60KN;;A2CxyKE;ECjDA,WAAA;EACA,yBnC0Ea;ATmxKf;AW/0KE;EiCVI,WAAA;EACA,mEAAA;A5C41KN;A4Cz1KI;EAEE,UAAA;EACA,+CAAA;A5C01KN;;A2CrzKE;ECjDA,cAAA;EACA,yBnC0Ea;ATgyKf;AW51KE;EiCVI,cAAA;EACA,4CAAA;A5Cy2KN;A4Ct2KI;EAEE,UAAA;EACA,iDAAA;A5Cu2KN;;A2Cl0KE;ECjDA,WAAA;EACA,yBnC0Ea;AT6yKf;AWz2KE;EiCVI,WAAA;EACA,yDAAA;A5Cs3KN;A4Cn3KI;EAEE,UAAA;EACA,8CAAA;A5Co3KN;;A6Cj4KA;EACE,kBAAA;EACA,mBpCyzBkC;EoCvzBlC,yBpCKS;EOSP,qBAAA;AhBs3KJ;AoB50KI;EyB5DJ;IAQI,kBAAA;E7Co4KF;AACF;;A6Cj4KA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;AhBi4KJ;;A8C/4KA;EACE,kBAAA;EACA,wBAAA;EACA,mBrCy9BkC;EqCx9BlC,6BAAA;E9BUE,sBAAA;AhBy4KJ;;A8C94KA;EAEE,cAAA;A9Cg5KF;;A8C54KA;EACE,gBrC6Q4B;ATkoK9B;;A8Cv4KA;EACE,mBAAA;A9C04KF;A8Cv4KE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;A9Cy4KJ;;A8C/3KE;EC/CA,8BDgDqH;EnB3CnH,sCmB2CuB;EC9CzB,qCD8CqE;A9Co4KvE;A+Ch7KE;EACE,qEAAA;A/Ck7KJ;A+C/6KE;EACE,+BAAA;A/Ci7KJ;;A8C34KE;EC/CA,4BDgDqH;EnB3CnH,wCmB2CuB;EC9CzB,wCD8CqE;A9Cg5KvE;A+C57KE;EACE,qEAAA;A/C87KJ;A+C37KE;EACE,uDAAA;A/C67KJ;;A8Cv5KE;EC/CA,4BDgDqH;EnB3CnH,sCmB2CuB;EC9CzB,uCD8CqE;A9C45KvE;A+Cx8KE;EACE,qEAAA;A/C08KJ;A+Cv8KE;EACE,4BAAA;A/Cy8KJ;;A8Cn6KE;EC/CA,+BDgDqH;EnB3CnH,0CmB2CuB;EC9CzB,yCD8CqE;A9Cw6KvE;A+Cp9KE;EACE,qEAAA;A/Cs9KJ;A+Cn9KE;EACE,sDAAA;A/Cq9KJ;;A8C/6KE;EC/CA,+BDgDqH;EnB3CnH,wCmB2CuB;EC9CzB,sCD8CqE;A9Co7KvE;A+Ch+KE;EACE,2CAAA;A/Ck+KJ;A+C/9KE;EACE,sDAAA;A/Ci+KJ;;A8C37KE;EC/CA,+BDgDqH;EnB3CnH,wCmB2CuB;EC9CzB,wCD8CqE;A9Cg8KvE;A+C5+KE;EACE,qEAAA;A/C8+KJ;A+C3+KE;EACE,uDAAA;A/C6+KJ;;A8Cv8KE;EC/CA,+BDgDqH;EnB3CnH,wCmB2CuB;EC9CzB,wCD8CqE;A9C48KvE;A+Cx/KE;EACE,+CAAA;A/C0/KJ;A+Cv/KE;EACE,kDAAA;A/Cy/KJ;;A8Cn9KE;EC/CA,+BDgDqH;EnB3CnH,0CmB2CuB;EC9CzB,yCD8CqE;A9Cw9KvE;A+CpgLE;EACE,6DAAA;A/CsgLJ;A+CngLE;EACE,4CAAA;A/CqgLJ;;AgD7gLE;EACE;IAAO,2BAAA;EhDihLT;EgDhhLE;IAAK,wBAAA;EhDmhLP;AACF;AgDhhLA;EACE,aAAA;EACA,YvCk+BkC;EuCj+BlC,gBAAA;EACA,cAAA;EtCwKI,kBAAA;EsCtKJ,yBvCLS;EOSP,sBAAA;AhB+gLJ;;AgD9gLA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,W9ChBM;E8CiBN,kBAAA;EACA,mBAAA;EACA,yBvCu9BkC;EgBl+B9B,2BuBYJ;AhDihLF;AyBzhLM;EuBDN;IvBEQ,gBAAA;EzB4hLN;AACF;;AgDnhLA;ErBYE,qMAAA;EqBVA,0BAAA;AhDshLF;;AgDlhLE;EACE,kDAAA;AhDqhLJ;AgDlhLM;EAJJ;IAKM,eAAA;EhDqhLN;AACF;;AiDhkLA;EACE,aAAA;EACA,uBAAA;AjDmkLF;;AiDhkLA;EACE,SAAA;AjDmkLF;;AkDrkLA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,sBAAA;AhB+jLJ;;AkD7jLA;EACE,WAAA;EACA,czCRS;EyCST,mBAAA;AlDgkLF;AWvkLE;EuCWE,UAAA;EACA,czCdO;EyCeP,qBAAA;EACA,yBzCtBO;ATqlLX;AkD5jLE;EACE,czClBO;EyCmBP,yBzC1BO;ATwlLX;;AkDrjLA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,sBhD1CM;EgD2CN,sCAAA;AlDsjLF;AkDpjLE;ElC1BE,+BAAA;EACA,gCAAA;AhBilLJ;AkDpjLE;ElChBE,mCAAA;EACA,kCAAA;AhBukLJ;AkDpjLE;EAEE,czClDO;EyCmDP,oBAAA;EACA,sBhDzDI;AF8mLR;AkDjjLE;EACE,UAAA;EACA,WhD/DI;EgDgEJ,yBzCkL0B;EyCjL1B,qBzCiL0B;ATk4K9B;AkDhjLE;EACE,mBAAA;AlDkjLJ;AkDhjLI;EACE,gBAAA;EACA,qBzC2JwB;ATu5K9B;;AkDpiLI;EACE,mBAAA;AlDuiLN;AkDpiLQ;ElC1BJ,kCAAA;EAZA,0BAAA;AhB8kLJ;AkDniLQ;ElC3CJ,gCAAA;EAYA,4BAAA;AhBskLJ;AkDliLQ;EACE,aAAA;AlDoiLV;AkDjiLQ;EACE,qBzC0HoB;EyCzHpB,oBAAA;AlDmiLV;AkDjiLU;EACE,iBAAA;EACA,sBzCqHkB;AT86K9B;;AoB9lLI;E8BmCA;IACE,mBAAA;ElD+jLJ;EkD5jLM;IlC1BJ,kCAAA;IAZA,0BAAA;EhBsmLF;EkD3jLM;IlC3CJ,gCAAA;IAYA,4BAAA;EhB8lLF;EkD1jLM;IACE,aAAA;ElD4jLR;EkDzjLM;IACE,qBzC0HoB;IyCzHpB,oBAAA;ElD2jLR;EkDzjLQ;IACE,iBAAA;IACA,sBzCqHkB;ETs8K5B;AACF;AoBvnLI;E8BmCA;IACE,mBAAA;ElDulLJ;EkDplLM;IlC1BJ,kCAAA;IAZA,0BAAA;EhB8nLF;EkDnlLM;IlC3CJ,gCAAA;IAYA,4BAAA;EhBsnLF;EkDllLM;IACE,aAAA;ElDolLR;EkDjlLM;IACE,qBzC0HoB;IyCzHpB,oBAAA;ElDmlLR;EkDjlLQ;IACE,iBAAA;IACA,sBzCqHkB;ET89K5B;AACF;AoB/oLI;E8BmCA;IACE,mBAAA;ElD+mLJ;EkD5mLM;IlC1BJ,kCAAA;IAZA,0BAAA;EhBspLF;EkD3mLM;IlC3CJ,gCAAA;IAYA,4BAAA;EhB8oLF;EkD1mLM;IACE,aAAA;ElD4mLR;EkDzmLM;IACE,qBzC0HoB;IyCzHpB,oBAAA;ElD2mLR;EkDzmLQ;IACE,iBAAA;IACA,sBzCqHkB;ETs/K5B;AACF;AoBvqLI;E8BmCA;IACE,mBAAA;ElDuoLJ;EkDpoLM;IlC1BJ,kCAAA;IAZA,0BAAA;EhB8qLF;EkDnoLM;IlC3CJ,gCAAA;IAYA,4BAAA;EhBsqLF;EkDloLM;IACE,aAAA;ElDooLR;EkDjoLM;IACE,qBzC0HoB;IyCzHpB,oBAAA;ElDmoLR;EkDjoLQ;IACE,iBAAA;IACA,sBzCqHkB;ET8gL5B;AACF;AkDtnLA;ElCnHI,gBAAA;AhB4uLJ;AkDtnLE;EACE,qBAAA;AlDwnLJ;AkDtnLI;EACE,sBAAA;AlDwnLN;;AmDjwLE;EACE,8BDoJsE;ECnJtE,yCDmJuC;AlDinL3C;AWzvLE;EwCPM,8BD+IkE;EC9IlE,qEAAA;AnDmwLR;AmDhwLM;EACE,WjDNA;EiDOA,yCDyIkE;ECxIlE,qCDwIkE;AlD0nL1E;;AmD/wLE;EACE,4BDoJsE;ECnJtE,4CDmJuC;AlD+nL3C;AWvwLE;EwCPM,4BD+IkE;EC9IlE,qEAAA;AnDixLR;AmD9wLM;EACE,WjDNA;EiDOA,uCDyIkE;ECxIlE,mCDwIkE;AlDwoL1E;;AmD7xLE;EACE,4BDoJsE;ECnJtE,2CDmJuC;AlD6oL3C;AWrxLE;EwCPM,4BD+IkE;EC9IlE,qEAAA;AnD+xLR;AmD5xLM;EACE,WjDNA;EiDOA,uCDyIkE;ECxIlE,mCDwIkE;AlDspL1E;;AmD3yLE;EACE,+BDoJsE;ECnJtE,6CDmJuC;AlD2pL3C;AWnyLE;EwCPM,+BD+IkE;EC9IlE,qEAAA;AnD6yLR;AmD1yLM;EACE,WjDNA;EiDOA,0CDyIkE;ECxIlE,sCDwIkE;AlDoqL1E;;AmDzzLE;EACE,+BDoJsE;ECnJtE,0CDmJuC;AlDyqL3C;AWjzLE;EwCPM,+BD+IkE;EC9IlE,2CAAA;AnD2zLR;AmDxzLM;EACE,WjDNA;EiDOA,0CDyIkE;ECxIlE,sCDwIkE;AlDkrL1E;;AmDv0LE;EACE,+BDoJsE;ECnJtE,4CDmJuC;AlDurL3C;AW/zLE;EwCPM,+BD+IkE;EC9IlE,qEAAA;AnDy0LR;AmDt0LM;EACE,WjDNA;EiDOA,0CDyIkE;ECxIlE,sCDwIkE;AlDgsL1E;;AmDr1LE;EACE,+BDoJsE;ECnJtE,4CDmJuC;AlDqsL3C;AW70LE;EwCPM,+BD+IkE;EC9IlE,+CAAA;AnDu1LR;AmDp1LM;EACE,WjDNA;EiDOA,0CDyIkE;ECxIlE,sCDwIkE;AlD8sL1E;;AmDn2LE;EACE,+BDoJsE;ECnJtE,6CDmJuC;AlDmtL3C;AW31LE;EwCPM,+BD+IkE;EC9IlE,6DAAA;AnDq2LR;AmDl2LM;EACE,WjDNA;EiDOA,0CDyIkE;ECxIlE,sCDwIkE;AlD4tL1E;;AoDp3LA;EACE,YAAA;E1CmLI,iBAAA;E0CjLJ,gB3C8R4B;E2C7R5B,cAAA;EACA,WlDMM;EkDLN,yB3CylCkC;E2CxlClC,YAAA;ApDu3LF;AWl3LE;EyCDE,WAAA;EACA,qBAAA;ApDs3LJ;AWl3LE;EyCCI,aAAA;ApDo3LN;;AoDz2LA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;ApD42LF;;AoDt2LA;EACE,oBAAA;ApDy2LF;;AqD/4LA;EAGE,iB5C24BkC;E4C14BlC,gB5C04BkC;EC1tB9B,mBAAA;E2C7KJ,2C5C44BkC;E4C34BlC,4BAAA;EACA,oCAAA;EACA,gD5C64BkC;E4C54BlC,UAAA;ErCOE,sBAAA;AhBy4LJ;AqD74LE;EACE,sB5Cg4BgC;AT+gKpC;AqD54LE;EACE,UAAA;ArD84LJ;AqD34LE;EACE,cAAA;EACA,UAAA;ArD64LJ;AqD14LE;EACE,aAAA;ArD44LJ;;AqDx4LA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c5CvBS;E4CwBT,2C5Cq3BkC;E4Cp3BlC,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;AhBw5LJ;;AqDz4LA;EACE,gB5Cm2BkC;ATyiKpC;;AsDl7LA;EAEE,gBAAA;AtDo7LF;AsDl7LE;EACE,kBAAA;EACA,gBAAA;AtDo7LJ;;AsD/6LA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7C4pBkC;E6C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AtDg7LF;;AsDz6LA;EACE,kBAAA;EACA,WAAA;EACA,c7Ci5BkC;E6C/4BlC,oBAAA;AtD26LF;AsDx6LE;E7B3BI,mC6B4BF;AtD06LJ;AyBl8LM;E6BuBJ;I7BtBM,gBAAA;EzBq8LN;AACF;AsDh7LE;EAEE,8B7Cu6BgC;AT0gKpC;AsD/6LE;EACE,e7Cq6BgC;AT4gKpC;AsD76LE;EACE,sB7Ck6BgC;AT6gKpC;;AsD36LA;EACE,aAAA;EACA,6BAAA;AtD86LF;AsD56LE;EACE,8BAAA;EACA,gBAAA;AtD86LJ;AsD36LE;;EAEE,cAAA;AtD66LJ;AsD16LE;EACE,gBAAA;AtD46LJ;;AsDx6LA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AtD26LF;AsDx6LE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AtD06LJ;AsDt6LE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AtDw6LJ;AsDt6LI;EACE,gBAAA;AtDw6LN;AsDr6LI;EACE,aAAA;AtDu6LN;;AsDj6LA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sBpD1GM;EoD2GN,4BAAA;EACA,oCAAA;EtClGE,qBAAA;EsCsGF,UAAA;AtDg6LF;;AsD55LA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7CgjBkC;E6C/iBlC,YAAA;EACA,aAAA;EACA,sBpDxHM;AFuhMR;AsD55LE;EAAS,UAAA;AtD+5LX;AsD95LE;EAAS,Y7C+zByB;ATkmKpC;;AsD55LA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB7C6zBkC;E6C5zBlC,gCAAA;EtCtHE,0CAAA;EACA,2CAAA;AhBshMJ;AsD95LE;EACE,kB7CwzBgC;E6CtzBhC,8BAAA;AtD+5LJ;;AsD15LA;EACE,gBAAA;EACA,gB7CuI4B;ATsxL9B;;AsDx5LA;EACE,kBAAA;EAGA,cAAA;EACA,a7C0wBkC;AT+oKpC;;AsDr5LA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;EtCzIE,8CAAA;EACA,6CAAA;AhBkiMJ;AsDp5LE;EACE,eAAA;AtDs5LJ;;AsDj5LA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AtDo5LF;;AoB3hMI;EkC6IF;IACE,gB7CuwBgC;I6CtwBhC,oBAAA;EtDk5LF;EsD/4LA;IACE,+BAAA;EtDi5LF;EsD/4LE;IACE,gCAAA;EtDi5LJ;EsD74LA;IACE,+BAAA;EtD+4LF;EsD74LE;IACE,4BAAA;IACA,mBAAA;EtD+4LJ;EsDv4LA;IAAY,gB7C+uBsB;ET2pKlC;AACF;AoBljMI;EkC2KF;;IAEE,gB7CuuBgC;ETmqKlC;AACF;AoBxjMI;EkCkLF;IAAY,iB7CiuBsB;ETyqKlC;AACF;AuDxnMA;EACE,kBAAA;EACA,a9CgrBkC;E8C/qBlC,cAAA;EACA,S9C61BkC;E+Cj2BlC,qN/CoR4B;E+ClR5B,kBAAA;EACA,gB/C4R4B;E+C3R5B,gB/CgS4B;E+C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,mBAAA;E6CzKJ,qBAAA;EACA,UAAA;AvDooMF;AuDloME;EAAS,Y9Ci1ByB;ATozKpC;AuDnoME;EACE,kBAAA;EACA,cAAA;EACA,a9Ci1BgC;E8Ch1BhC,c9Ci1BgC;ATozKpC;AuDnoMI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AvDqoMN;;AuDhoMA;EACE,iBAAA;AvDmoMF;AuDjoME;EACE,SAAA;AvDmoMJ;AuDjoMI;EACE,MAAA;EACA,6BAAA;EACA,sBrD7BE;AFgqMR;;AuD9nMA;EACE,iBAAA;AvDioMF;AuD/nME;EACE,OAAA;EACA,a9CmzBgC;E8ClzBhC,c9CizBgC;ATg1KpC;AuD/nMI;EACE,QAAA;EACA,oCAAA;EACA,wBrD7CE;AF8qMR;;AuD5nMA;EACE,iBAAA;AvD+nMF;AuD7nME;EACE,MAAA;AvD+nMJ;AuD7nMI;EACE,SAAA;EACA,6BAAA;EACA,yBrD3DE;AF0rMR;;AuD1nMA;EACE,iBAAA;AvD6nMF;AuD3nME;EACE,QAAA;EACA,a9CqxBgC;E8CpxBhC,c9CmxBgC;AT02KpC;AuD3nMI;EACE,OAAA;EACA,oCAAA;EACA,uBrD3EE;AFwsMR;;AuDxmMA;EACE,gB9C+uBkC;E8C9uBlC,uBAAA;EACA,WrDtGM;EqDuGN,kBAAA;EACA,sBrDrGM;EcOJ,sBAAA;AhB0sMJ;;AyD5tMA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,ahD8qBkC;EgD7qBlC,cAAA;EACA,gBhD+2BkC;E+Cp3BlC,qN/CoR4B;E+ClR5B,kBAAA;EACA,gB/C4R4B;E+C3R5B,gB/CgS4B;E+C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,mBAAA;E+CxKJ,qBAAA;EACA,sBvDLM;EuDMN,4BAAA;EACA,oCAAA;EzCGE,qBAAA;AhBuuMJ;AyDtuME;EACE,kBAAA;EACA,cAAA;EACA,WhD+2BgC;EgD92BhC,chD+2BgC;EgD92BhC,gBAAA;AzDwuMJ;AyDtuMI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AzDuuMN;;AyDluMA;EACE,qBhDg2BkC;ATq4KpC;AyDnuME;EACE,2BAAA;AzDquMJ;AyDnuMI;EACE,SAAA;EACA,6BAAA;EACA,qChD21B8B;AT04KpC;AyDluMI;EACE,WhD0LwB;EgDzLxB,6BAAA;EACA,sBvD5CE;AFgxMR;;AyD/tMA;EACE,mBhD40BkC;ATs5KpC;AyDhuME;EACE,yBAAA;EACA,ahDw0BgC;EgDv0BhC,YhDs0BgC;EgDr0BhC,gBAAA;AzDkuMJ;AyDhuMI;EACE,OAAA;EACA,oCAAA;EACA,uChDo0B8B;AT85KpC;AyD/tMI;EACE,ShDmKwB;EgDlKxB,oCAAA;EACA,wBvDnEE;AFoyMR;;AyD5tMA;EACE,kBhDqzBkC;AT06KpC;AyD7tME;EACE,wBAAA;AzD+tMJ;AyD7tMI;EACE,MAAA;EACA,oCAAA;EACA,wChDgzB8B;AT+6KpC;AyD5tMI;EACE,QhD+IwB;EgD9IxB,oCAAA;EACA,yBvDvFE;AFqzMR;AyDztME;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WhD4xBgC;EgD3xBhC,oBAAA;EACA,WAAA;EACA,oDAAA;AzD2tMJ;;AyDvtMA;EACE,oBhDqxBkC;ATq8KpC;AyDxtME;EACE,0BAAA;EACA,ahDixBgC;EgDhxBhC,YhD+wBgC;EgD9wBhC,gBAAA;AzD0tMJ;AyDxtMI;EACE,QAAA;EACA,oCAAA;EACA,sChD6wB8B;AT68KpC;AyDvtMI;EACE,UhD4GwB;EgD3GxB,oCAAA;EACA,uBvD1HE;AFm1MR;;AyDnsMA;EACE,uBAAA;EACA,gBAAA;E/C0BI,eAAA;E+CvBJ,6ChD+tBkC;EgD9tBlC,iDAAA;EzCnIE,0CAAA;EACA,2CAAA;AhBy0MJ;AyDpsME;EACE,aAAA;AzDssMJ;;AyDlsMA;EACE,uBAAA;EACA,chDxJS;AT61MX;;A0Dh2MA;EACE,kBAAA;A1Dm2MF;;A0Dh2MA;EACE,mBAAA;A1Dm2MF;;A0Dh2MA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A1Dm2MF;A2D13ME;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3D43MJ;;A0Dp2MA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;A1Du2MF;AyBt3MM;EiCQN;IjCPQ,gBAAA;EzBy3MN;AACF;;A0Dz2MA;;;EAGE,cAAA;A1D42MF;;A0Dz2MA;;EAEE,2BAAA;A1D42MF;;A0Dz2MA;;EAEE,4BAAA;A1D42MF;;A0Dn2ME;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A1Ds2MJ;A0Dn2ME;;;EAGE,UAAA;EACA,UAAA;A1Dq2MJ;A0Dl2ME;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;A1Do2MJ;AyB75MM;EiCqDJ;;IjCpDM,gBAAA;EzBi6MN;AACF;;A0Dj2MA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDs9BmC;EiDr9BnC,UAAA;EACA,WxD1FM;EwD2FN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjDi9BmC;EgBviC/B,8BiCuFJ;A1Dm2MF;AyBt7MM;EiCkEN;;IjCjEQ,gBAAA;EzB07MN;AACF;AWh8ME;;;E+C2FE,WxDnGI;EwDoGJ,qBAAA;EACA,UAAA;EACA,YjD08BiC;ATg6KrC;;A0Dv2MA;EACE,OAAA;A1D02MF;;A0Dr2MA;EACE,QAAA;A1Dw2MF;;A0Dj2MA;;EAEE,qBAAA;EACA,WjDm8BmC;EiDl8BnC,YjDk8BmC;EiDj8BnC,mCAAA;A1Do2MF;;A0Dl2MA;EACE,yDAAA;A1Dq2MF;;A0Dn2MA;EACE,0DAAA;A1Ds2MF;;A0D71MA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBjDy5BmC;EiDx5BnC,gBjDw5BmC;EiDv5BnC,gBAAA;A1D+1MF;A0D71ME;EACE,uBAAA;EACA,cAAA;EACA,WjDu5BiC;EiDt5BjC,WjDu5BiC;EiDt5BjC,iBjDw5BiC;EiDv5BjC,gBjDu5BiC;EiDt5BjC,mBAAA;EACA,eAAA;EACA,sBxDlKI;EwDmKJ,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;A1D81MJ;AyB1/MM;EiC6IJ;IjC5IM,gBAAA;EzB6/MN;AACF;A0Dh2ME;EACE,UAAA;A1Dk2MJ;;A0Dz1MA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WxD7LM;EwD8LN,kBAAA;A1D41MF;;A4D9hNA;EACE;IAAK,yBAAA;E5DkiNL;AACF;A4DhiNA;EACE,qBAAA;EACA,WnDskCwB;EmDrkCxB,YnDqkCwB;EmDpkCxB,wBnDskCwB;EmDrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;A5DiiNF;;A4D9hNA;EACE,WnDgkCwB;EmD/jCxB,YnD+jCwB;EmD9jCxB,mBnDgkCwB;ATi+K1B;;A4D1hNA;EACE;IACE,mBAAA;E5D6hNF;E4D3hNA;IACE,UAAA;IACA,eAAA;E5D6hNF;AACF;A4D1hNA;EACE,qBAAA;EACA,WnDsiCwB;EmDriCxB,YnDqiCwB;EmDpiCxB,wBnDsiCwB;EmDriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;A5D2hNF;;A4DxhNA;EACE,WnDgiCwB;EmD/hCxB,YnD+hCwB;AT4/K1B;;A4DvhNE;EACE;;IAEE,wBAAA;E5D0hNJ;AACF;A6DtlNA;EAAqB,mCAAA;A7DylNrB;;A6DxlNA;EAAqB,8BAAA;A7D4lNrB;;A6D3lNA;EAAqB,iCAAA;A7D+lNrB;;A6D9lNA;EAAqB,iCAAA;A7DkmNrB;;A6DjmNA;EAAqB,sCAAA;A7DqmNrB;;A6DpmNA;EAAqB,mCAAA;A7DwmNrB;;A8D1mNE;EACE,oCAAA;A9D6mNJ;;AWnmNE;;;EmDLI,+EAAA;A9D8mNN;;A8DpnNE;EACE,oCAAA;A9DunNJ;;AW7mNE;;;EmDLI,6EAAA;A9DwnNN;;A8D9nNE;EACE,oCAAA;A9DioNJ;;AWvnNE;;;EmDLI,kDAAA;A9DkoNN;;A8DxoNE;EACE,oCAAA;A9D2oNJ;;AWjoNE;;;EmDLI,+EAAA;A9D4oNN;;A8DlpNE;EACE,oCAAA;A9DqpNJ;;AW3oNE;;;EmDLI,gDAAA;A9DspNN;;A8D5pNE;EACE,oCAAA;A9D+pNJ;;AWrpNE;;;EmDLI,8EAAA;A9DgqNN;;A8DtqNE;EACE,oCAAA;A9DyqNJ;;AW/pNE;;;EmDLI,uDAAA;A9D0qNN;;A8DhrNE;EACE,oCAAA;A9DmrNJ;;AWzqNE;;;EmDLI,oEAAA;A9DorNN;;A+DnrNA;EACE,iCAAA;A/DsrNF;;A+DnrNA;EACE,wCAAA;A/DsrNF;;AgEjsNA;EAAkB,oCAAA;AhEqsNlB;;AgEpsNA;EAAkB,wCAAA;AhEwsNlB;;AgEvsNA;EAAkB,0CAAA;AhE2sNlB;;AgE1sNA;EAAkB,2CAAA;AhE8sNlB;;AgE7sNA;EAAkB,yCAAA;AhEitNlB;;AgE/sNA;EAAmB,oBAAA;AhEmtNnB;;AgEltNA;EAAmB,wBAAA;AhEstNnB;;AgErtNA;EAAmB,0BAAA;AhEytNnB;;AgExtNA;EAAmB,2BAAA;AhE4tNnB;;AgE3tNA;EAAmB,yBAAA;AhE+tNnB;;AgE5tNE;EACE,gCAAA;AhE+tNJ;;AgEhuNE;EACE,gCAAA;AhEmuNJ;;AgEpuNE;EACE,gCAAA;AhEuuNJ;;AgExuNE;EACE,gCAAA;AhE2uNJ;;AgE5uNE;EACE,gCAAA;AhE+uNJ;;AgEhvNE;EACE,gCAAA;AhEmvNJ;;AgEpvNE;EACE,gCAAA;AhEuvNJ;;AgExvNE;EACE,gCAAA;AhE2vNJ;;AgEvvNA;EACE,6BAAA;AhE0vNF;;AgEnvNA;EACE,gCAAA;AhEsvNF;;AgEnvNA;EACE,iCAAA;AhEsvNF;;AgEnvNA;EACE,0CAAA;EACA,2CAAA;AhEsvNF;;AgEnvNA;EACE,2CAAA;EACA,8CAAA;AhEsvNF;;AgEnvNA;EACE,8CAAA;EACA,6CAAA;AhEsvNF;;AgEnvNA;EACE,0CAAA;EACA,6CAAA;AhEsvNF;;AgEnvNA;EACE,gCAAA;AhEsvNF;;AgEnvNA;EACE,6BAAA;AhEsvNF;;AgEnvNA;EACE,+BAAA;AhEsvNF;;AgEnvNA;EACE,2BAAA;AhEsvNF;;A2D9zNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3Di0NJ;;AiE1zNM;EAAwB,wBAAA;AjE8zN9B;;AiE9zNM;EAAwB,0BAAA;AjEk0N9B;;AiEl0NM;EAAwB,gCAAA;AjEs0N9B;;AiEt0NM;EAAwB,yBAAA;AjE00N9B;;AiE10NM;EAAwB,yBAAA;AjE80N9B;;AiE90NM;EAAwB,6BAAA;AjEk1N9B;;AiEl1NM;EAAwB,8BAAA;AjEs1N9B;;AiEt1NM;EAAwB,wBAAA;AjE01N9B;;AiE11NM;EAAwB,+BAAA;AjE81N9B;;AoB7yNI;E6CjDE;IAAwB,wBAAA;EjEm2N5B;EiEn2NI;IAAwB,0BAAA;EjEs2N5B;EiEt2NI;IAAwB,gCAAA;EjEy2N5B;EiEz2NI;IAAwB,yBAAA;EjE42N5B;EiE52NI;IAAwB,yBAAA;EjE+2N5B;EiE/2NI;IAAwB,6BAAA;EjEk3N5B;EiEl3NI;IAAwB,8BAAA;EjEq3N5B;EiEr3NI;IAAwB,wBAAA;EjEw3N5B;EiEx3NI;IAAwB,+BAAA;EjE23N5B;AACF;AoB30NI;E6CjDE;IAAwB,wBAAA;EjEg4N5B;EiEh4NI;IAAwB,0BAAA;EjEm4N5B;EiEn4NI;IAAwB,gCAAA;EjEs4N5B;EiEt4NI;IAAwB,yBAAA;EjEy4N5B;EiEz4NI;IAAwB,yBAAA;EjE44N5B;EiE54NI;IAAwB,6BAAA;EjE+4N5B;EiE/4NI;IAAwB,8BAAA;EjEk5N5B;EiEl5NI;IAAwB,wBAAA;EjEq5N5B;EiEr5NI;IAAwB,+BAAA;EjEw5N5B;AACF;AoBx2NI;E6CjDE;IAAwB,wBAAA;EjE65N5B;EiE75NI;IAAwB,0BAAA;EjEg6N5B;EiEh6NI;IAAwB,gCAAA;EjEm6N5B;EiEn6NI;IAAwB,yBAAA;EjEs6N5B;EiEt6NI;IAAwB,yBAAA;EjEy6N5B;EiEz6NI;IAAwB,6BAAA;EjE46N5B;EiE56NI;IAAwB,8BAAA;EjE+6N5B;EiE/6NI;IAAwB,wBAAA;EjEk7N5B;EiEl7NI;IAAwB,+BAAA;EjEq7N5B;AACF;AoBr4NI;E6CjDE;IAAwB,wBAAA;EjE07N5B;EiE17NI;IAAwB,0BAAA;EjE67N5B;EiE77NI;IAAwB,gCAAA;EjEg8N5B;EiEh8NI;IAAwB,yBAAA;EjEm8N5B;EiEn8NI;IAAwB,yBAAA;EjEs8N5B;EiEt8NI;IAAwB,6BAAA;EjEy8N5B;EiEz8NI;IAAwB,8BAAA;EjE48N5B;EiE58NI;IAAwB,wBAAA;EjE+8N5B;EiE/8NI;IAAwB,+BAAA;EjEk9N5B;AACF;AiEz8NA;EAEI;IAAqB,wBAAA;EjE28NvB;EiE38NE;IAAqB,0BAAA;EjE88NvB;EiE98NE;IAAqB,gCAAA;EjEi9NvB;EiEj9NE;IAAqB,yBAAA;EjEo9NvB;EiEp9NE;IAAqB,yBAAA;EjEu9NvB;EiEv9NE;IAAqB,6BAAA;EjE09NvB;EiE19NE;IAAqB,8BAAA;EjE69NvB;EiE79NE;IAAqB,wBAAA;EjEg+NvB;EiEh+NE;IAAqB,+BAAA;EjEm+NvB;AACF;AkEz/NA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AlE2/NF;AkEz/NE;EACE,cAAA;EACA,WAAA;AlE2/NJ;AkEx/NE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AlE0/NJ;;AkEj/NI;EACE,yBAAA;AlEo/NN;;AkEr/NI;EACE,mBAAA;AlEw/NN;;AkEz/NI;EACE,gBAAA;AlE4/NN;;AkE7/NI;EACE,iBAAA;AlEggON;;AmEzhOI;EAAgC,8BAAA;AnE6hOpC;;AmE5hOI;EAAgC,iCAAA;AnEgiOpC;;AmE/hOI;EAAgC,sCAAA;AnEmiOpC;;AmEliOI;EAAgC,yCAAA;AnEsiOpC;;AmEpiOI;EAA8B,0BAAA;AnEwiOlC;;AmEviOI;EAA8B,4BAAA;AnE2iOlC;;AmE1iOI;EAA8B,kCAAA;AnE8iOlC;;AmE7iOI;EAA8B,yBAAA;AnEijOlC;;AmEhjOI;EAA8B,uBAAA;AnEojOlC;;AmEnjOI;EAA8B,uBAAA;AnEujOlC;;AmEtjOI;EAA8B,yBAAA;AnE0jOlC;;AmEzjOI;EAA8B,yBAAA;AnE6jOlC;;AmE3jOI;EAAoC,sCAAA;AnE+jOxC;;AmE9jOI;EAAoC,oCAAA;AnEkkOxC;;AmEjkOI;EAAoC,kCAAA;AnEqkOxC;;AmEpkOI;EAAoC,yCAAA;AnEwkOxC;;AmEvkOI;EAAoC,wCAAA;AnE2kOxC;;AmEzkOI;EAAiC,kCAAA;AnE6kOrC;;AmE5kOI;EAAiC,gCAAA;AnEglOrC;;AmE/kOI;EAAiC,8BAAA;AnEmlOrC;;AmEllOI;EAAiC,gCAAA;AnEslOrC;;AmErlOI;EAAiC,+BAAA;AnEylOrC;;AmEvlOI;EAAkC,oCAAA;AnE2lOtC;;AmE1lOI;EAAkC,kCAAA;AnE8lOtC;;AmE7lOI;EAAkC,gCAAA;AnEimOtC;;AmEhmOI;EAAkC,uCAAA;AnEomOtC;;AmEnmOI;EAAkC,sCAAA;AnEumOtC;;AmEtmOI;EAAkC,iCAAA;AnE0mOtC;;AmExmOI;EAAgC,2BAAA;AnE4mOpC;;AmE3mOI;EAAgC,iCAAA;AnE+mOpC;;AmE9mOI;EAAgC,+BAAA;AnEknOpC;;AmEjnOI;EAAgC,6BAAA;AnEqnOpC;;AmEpnOI;EAAgC,+BAAA;AnEwnOpC;;AmEvnOI;EAAgC,8BAAA;AnE2nOpC;;AoB/mOI;E+ClDA;IAAgC,8BAAA;EnEsqOlC;EmErqOE;IAAgC,iCAAA;EnEwqOlC;EmEvqOE;IAAgC,sCAAA;EnE0qOlC;EmEzqOE;IAAgC,yCAAA;EnE4qOlC;EmE1qOE;IAA8B,0BAAA;EnE6qOhC;EmE5qOE;IAA8B,4BAAA;EnE+qOhC;EmE9qOE;IAA8B,kCAAA;EnEirOhC;EmEhrOE;IAA8B,yBAAA;EnEmrOhC;EmElrOE;IAA8B,uBAAA;EnEqrOhC;EmEprOE;IAA8B,uBAAA;EnEurOhC;EmEtrOE;IAA8B,yBAAA;EnEyrOhC;EmExrOE;IAA8B,yBAAA;EnE2rOhC;EmEzrOE;IAAoC,sCAAA;EnE4rOtC;EmE3rOE;IAAoC,oCAAA;EnE8rOtC;EmE7rOE;IAAoC,kCAAA;EnEgsOtC;EmE/rOE;IAAoC,yCAAA;EnEksOtC;EmEjsOE;IAAoC,wCAAA;EnEosOtC;EmElsOE;IAAiC,kCAAA;EnEqsOnC;EmEpsOE;IAAiC,gCAAA;EnEusOnC;EmEtsOE;IAAiC,8BAAA;EnEysOnC;EmExsOE;IAAiC,gCAAA;EnE2sOnC;EmE1sOE;IAAiC,+BAAA;EnE6sOnC;EmE3sOE;IAAkC,oCAAA;EnE8sOpC;EmE7sOE;IAAkC,kCAAA;EnEgtOpC;EmE/sOE;IAAkC,gCAAA;EnEktOpC;EmEjtOE;IAAkC,uCAAA;EnEotOpC;EmEntOE;IAAkC,sCAAA;EnEstOpC;EmErtOE;IAAkC,iCAAA;EnEwtOpC;EmEttOE;IAAgC,2BAAA;EnEytOlC;EmExtOE;IAAgC,iCAAA;EnE2tOlC;EmE1tOE;IAAgC,+BAAA;EnE6tOlC;EmE5tOE;IAAgC,6BAAA;EnE+tOlC;EmE9tOE;IAAgC,+BAAA;EnEiuOlC;EmEhuOE;IAAgC,8BAAA;EnEmuOlC;AACF;AoBxtOI;E+ClDA;IAAgC,8BAAA;EnE8wOlC;EmE7wOE;IAAgC,iCAAA;EnEgxOlC;EmE/wOE;IAAgC,sCAAA;EnEkxOlC;EmEjxOE;IAAgC,yCAAA;EnEoxOlC;EmElxOE;IAA8B,0BAAA;EnEqxOhC;EmEpxOE;IAA8B,4BAAA;EnEuxOhC;EmEtxOE;IAA8B,kCAAA;EnEyxOhC;EmExxOE;IAA8B,yBAAA;EnE2xOhC;EmE1xOE;IAA8B,uBAAA;EnE6xOhC;EmE5xOE;IAA8B,uBAAA;EnE+xOhC;EmE9xOE;IAA8B,yBAAA;EnEiyOhC;EmEhyOE;IAA8B,yBAAA;EnEmyOhC;EmEjyOE;IAAoC,sCAAA;EnEoyOtC;EmEnyOE;IAAoC,oCAAA;EnEsyOtC;EmEryOE;IAAoC,kCAAA;EnEwyOtC;EmEvyOE;IAAoC,yCAAA;EnE0yOtC;EmEzyOE;IAAoC,wCAAA;EnE4yOtC;EmE1yOE;IAAiC,kCAAA;EnE6yOnC;EmE5yOE;IAAiC,gCAAA;EnE+yOnC;EmE9yOE;IAAiC,8BAAA;EnEizOnC;EmEhzOE;IAAiC,gCAAA;EnEmzOnC;EmElzOE;IAAiC,+BAAA;EnEqzOnC;EmEnzOE;IAAkC,oCAAA;EnEszOpC;EmErzOE;IAAkC,kCAAA;EnEwzOpC;EmEvzOE;IAAkC,gCAAA;EnE0zOpC;EmEzzOE;IAAkC,uCAAA;EnE4zOpC;EmE3zOE;IAAkC,sCAAA;EnE8zOpC;EmE7zOE;IAAkC,iCAAA;EnEg0OpC;EmE9zOE;IAAgC,2BAAA;EnEi0OlC;EmEh0OE;IAAgC,iCAAA;EnEm0OlC;EmEl0OE;IAAgC,+BAAA;EnEq0OlC;EmEp0OE;IAAgC,6BAAA;EnEu0OlC;EmEt0OE;IAAgC,+BAAA;EnEy0OlC;EmEx0OE;IAAgC,8BAAA;EnE20OlC;AACF;AoBh0OI;E+ClDA;IAAgC,8BAAA;EnEs3OlC;EmEr3OE;IAAgC,iCAAA;EnEw3OlC;EmEv3OE;IAAgC,sCAAA;EnE03OlC;EmEz3OE;IAAgC,yCAAA;EnE43OlC;EmE13OE;IAA8B,0BAAA;EnE63OhC;EmE53OE;IAA8B,4BAAA;EnE+3OhC;EmE93OE;IAA8B,kCAAA;EnEi4OhC;EmEh4OE;IAA8B,yBAAA;EnEm4OhC;EmEl4OE;IAA8B,uBAAA;EnEq4OhC;EmEp4OE;IAA8B,uBAAA;EnEu4OhC;EmEt4OE;IAA8B,yBAAA;EnEy4OhC;EmEx4OE;IAA8B,yBAAA;EnE24OhC;EmEz4OE;IAAoC,sCAAA;EnE44OtC;EmE34OE;IAAoC,oCAAA;EnE84OtC;EmE74OE;IAAoC,kCAAA;EnEg5OtC;EmE/4OE;IAAoC,yCAAA;EnEk5OtC;EmEj5OE;IAAoC,wCAAA;EnEo5OtC;EmEl5OE;IAAiC,kCAAA;EnEq5OnC;EmEp5OE;IAAiC,gCAAA;EnEu5OnC;EmEt5OE;IAAiC,8BAAA;EnEy5OnC;EmEx5OE;IAAiC,gCAAA;EnE25OnC;EmE15OE;IAAiC,+BAAA;EnE65OnC;EmE35OE;IAAkC,oCAAA;EnE85OpC;EmE75OE;IAAkC,kCAAA;EnEg6OpC;EmE/5OE;IAAkC,gCAAA;EnEk6OpC;EmEj6OE;IAAkC,uCAAA;EnEo6OpC;EmEn6OE;IAAkC,sCAAA;EnEs6OpC;EmEr6OE;IAAkC,iCAAA;EnEw6OpC;EmEt6OE;IAAgC,2BAAA;EnEy6OlC;EmEx6OE;IAAgC,iCAAA;EnE26OlC;EmE16OE;IAAgC,+BAAA;EnE66OlC;EmE56OE;IAAgC,6BAAA;EnE+6OlC;EmE96OE;IAAgC,+BAAA;EnEi7OlC;EmEh7OE;IAAgC,8BAAA;EnEm7OlC;AACF;AoBx6OI;E+ClDA;IAAgC,8BAAA;EnE89OlC;EmE79OE;IAAgC,iCAAA;EnEg+OlC;EmE/9OE;IAAgC,sCAAA;EnEk+OlC;EmEj+OE;IAAgC,yCAAA;EnEo+OlC;EmEl+OE;IAA8B,0BAAA;EnEq+OhC;EmEp+OE;IAA8B,4BAAA;EnEu+OhC;EmEt+OE;IAA8B,kCAAA;EnEy+OhC;EmEx+OE;IAA8B,yBAAA;EnE2+OhC;EmE1+OE;IAA8B,uBAAA;EnE6+OhC;EmE5+OE;IAA8B,uBAAA;EnE++OhC;EmE9+OE;IAA8B,yBAAA;EnEi/OhC;EmEh/OE;IAA8B,yBAAA;EnEm/OhC;EmEj/OE;IAAoC,sCAAA;EnEo/OtC;EmEn/OE;IAAoC,oCAAA;EnEs/OtC;EmEr/OE;IAAoC,kCAAA;EnEw/OtC;EmEv/OE;IAAoC,yCAAA;EnE0/OtC;EmEz/OE;IAAoC,wCAAA;EnE4/OtC;EmE1/OE;IAAiC,kCAAA;EnE6/OnC;EmE5/OE;IAAiC,gCAAA;EnE+/OnC;EmE9/OE;IAAiC,8BAAA;EnEigPnC;EmEhgPE;IAAiC,gCAAA;EnEmgPnC;EmElgPE;IAAiC,+BAAA;EnEqgPnC;EmEngPE;IAAkC,oCAAA;EnEsgPpC;EmErgPE;IAAkC,kCAAA;EnEwgPpC;EmEvgPE;IAAkC,gCAAA;EnE0gPpC;EmEzgPE;IAAkC,uCAAA;EnE4gPpC;EmE3gPE;IAAkC,sCAAA;EnE8gPpC;EmE7gPE;IAAkC,iCAAA;EnEghPpC;EmE9gPE;IAAgC,2BAAA;EnEihPlC;EmEhhPE;IAAgC,iCAAA;EnEmhPlC;EmElhPE;IAAgC,+BAAA;EnEqhPlC;EmEphPE;IAAgC,6BAAA;EnEuhPlC;EmEthPE;IAAgC,+BAAA;EnEyhPlC;EmExhPE;IAAgC,8BAAA;EnE2hPlC;AACF;AoEtkPI;EAAwB,sBAAA;ApEykP5B;;AoExkPI;EAAwB,uBAAA;ApE4kP5B;;AoE3kPI;EAAwB,sBAAA;ApE+kP5B;;AoB3hPI;EgDtDA;IAAwB,sBAAA;EpEslP1B;EoErlPE;IAAwB,uBAAA;EpEwlP1B;EoEvlPE;IAAwB,sBAAA;EpE0lP1B;AACF;AoBviPI;EgDtDA;IAAwB,sBAAA;EpEimP1B;EoEhmPE;IAAwB,uBAAA;EpEmmP1B;EoElmPE;IAAwB,sBAAA;EpEqmP1B;AACF;AoBljPI;EgDtDA;IAAwB,sBAAA;EpE4mP1B;EoE3mPE;IAAwB,uBAAA;EpE8mP1B;EoE7mPE;IAAwB,sBAAA;EpEgnP1B;AACF;AoB7jPI;EgDtDA;IAAwB,sBAAA;EpEunP1B;EoEtnPE;IAAwB,uBAAA;EpEynP1B;EoExnPE;IAAwB,sBAAA;EpE2nP1B;AACF;AqEjoPE;EAAyB,mCAAA;UAAA,2BAAA;ArEooP3B;;AqEpoPE;EAAyB,oCAAA;UAAA,4BAAA;ArEwoP3B;;AqExoPE;EAAyB,oCAAA;UAAA,4BAAA;ArE4oP3B;;AsE5oPE;EAAsB,yBAAA;AtEgpPxB;;AsEhpPE;EAAsB,2BAAA;AtEopPxB;;AuEnpPE;EAAyB,2BAAA;AvEupP3B;;AuEvpPE;EAAyB,6BAAA;AvE2pP3B;;AuE3pPE;EAAyB,6BAAA;AvE+pP3B;;AuE/pPE;EAAyB,0BAAA;AvEmqP3B;;AuEnqPE;EAAyB,2BAAA;AvEuqP3B;;AuElqPA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a9DiqBkC;ATogOpC;;AuElqPA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a9DypBkC;AT4gOpC;;AuEjqPE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a9DipBgC;ETohOlC;AACF;;AwE/rPA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AzEisPF;;AyEvrPE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AzEyrPJ;;A0EttPA;EAAa,8DAAA;A1E0tPb;;A0EztPA;EAAU,wDAAA;A1E6tPV;;A0E5tPA;EAAa,uDAAA;A1EguPb;;A0E/tPA;EAAe,2BAAA;A1EmuPf;;A2EluPI;EAAuB,qBAAA;A3EsuP3B;;A2EtuPI;EAAuB,qBAAA;A3E0uP3B;;A2E1uPI;EAAuB,qBAAA;A3E8uP3B;;A2E9uPI;EAAuB,sBAAA;A3EkvP3B;;A2ElvPI;EAAuB,sBAAA;A3EsvP3B;;A2EtvPI;EAAuB,sBAAA;A3E0vP3B;;A2E1vPI;EAAuB,sBAAA;A3E8vP3B;;A2E9vPI;EAAuB,sBAAA;A3EkwP3B;;A2ElwPI;EAAuB,uBAAA;A3EswP3B;;A2EtwPI;EAAuB,uBAAA;A3E0wP3B;;A2EtwPA;EAAU,0BAAA;A3E0wPV;;A2EzwPA;EAAU,2BAAA;A3E6wPV;;A2EzwPA;EAAc,2BAAA;A3E6wPd;;A2E5wPA;EAAc,4BAAA;A3EgxPd;;A2E9wPA;EAAU,uBAAA;A3EkxPV;;A2EjxPA;EAAU,wBAAA;A3EqxPV;;A4E9xPQ;EAAgC,oBAAA;A5EkyPxC;;A4EjyPQ;;EAEE,wBAAA;A5EoyPV;;A4ElyPQ;;EAEE,0BAAA;A5EqyPV;;A4EnyPQ;;EAEE,2BAAA;A5EsyPV;;A4EpyPQ;;EAEE,yBAAA;A5EuyPV;;A4EtzPQ;EAAgC,0BAAA;A5E0zPxC;;A4EzzPQ;;EAEE,8BAAA;A5E4zPV;;A4E1zPQ;;EAEE,gCAAA;A5E6zPV;;A4E3zPQ;;EAEE,iCAAA;A5E8zPV;;A4E5zPQ;;EAEE,+BAAA;A5E+zPV;;A4E90PQ;EAAgC,yBAAA;A5Ek1PxC;;A4Ej1PQ;;EAEE,6BAAA;A5Eo1PV;;A4El1PQ;;EAEE,+BAAA;A5Eq1PV;;A4En1PQ;;EAEE,gCAAA;A5Es1PV;;A4Ep1PQ;;EAEE,8BAAA;A5Eu1PV;;A4Et2PQ;EAAgC,uBAAA;A5E02PxC;;A4Ez2PQ;;EAEE,2BAAA;A5E42PV;;A4E12PQ;;EAEE,6BAAA;A5E62PV;;A4E32PQ;;EAEE,8BAAA;A5E82PV;;A4E52PQ;;EAEE,4BAAA;A5E+2PV;;A4E93PQ;EAAgC,yBAAA;A5Ek4PxC;;A4Ej4PQ;;EAEE,6BAAA;A5Eo4PV;;A4El4PQ;;EAEE,+BAAA;A5Eq4PV;;A4En4PQ;;EAEE,gCAAA;A5Es4PV;;A4Ep4PQ;;EAEE,8BAAA;A5Eu4PV;;A4Et5PQ;EAAgC,uBAAA;A5E05PxC;;A4Ez5PQ;;EAEE,2BAAA;A5E45PV;;A4E15PQ;;EAEE,6BAAA;A5E65PV;;A4E35PQ;;EAEE,8BAAA;A5E85PV;;A4E55PQ;;EAEE,4BAAA;A5E+5PV;;A4E96PQ;EAAgC,qBAAA;A5Ek7PxC;;A4Ej7PQ;;EAEE,yBAAA;A5Eo7PV;;A4El7PQ;;EAEE,2BAAA;A5Eq7PV;;A4En7PQ;;EAEE,4BAAA;A5Es7PV;;A4Ep7PQ;;EAEE,0BAAA;A5Eu7PV;;A4Et8PQ;EAAgC,2BAAA;A5E08PxC;;A4Ez8PQ;;EAEE,+BAAA;A5E48PV;;A4E18PQ;;EAEE,iCAAA;A5E68PV;;A4E38PQ;;EAEE,kCAAA;A5E88PV;;A4E58PQ;;EAEE,gCAAA;A5E+8PV;;A4E99PQ;EAAgC,0BAAA;A5Ek+PxC;;A4Ej+PQ;;EAEE,8BAAA;A5Eo+PV;;A4El+PQ;;EAEE,gCAAA;A5Eq+PV;;A4En+PQ;;EAEE,iCAAA;A5Es+PV;;A4Ep+PQ;;EAEE,+BAAA;A5Eu+PV;;A4Et/PQ;EAAgC,wBAAA;A5E0/PxC;;A4Ez/PQ;;EAEE,4BAAA;A5E4/PV;;A4E1/PQ;;EAEE,8BAAA;A5E6/PV;;A4E3/PQ;;EAEE,+BAAA;A5E8/PV;;A4E5/PQ;;EAEE,6BAAA;A5E+/PV;;A4E9gQQ;EAAgC,0BAAA;A5EkhQxC;;A4EjhQQ;;EAEE,8BAAA;A5EohQV;;A4ElhQQ;;EAEE,gCAAA;A5EqhQV;;A4EnhQQ;;EAEE,iCAAA;A5EshQV;;A4EphQQ;;EAEE,+BAAA;A5EuhQV;;A4EtiQQ;EAAgC,wBAAA;A5E0iQxC;;A4EziQQ;;EAEE,4BAAA;A5E4iQV;;A4E1iQQ;;EAEE,8BAAA;A5E6iQV;;A4E3iQQ;;EAEE,+BAAA;A5E8iQV;;A4E5iQQ;;EAEE,6BAAA;A5E+iQV;;A4EviQQ;EAAwB,2BAAA;A5E2iQhC;;A4E1iQQ;;EAEE,+BAAA;A5E6iQV;;A4E3iQQ;;EAEE,iCAAA;A5E8iQV;;A4E5iQQ;;EAEE,kCAAA;A5E+iQV;;A4E7iQQ;;EAEE,gCAAA;A5EgjQV;;A4E/jQQ;EAAwB,0BAAA;A5EmkQhC;;A4ElkQQ;;EAEE,8BAAA;A5EqkQV;;A4EnkQQ;;EAEE,gCAAA;A5EskQV;;A4EpkQQ;;EAEE,iCAAA;A5EukQV;;A4ErkQQ;;EAEE,+BAAA;A5EwkQV;;A4EvlQQ;EAAwB,wBAAA;A5E2lQhC;;A4E1lQQ;;EAEE,4BAAA;A5E6lQV;;A4E3lQQ;;EAEE,8BAAA;A5E8lQV;;A4E5lQQ;;EAEE,+BAAA;A5E+lQV;;A4E7lQQ;;EAEE,6BAAA;A5EgmQV;;A4E/mQQ;EAAwB,0BAAA;A5EmnQhC;;A4ElnQQ;;EAEE,8BAAA;A5EqnQV;;A4EnnQQ;;EAEE,gCAAA;A5EsnQV;;A4EpnQQ;;EAEE,iCAAA;A5EunQV;;A4ErnQQ;;EAEE,+BAAA;A5EwnQV;;A4EvoQQ;EAAwB,wBAAA;A5E2oQhC;;A4E1oQQ;;EAEE,4BAAA;A5E6oQV;;A4E3oQQ;;EAEE,8BAAA;A5E8oQV;;A4E5oQQ;;EAEE,+BAAA;A5E+oQV;;A4E7oQQ;;EAEE,6BAAA;A5EgpQV;;A4E1oQI;EAAmB,uBAAA;A5E8oQvB;;A4E7oQI;;EAEE,2BAAA;A5EgpQN;;A4E9oQI;;EAEE,6BAAA;A5EipQN;;A4E/oQI;;EAEE,8BAAA;A5EkpQN;;A4EhpQI;;EAEE,4BAAA;A5EmpQN;;AoB5pQI;EwDlDI;IAAgC,oBAAA;E5EmtQtC;E4EltQM;;IAEE,wBAAA;E5EotQR;E4EltQM;;IAEE,0BAAA;E5EotQR;E4EltQM;;IAEE,2BAAA;E5EotQR;E4EltQM;;IAEE,yBAAA;E5EotQR;E4EnuQM;IAAgC,0BAAA;E5EsuQtC;E4EruQM;;IAEE,8BAAA;E5EuuQR;E4EruQM;;IAEE,gCAAA;E5EuuQR;E4EruQM;;IAEE,iCAAA;E5EuuQR;E4EruQM;;IAEE,+BAAA;E5EuuQR;E4EtvQM;IAAgC,yBAAA;E5EyvQtC;E4ExvQM;;IAEE,6BAAA;E5E0vQR;E4ExvQM;;IAEE,+BAAA;E5E0vQR;E4ExvQM;;IAEE,gCAAA;E5E0vQR;E4ExvQM;;IAEE,8BAAA;E5E0vQR;E4EzwQM;IAAgC,uBAAA;E5E4wQtC;E4E3wQM;;IAEE,2BAAA;E5E6wQR;E4E3wQM;;IAEE,6BAAA;E5E6wQR;E4E3wQM;;IAEE,8BAAA;E5E6wQR;E4E3wQM;;IAEE,4BAAA;E5E6wQR;E4E5xQM;IAAgC,yBAAA;E5E+xQtC;E4E9xQM;;IAEE,6BAAA;E5EgyQR;E4E9xQM;;IAEE,+BAAA;E5EgyQR;E4E9xQM;;IAEE,gCAAA;E5EgyQR;E4E9xQM;;IAEE,8BAAA;E5EgyQR;E4E/yQM;IAAgC,uBAAA;E5EkzQtC;E4EjzQM;;IAEE,2BAAA;E5EmzQR;E4EjzQM;;IAEE,6BAAA;E5EmzQR;E4EjzQM;;IAEE,8BAAA;E5EmzQR;E4EjzQM;;IAEE,4BAAA;E5EmzQR;E4El0QM;IAAgC,qBAAA;E5Eq0QtC;E4Ep0QM;;IAEE,yBAAA;E5Es0QR;E4Ep0QM;;IAEE,2BAAA;E5Es0QR;E4Ep0QM;;IAEE,4BAAA;E5Es0QR;E4Ep0QM;;IAEE,0BAAA;E5Es0QR;E4Er1QM;IAAgC,2BAAA;E5Ew1QtC;E4Ev1QM;;IAEE,+BAAA;E5Ey1QR;E4Ev1QM;;IAEE,iCAAA;E5Ey1QR;E4Ev1QM;;IAEE,kCAAA;E5Ey1QR;E4Ev1QM;;IAEE,gCAAA;E5Ey1QR;E4Ex2QM;IAAgC,0BAAA;E5E22QtC;E4E12QM;;IAEE,8BAAA;E5E42QR;E4E12QM;;IAEE,gCAAA;E5E42QR;E4E12QM;;IAEE,iCAAA;E5E42QR;E4E12QM;;IAEE,+BAAA;E5E42QR;E4E33QM;IAAgC,wBAAA;E5E83QtC;E4E73QM;;IAEE,4BAAA;E5E+3QR;E4E73QM;;IAEE,8BAAA;E5E+3QR;E4E73QM;;IAEE,+BAAA;E5E+3QR;E4E73QM;;IAEE,6BAAA;E5E+3QR;E4E94QM;IAAgC,0BAAA;E5Ei5QtC;E4Eh5QM;;IAEE,8BAAA;E5Ek5QR;E4Eh5QM;;IAEE,gCAAA;E5Ek5QR;E4Eh5QM;;IAEE,iCAAA;E5Ek5QR;E4Eh5QM;;IAEE,+BAAA;E5Ek5QR;E4Ej6QM;IAAgC,wBAAA;E5Eo6QtC;E4En6QM;;IAEE,4BAAA;E5Eq6QR;E4En6QM;;IAEE,8BAAA;E5Eq6QR;E4En6QM;;IAEE,+BAAA;E5Eq6QR;E4En6QM;;IAEE,6BAAA;E5Eq6QR;E4E75QM;IAAwB,2BAAA;E5Eg6Q9B;E4E/5QM;;IAEE,+BAAA;E5Ei6QR;E4E/5QM;;IAEE,iCAAA;E5Ei6QR;E4E/5QM;;IAEE,kCAAA;E5Ei6QR;E4E/5QM;;IAEE,gCAAA;E5Ei6QR;E4Eh7QM;IAAwB,0BAAA;E5Em7Q9B;E4El7QM;;IAEE,8BAAA;E5Eo7QR;E4El7QM;;IAEE,gCAAA;E5Eo7QR;E4El7QM;;IAEE,iCAAA;E5Eo7QR;E4El7QM;;IAEE,+BAAA;E5Eo7QR;E4En8QM;IAAwB,wBAAA;E5Es8Q9B;E4Er8QM;;IAEE,4BAAA;E5Eu8QR;E4Er8QM;;IAEE,8BAAA;E5Eu8QR;E4Er8QM;;IAEE,+BAAA;E5Eu8QR;E4Er8QM;;IAEE,6BAAA;E5Eu8QR;E4Et9QM;IAAwB,0BAAA;E5Ey9Q9B;E4Ex9QM;;IAEE,8BAAA;E5E09QR;E4Ex9QM;;IAEE,gCAAA;E5E09QR;E4Ex9QM;;IAEE,iCAAA;E5E09QR;E4Ex9QM;;IAEE,+BAAA;E5E09QR;E4Ez+QM;IAAwB,wBAAA;E5E4+Q9B;E4E3+QM;;IAEE,4BAAA;E5E6+QR;E4E3+QM;;IAEE,8BAAA;E5E6+QR;E4E3+QM;;IAEE,+BAAA;E5E6+QR;E4E3+QM;;IAEE,6BAAA;E5E6+QR;E4Ev+QE;IAAmB,uBAAA;E5E0+QrB;E4Ez+QE;;IAEE,2BAAA;E5E2+QJ;E4Ez+QE;;IAEE,6BAAA;E5E2+QJ;E4Ez+QE;;IAEE,8BAAA;E5E2+QJ;E4Ez+QE;;IAEE,4BAAA;E5E2+QJ;AACF;AoBr/QI;EwDlDI;IAAgC,oBAAA;E5E2iRtC;E4E1iRM;;IAEE,wBAAA;E5E4iRR;E4E1iRM;;IAEE,0BAAA;E5E4iRR;E4E1iRM;;IAEE,2BAAA;E5E4iRR;E4E1iRM;;IAEE,yBAAA;E5E4iRR;E4E3jRM;IAAgC,0BAAA;E5E8jRtC;E4E7jRM;;IAEE,8BAAA;E5E+jRR;E4E7jRM;;IAEE,gCAAA;E5E+jRR;E4E7jRM;;IAEE,iCAAA;E5E+jRR;E4E7jRM;;IAEE,+BAAA;E5E+jRR;E4E9kRM;IAAgC,yBAAA;E5EilRtC;E4EhlRM;;IAEE,6BAAA;E5EklRR;E4EhlRM;;IAEE,+BAAA;E5EklRR;E4EhlRM;;IAEE,gCAAA;E5EklRR;E4EhlRM;;IAEE,8BAAA;E5EklRR;E4EjmRM;IAAgC,uBAAA;E5EomRtC;E4EnmRM;;IAEE,2BAAA;E5EqmRR;E4EnmRM;;IAEE,6BAAA;E5EqmRR;E4EnmRM;;IAEE,8BAAA;E5EqmRR;E4EnmRM;;IAEE,4BAAA;E5EqmRR;E4EpnRM;IAAgC,yBAAA;E5EunRtC;E4EtnRM;;IAEE,6BAAA;E5EwnRR;E4EtnRM;;IAEE,+BAAA;E5EwnRR;E4EtnRM;;IAEE,gCAAA;E5EwnRR;E4EtnRM;;IAEE,8BAAA;E5EwnRR;E4EvoRM;IAAgC,uBAAA;E5E0oRtC;E4EzoRM;;IAEE,2BAAA;E5E2oRR;E4EzoRM;;IAEE,6BAAA;E5E2oRR;E4EzoRM;;IAEE,8BAAA;E5E2oRR;E4EzoRM;;IAEE,4BAAA;E5E2oRR;E4E1pRM;IAAgC,qBAAA;E5E6pRtC;E4E5pRM;;IAEE,yBAAA;E5E8pRR;E4E5pRM;;IAEE,2BAAA;E5E8pRR;E4E5pRM;;IAEE,4BAAA;E5E8pRR;E4E5pRM;;IAEE,0BAAA;E5E8pRR;E4E7qRM;IAAgC,2BAAA;E5EgrRtC;E4E/qRM;;IAEE,+BAAA;E5EirRR;E4E/qRM;;IAEE,iCAAA;E5EirRR;E4E/qRM;;IAEE,kCAAA;E5EirRR;E4E/qRM;;IAEE,gCAAA;E5EirRR;E4EhsRM;IAAgC,0BAAA;E5EmsRtC;E4ElsRM;;IAEE,8BAAA;E5EosRR;E4ElsRM;;IAEE,gCAAA;E5EosRR;E4ElsRM;;IAEE,iCAAA;E5EosRR;E4ElsRM;;IAEE,+BAAA;E5EosRR;E4EntRM;IAAgC,wBAAA;E5EstRtC;E4ErtRM;;IAEE,4BAAA;E5EutRR;E4ErtRM;;IAEE,8BAAA;E5EutRR;E4ErtRM;;IAEE,+BAAA;E5EutRR;E4ErtRM;;IAEE,6BAAA;E5EutRR;E4EtuRM;IAAgC,0BAAA;E5EyuRtC;E4ExuRM;;IAEE,8BAAA;E5E0uRR;E4ExuRM;;IAEE,gCAAA;E5E0uRR;E4ExuRM;;IAEE,iCAAA;E5E0uRR;E4ExuRM;;IAEE,+BAAA;E5E0uRR;E4EzvRM;IAAgC,wBAAA;E5E4vRtC;E4E3vRM;;IAEE,4BAAA;E5E6vRR;E4E3vRM;;IAEE,8BAAA;E5E6vRR;E4E3vRM;;IAEE,+BAAA;E5E6vRR;E4E3vRM;;IAEE,6BAAA;E5E6vRR;E4ErvRM;IAAwB,2BAAA;E5EwvR9B;E4EvvRM;;IAEE,+BAAA;E5EyvRR;E4EvvRM;;IAEE,iCAAA;E5EyvRR;E4EvvRM;;IAEE,kCAAA;E5EyvRR;E4EvvRM;;IAEE,gCAAA;E5EyvRR;E4ExwRM;IAAwB,0BAAA;E5E2wR9B;E4E1wRM;;IAEE,8BAAA;E5E4wRR;E4E1wRM;;IAEE,gCAAA;E5E4wRR;E4E1wRM;;IAEE,iCAAA;E5E4wRR;E4E1wRM;;IAEE,+BAAA;E5E4wRR;E4E3xRM;IAAwB,wBAAA;E5E8xR9B;E4E7xRM;;IAEE,4BAAA;E5E+xRR;E4E7xRM;;IAEE,8BAAA;E5E+xRR;E4E7xRM;;IAEE,+BAAA;E5E+xRR;E4E7xRM;;IAEE,6BAAA;E5E+xRR;E4E9yRM;IAAwB,0BAAA;E5EizR9B;E4EhzRM;;IAEE,8BAAA;E5EkzRR;E4EhzRM;;IAEE,gCAAA;E5EkzRR;E4EhzRM;;IAEE,iCAAA;E5EkzRR;E4EhzRM;;IAEE,+BAAA;E5EkzRR;E4Ej0RM;IAAwB,wBAAA;E5Eo0R9B;E4En0RM;;IAEE,4BAAA;E5Eq0RR;E4En0RM;;IAEE,8BAAA;E5Eq0RR;E4En0RM;;IAEE,+BAAA;E5Eq0RR;E4En0RM;;IAEE,6BAAA;E5Eq0RR;E4E/zRE;IAAmB,uBAAA;E5Ek0RrB;E4Ej0RE;;IAEE,2BAAA;E5Em0RJ;E4Ej0RE;;IAEE,6BAAA;E5Em0RJ;E4Ej0RE;;IAEE,8BAAA;E5Em0RJ;E4Ej0RE;;IAEE,4BAAA;E5Em0RJ;AACF;AoB70RI;EwDlDI;IAAgC,oBAAA;E5Em4RtC;E4El4RM;;IAEE,wBAAA;E5Eo4RR;E4El4RM;;IAEE,0BAAA;E5Eo4RR;E4El4RM;;IAEE,2BAAA;E5Eo4RR;E4El4RM;;IAEE,yBAAA;E5Eo4RR;E4En5RM;IAAgC,0BAAA;E5Es5RtC;E4Er5RM;;IAEE,8BAAA;E5Eu5RR;E4Er5RM;;IAEE,gCAAA;E5Eu5RR;E4Er5RM;;IAEE,iCAAA;E5Eu5RR;E4Er5RM;;IAEE,+BAAA;E5Eu5RR;E4Et6RM;IAAgC,yBAAA;E5Ey6RtC;E4Ex6RM;;IAEE,6BAAA;E5E06RR;E4Ex6RM;;IAEE,+BAAA;E5E06RR;E4Ex6RM;;IAEE,gCAAA;E5E06RR;E4Ex6RM;;IAEE,8BAAA;E5E06RR;E4Ez7RM;IAAgC,uBAAA;E5E47RtC;E4E37RM;;IAEE,2BAAA;E5E67RR;E4E37RM;;IAEE,6BAAA;E5E67RR;E4E37RM;;IAEE,8BAAA;E5E67RR;E4E37RM;;IAEE,4BAAA;E5E67RR;E4E58RM;IAAgC,yBAAA;E5E+8RtC;E4E98RM;;IAEE,6BAAA;E5Eg9RR;E4E98RM;;IAEE,+BAAA;E5Eg9RR;E4E98RM;;IAEE,gCAAA;E5Eg9RR;E4E98RM;;IAEE,8BAAA;E5Eg9RR;E4E/9RM;IAAgC,uBAAA;E5Ek+RtC;E4Ej+RM;;IAEE,2BAAA;E5Em+RR;E4Ej+RM;;IAEE,6BAAA;E5Em+RR;E4Ej+RM;;IAEE,8BAAA;E5Em+RR;E4Ej+RM;;IAEE,4BAAA;E5Em+RR;E4El/RM;IAAgC,qBAAA;E5Eq/RtC;E4Ep/RM;;IAEE,yBAAA;E5Es/RR;E4Ep/RM;;IAEE,2BAAA;E5Es/RR;E4Ep/RM;;IAEE,4BAAA;E5Es/RR;E4Ep/RM;;IAEE,0BAAA;E5Es/RR;E4ErgSM;IAAgC,2BAAA;E5EwgStC;E4EvgSM;;IAEE,+BAAA;E5EygSR;E4EvgSM;;IAEE,iCAAA;E5EygSR;E4EvgSM;;IAEE,kCAAA;E5EygSR;E4EvgSM;;IAEE,gCAAA;E5EygSR;E4ExhSM;IAAgC,0BAAA;E5E2hStC;E4E1hSM;;IAEE,8BAAA;E5E4hSR;E4E1hSM;;IAEE,gCAAA;E5E4hSR;E4E1hSM;;IAEE,iCAAA;E5E4hSR;E4E1hSM;;IAEE,+BAAA;E5E4hSR;E4E3iSM;IAAgC,wBAAA;E5E8iStC;E4E7iSM;;IAEE,4BAAA;E5E+iSR;E4E7iSM;;IAEE,8BAAA;E5E+iSR;E4E7iSM;;IAEE,+BAAA;E5E+iSR;E4E7iSM;;IAEE,6BAAA;E5E+iSR;E4E9jSM;IAAgC,0BAAA;E5EikStC;E4EhkSM;;IAEE,8BAAA;E5EkkSR;E4EhkSM;;IAEE,gCAAA;E5EkkSR;E4EhkSM;;IAEE,iCAAA;E5EkkSR;E4EhkSM;;IAEE,+BAAA;E5EkkSR;E4EjlSM;IAAgC,wBAAA;E5EolStC;E4EnlSM;;IAEE,4BAAA;E5EqlSR;E4EnlSM;;IAEE,8BAAA;E5EqlSR;E4EnlSM;;IAEE,+BAAA;E5EqlSR;E4EnlSM;;IAEE,6BAAA;E5EqlSR;E4E7kSM;IAAwB,2BAAA;E5EglS9B;E4E/kSM;;IAEE,+BAAA;E5EilSR;E4E/kSM;;IAEE,iCAAA;E5EilSR;E4E/kSM;;IAEE,kCAAA;E5EilSR;E4E/kSM;;IAEE,gCAAA;E5EilSR;E4EhmSM;IAAwB,0BAAA;E5EmmS9B;E4ElmSM;;IAEE,8BAAA;E5EomSR;E4ElmSM;;IAEE,gCAAA;E5EomSR;E4ElmSM;;IAEE,iCAAA;E5EomSR;E4ElmSM;;IAEE,+BAAA;E5EomSR;E4EnnSM;IAAwB,wBAAA;E5EsnS9B;E4ErnSM;;IAEE,4BAAA;E5EunSR;E4ErnSM;;IAEE,8BAAA;E5EunSR;E4ErnSM;;IAEE,+BAAA;E5EunSR;E4ErnSM;;IAEE,6BAAA;E5EunSR;E4EtoSM;IAAwB,0BAAA;E5EyoS9B;E4ExoSM;;IAEE,8BAAA;E5E0oSR;E4ExoSM;;IAEE,gCAAA;E5E0oSR;E4ExoSM;;IAEE,iCAAA;E5E0oSR;E4ExoSM;;IAEE,+BAAA;E5E0oSR;E4EzpSM;IAAwB,wBAAA;E5E4pS9B;E4E3pSM;;IAEE,4BAAA;E5E6pSR;E4E3pSM;;IAEE,8BAAA;E5E6pSR;E4E3pSM;;IAEE,+BAAA;E5E6pSR;E4E3pSM;;IAEE,6BAAA;E5E6pSR;E4EvpSE;IAAmB,uBAAA;E5E0pSrB;E4EzpSE;;IAEE,2BAAA;E5E2pSJ;E4EzpSE;;IAEE,6BAAA;E5E2pSJ;E4EzpSE;;IAEE,8BAAA;E5E2pSJ;E4EzpSE;;IAEE,4BAAA;E5E2pSJ;AACF;AoBrqSI;EwDlDI;IAAgC,oBAAA;E5E2tStC;E4E1tSM;;IAEE,wBAAA;E5E4tSR;E4E1tSM;;IAEE,0BAAA;E5E4tSR;E4E1tSM;;IAEE,2BAAA;E5E4tSR;E4E1tSM;;IAEE,yBAAA;E5E4tSR;E4E3uSM;IAAgC,0BAAA;E5E8uStC;E4E7uSM;;IAEE,8BAAA;E5E+uSR;E4E7uSM;;IAEE,gCAAA;E5E+uSR;E4E7uSM;;IAEE,iCAAA;E5E+uSR;E4E7uSM;;IAEE,+BAAA;E5E+uSR;E4E9vSM;IAAgC,yBAAA;E5EiwStC;E4EhwSM;;IAEE,6BAAA;E5EkwSR;E4EhwSM;;IAEE,+BAAA;E5EkwSR;E4EhwSM;;IAEE,gCAAA;E5EkwSR;E4EhwSM;;IAEE,8BAAA;E5EkwSR;E4EjxSM;IAAgC,uBAAA;E5EoxStC;E4EnxSM;;IAEE,2BAAA;E5EqxSR;E4EnxSM;;IAEE,6BAAA;E5EqxSR;E4EnxSM;;IAEE,8BAAA;E5EqxSR;E4EnxSM;;IAEE,4BAAA;E5EqxSR;E4EpySM;IAAgC,yBAAA;E5EuyStC;E4EtySM;;IAEE,6BAAA;E5EwySR;E4EtySM;;IAEE,+BAAA;E5EwySR;E4EtySM;;IAEE,gCAAA;E5EwySR;E4EtySM;;IAEE,8BAAA;E5EwySR;E4EvzSM;IAAgC,uBAAA;E5E0zStC;E4EzzSM;;IAEE,2BAAA;E5E2zSR;E4EzzSM;;IAEE,6BAAA;E5E2zSR;E4EzzSM;;IAEE,8BAAA;E5E2zSR;E4EzzSM;;IAEE,4BAAA;E5E2zSR;E4E10SM;IAAgC,qBAAA;E5E60StC;E4E50SM;;IAEE,yBAAA;E5E80SR;E4E50SM;;IAEE,2BAAA;E5E80SR;E4E50SM;;IAEE,4BAAA;E5E80SR;E4E50SM;;IAEE,0BAAA;E5E80SR;E4E71SM;IAAgC,2BAAA;E5Eg2StC;E4E/1SM;;IAEE,+BAAA;E5Ei2SR;E4E/1SM;;IAEE,iCAAA;E5Ei2SR;E4E/1SM;;IAEE,kCAAA;E5Ei2SR;E4E/1SM;;IAEE,gCAAA;E5Ei2SR;E4Eh3SM;IAAgC,0BAAA;E5Em3StC;E4El3SM;;IAEE,8BAAA;E5Eo3SR;E4El3SM;;IAEE,gCAAA;E5Eo3SR;E4El3SM;;IAEE,iCAAA;E5Eo3SR;E4El3SM;;IAEE,+BAAA;E5Eo3SR;E4En4SM;IAAgC,wBAAA;E5Es4StC;E4Er4SM;;IAEE,4BAAA;E5Eu4SR;E4Er4SM;;IAEE,8BAAA;E5Eu4SR;E4Er4SM;;IAEE,+BAAA;E5Eu4SR;E4Er4SM;;IAEE,6BAAA;E5Eu4SR;E4Et5SM;IAAgC,0BAAA;E5Ey5StC;E4Ex5SM;;IAEE,8BAAA;E5E05SR;E4Ex5SM;;IAEE,gCAAA;E5E05SR;E4Ex5SM;;IAEE,iCAAA;E5E05SR;E4Ex5SM;;IAEE,+BAAA;E5E05SR;E4Ez6SM;IAAgC,wBAAA;E5E46StC;E4E36SM;;IAEE,4BAAA;E5E66SR;E4E36SM;;IAEE,8BAAA;E5E66SR;E4E36SM;;IAEE,+BAAA;E5E66SR;E4E36SM;;IAEE,6BAAA;E5E66SR;E4Er6SM;IAAwB,2BAAA;E5Ew6S9B;E4Ev6SM;;IAEE,+BAAA;E5Ey6SR;E4Ev6SM;;IAEE,iCAAA;E5Ey6SR;E4Ev6SM;;IAEE,kCAAA;E5Ey6SR;E4Ev6SM;;IAEE,gCAAA;E5Ey6SR;E4Ex7SM;IAAwB,0BAAA;E5E27S9B;E4E17SM;;IAEE,8BAAA;E5E47SR;E4E17SM;;IAEE,gCAAA;E5E47SR;E4E17SM;;IAEE,iCAAA;E5E47SR;E4E17SM;;IAEE,+BAAA;E5E47SR;E4E38SM;IAAwB,wBAAA;E5E88S9B;E4E78SM;;IAEE,4BAAA;E5E+8SR;E4E78SM;;IAEE,8BAAA;E5E+8SR;E4E78SM;;IAEE,+BAAA;E5E+8SR;E4E78SM;;IAEE,6BAAA;E5E+8SR;E4E99SM;IAAwB,0BAAA;E5Ei+S9B;E4Eh+SM;;IAEE,8BAAA;E5Ek+SR;E4Eh+SM;;IAEE,gCAAA;E5Ek+SR;E4Eh+SM;;IAEE,iCAAA;E5Ek+SR;E4Eh+SM;;IAEE,+BAAA;E5Ek+SR;E4Ej/SM;IAAwB,wBAAA;E5Eo/S9B;E4En/SM;;IAEE,4BAAA;E5Eq/SR;E4En/SM;;IAEE,8BAAA;E5Eq/SR;E4En/SM;;IAEE,+BAAA;E5Eq/SR;E4En/SM;;IAEE,6BAAA;E5Eq/SR;E4E/+SE;IAAmB,uBAAA;E5Ek/SrB;E4Ej/SE;;IAEE,2BAAA;E5Em/SJ;E4Ej/SE;;IAEE,6BAAA;E5Em/SJ;E4Ej/SE;;IAEE,8BAAA;E5Em/SJ;E4Ej/SE;;IAEE,4BAAA;E5Em/SJ;AACF;A6EpjTE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;A7EojTJ;;A8E9jTA;EAAkB,4GAAA;A9EkkTlB;;A8E9jTA;EAAiB,8BAAA;A9EkkTjB;;A8EjkTA;EAAiB,8BAAA;A9EqkTjB;;A8EpkTA;EAAiB,8BAAA;A9EwkTjB;;A8EvkTA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A/EolTF;;A8ErkTI;EAAwB,2BAAA;A9EykT5B;;A8ExkTI;EAAwB,4BAAA;A9E4kT5B;;A8E3kTI;EAAwB,6BAAA;A9E+kT5B;;AoB1iTI;E0DvCA;IAAwB,2BAAA;E9EslT1B;E8ErlTE;IAAwB,4BAAA;E9EwlT1B;E8EvlTE;IAAwB,6BAAA;E9E0lT1B;AACF;AoBtjTI;E0DvCA;IAAwB,2BAAA;E9EimT1B;E8EhmTE;IAAwB,4BAAA;E9EmmT1B;E8ElmTE;IAAwB,6BAAA;E9EqmT1B;AACF;AoBjkTI;E0DvCA;IAAwB,2BAAA;E9E4mT1B;E8E3mTE;IAAwB,4BAAA;E9E8mT1B;E8E7mTE;IAAwB,6BAAA;E9EgnT1B;AACF;AoB5kTI;E0DvCA;IAAwB,2BAAA;E9EunT1B;E8EtnTE;IAAwB,4BAAA;E9EynT1B;E8ExnTE;IAAwB,6BAAA;E9E2nT1B;AACF;A8EtnTA;EAAmB,oCAAA;A9EynTnB;;A8ExnTA;EAAmB,oCAAA;A9E4nTnB;;A8E3nTA;EAAmB,qCAAA;A9E+nTnB;;A8E3nTA;EAAuB,2BAAA;A9E+nTvB;;A8E9nTA;EAAuB,+BAAA;A9EkoTvB;;A8EjoTA;EAAuB,2BAAA;A9EqoTvB;;A8EpoTA;EAAuB,2BAAA;A9EwoTvB;;A8EvoTA;EAAuB,8BAAA;A9E2oTvB;;A8E1oTA;EAAuB,6BAAA;A9E8oTvB;;A8E1oTA;EAAc,sBAAA;A9E8oTd;;AgFrrTE;EACE,yBAAA;AhFwrTJ;;AW9qTE;EqELM,mEAAA;AhFurTR;;AgF7rTE;EACE,yBAAA;AhFgsTJ;;AWtrTE;EqELM,kEAAA;AhF+rTR;;AgFrsTE;EACE,yBAAA;AhFwsTJ;;AW9rTE;EqELM,uCAAA;AhFusTR;;AgF7sTE;EACE,yBAAA;AhFgtTJ;;AWtsTE;EqELM,gDAAA;AhF+sTR;;AgFrtTE;EACE,yBAAA;AhFwtTJ;;AW9sTE;EqELM,wCAAA;AhFutTR;;AgF7tTE;EACE,yBAAA;AhFguTJ;;AWttTE;EqELM,mEAAA;AhF+tTR;;AgFruTE;EACE,yBAAA;AhFwuTJ;;AW9tTE;EqELM,+CAAA;AhFuuTR;;AgF7uTE;EACE,yBAAA;AhFgvTJ;;AWtuTE;EqELM,0DAAA;AhF+uTR;;A8ExsTA;EAAa,yBAAA;A9E4sTb;;A8E3sTA;EAAc,yBAAA;A9E+sTd;;A8E7sTA;EAAiB,oCAAA;A9EitTjB;;A8EhtTA;EAAiB,0CAAA;A9EotTjB;;A8EhtTA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AjF2wTF;;A8EptTA;EAAwB,gCAAA;A9EwtTxB;;A8EttTA;EACE,iCAAA;EACA,gCAAA;A9EytTF;;A8EptTA;EAAc,yBAAA;A9EwtTd;;AkFzxTA;EACE,8BAAA;AlF4xTF;;AkFzxTA;EACE,6BAAA;AlF4xTF;;AmF5xTE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;EnF4xTJ;EmFxxTI;IACE,0BAAA;EnF0xTN;EmFjxTE;IACE,6BAAA;EnFmxTJ;EmFrwTE;IACE,gCAAA;EnFuwTJ;EmFrwTE;;IAEE,yBAAA;IACA,wBAAA;EnFuwTJ;EmFpwTE;;IAEE,wBAAA;EnFswTJ;EmFnwTE;;;IAGE,UAAA;IACA,SAAA;EnFqwTJ;EmFlwTE;;IAEE,uBAAA;EnFowTJ;EmF5vTE;IACE,Q1E2iC8B;ETmtRlC;EmF5vTE;IACE,2BAAA;EnF8vTJ;EmF5vTE;IACE,2BAAA;EnF8vTJ;EmF1vTE;IACE,aAAA;EnF4vTJ;EmF1vTE;IACE,sBAAA;EnF4vTJ;EmFzvTE;IACE,oCAAA;EnF2vTJ;EmFzvTI;;IAEE,iCAAA;EnF2vTN;EmFtvTI;;IAEE,oCAAA;EnFwvTN;EmFpvTE;IACE,cAAA;EnFsvTJ;EmFpvTI;;;;IAIE,qB1E9GG;ETo2TT;EmFlvTE;IACE,cAAA;IACA,qB1EpHK;ETw2TT;AACF;AE3yTA,UAAA;AA2BE;EACE,cA3BO;AF8yTX;;AEjxTE;EACE,yBA9BO;AFkzTX;;AElxTE;EACE,yBAjCO;AFszTX;;AEnxTE;EACE,qBApCO;AF0zTX;;AEhyTE;EACE,cA3BO;AF8zTX;;AEjyTE;EACE,yBA9BO;AFk0TX;;AElyTE;EACE,yBAjCO;AFs0TX;;AEnyTE;EACE,qBApCO;AF00TX;;AEhzTE;EACE,cA3BO;AF80TX;;AEjzTE;EACE,yBA9BO;AFk1TX;;AElzTE;EACE,yBAjCO;AFs1TX;;AEnzTE;EACE,qBApCO;AF01TX;;AEh0TE;EACE,cA3BO;AF81TX;;AEj0TE;EACE,yBA9BO;AFk2TX;;AEl0TE;EACE,yBAjCO;AFs2TX;;AEn0TE;EACE,qBApCO;AF02TX;;AEh1TE;EACE,cA3BO;AF82TX;;AEj1TE;EACE,yBA9BO;AFk3TX;;AEl1TE;EACE,yBAjCO;AFs3TX;;AEn1TE;EACE,qBApCO;AF03TX;;AEh2TE;EACE,cA3BO;AF83TX;;AEj2TE;EACE,yBA9BO;AFk4TX;;AEl2TE;EACE,yBAjCO;AFs4TX;;AEn2TE;EACE,qBApCO;AF04TX;;AEh3TE;EACE,cA3BO;AF84TX;;AEj3TE;EACE,yBA9BO;AFk5TX;;AEl3TE;EACE,yBAjCO;AFs5TX;;AEn3TE;EACE,qBApCO;AF05TX;;AEh4TE;EACE,cA3BO;AF85TX;;AEj4TE;EACE,yBA9BO;AFk6TX;;AEl4TE;EACE,yBAjCO;AFs6TX;;AEn4TE;EACE,qBApCO;AF06TX;;AEh5TE;EACE,cA3BO;AF86TX;;AEj5TE;EACE,yBA9BO;AFk7TX;;AEl5TE;EACE,yBAjCO;AFs7TX;;AEn5TE;EACE,qBApCO;AF07TX;;AEh6TE;EACE,cA3BO;AF87TX;;AEj6TE;EACE,yBA9BO;AFk8TX;;AEl6TE;EACE,yBAjCO;AFs8TX;;AEn6TE;EACE,qBApCO;AF08TX;;AEh7TE;EACE,cA3BO;AF88TX;;AEj7TE;EACE,yBA9BO;AFk9TX;;AEl7TE;EACE,yBAjCO;AFs9TX;;AEn7TE;EACE,qBApCO;AF09TX;;AEh8TE;EACE,cA3BO;AF89TX;;AEj8TE;EACE,yBA9BO;AFk+TX;;AEl8TE;EACE,yBAjCO;AFs+TX;;AEn8TE;EACE,qBApCO;AF0+TX;;AEh9TE;EACE,cA3BO;AF8+TX;;AEj9TE;EACE,yBA9BO;AFk/TX;;AEl9TE;EACE,yBAjCO;AFs/TX;;AEn9TE;EACE,qBApCO;AF0/TX;;AEh+TE;EACE,cA3BO;AF8/TX;;AEj+TE;EACE,yBA9BO;AFkgUX;;AEl+TE;EACE,yBAjCO;AFsgUX;;AEn+TE;EACE,qBApCO;AF0gUX;;AEh/TE;EACE,cA3BO;AF8gUX;;AEj/TE;EACE,yBA9BO;AFkhUX;;AEl/TE;EACE,yBAjCO;AFshUX;;AEn/TE;EACE,qBApCO;AF0hUX;;AEhgUE;EACE,cA3BO;AF8hUX;;AEjgUE;EACE,yBA9BO;AFkiUX;;AElgUE;EACE,yBAjCO;AFsiUX;;AEngUE;EACE,qBApCO;AF0iUX;;AEhhUE;EACE,cA3BO;AF8iUX;;AEjhUE;EACE,yBA9BO;AFkjUX;;AElhUE;EACE,yBAjCO;AFsjUX;;AEnhUE;EACE,qBApCO;AF0jUX;;AEhiUE;EACE,cA3BO;AF8jUX;;AEjiUE;EACE,yBA9BO;AFkkUX;;AEliUE;EACE,yBAjCO;AFskUX;;AEniUE;EACE,qBApCO;AF0kUX;;AEhjUE;EACE,cA3BO;AF8kUX;;AEjjUE;EACE,yBA9BO;AFklUX;;AEljUE;EACE,yBAjCO;AFslUX;;AEnjUE;EACE,qBApCO;AF0lUX;;AEhkUE;EACE,cA3BO;AF8lUX;;AEjkUE;EACE,yBA9BO;AFkmUX;;AElkUE;EACE,yBAjCO;AFsmUX;;AEnkUE;EACE,qBApCO;AF0mUX;;AEhlUE;EACE,cA3BO;AF8mUX;;AEjlUE;EACE,yBA9BO;AFknUX;;AEllUE;EACE,yBAjCO;AFsnUX;;AEnlUE;EACE,qBApCO;AF0nUX;;AG5rUA,cAAA;AAGE;EACE,eAAA;AH6rUJ;;AG9rUE;EACE,eAAA;AHisUJ;;AGlsUE;EACE,eAAA;AHqsUJ;;AGtsUE;EACE,eAAA;AHysUJ;;AG1sUE;EACE,eAAA;AH6sUJ;;AG9sUE;EACE,eAAA;AHitUJ;;AGltUE;EACE,eAAA;AHqtUJ;;AGttUE;EACE,eAAA;AHytUJ;;AG1tUE;EACE,eAAA;AH6tUJ;;AG9tUE;EACE,eAAA;AHiuUJ;;AGluUE;EACE,eAAA;AHquUJ;;AGtuUE;EACE,eAAA;AHyuUJ;;AG1uUE;EACE,eAAA;AH6uUJ;;AG9uUE;EACE,eAAA;AHivUJ;;AGlvUE;EACE,eAAA;AHqvUJ;;AGtvUE;EACE,eAAA;AHyvUJ;;AG1vUE;EACE,eAAA;AH6vUJ;;AG9vUE;EACE,eAAA;AHiwUJ;;AGlwUE;EACE,eAAA;AHqwUJ;;AGtwUE;EACE,eAAA;AHywUJ;;AG1wUE;EACE,eAAA;AH6wUJ;;AG9wUE;EACE,eAAA;AHixUJ;;AGlxUE;EACE,eAAA;AHqxUJ;;AGtxUE;EACE,eAAA;AHyxUJ;;AG1xUE;EACE,eAAA;AH6xUJ;;AG9xUE;EACE,eAAA;AHiyUJ;;AGlyUE;EACE,eAAA;AHqyUJ;;AGtyUE;EACE,eAAA;AHyyUJ;;AG1yUE;EACE,eAAA;AH6yUJ;;AG9yUE;EACE,cAAA;AHizUJ;;AGzyUE;EACE,iBAAA;AH4yUJ;;AG7yUE;EACE,iBAAA;AHgzUJ;;AGjzUE;EACE,iBAAA;AHozUJ;;AGrzUE;EACE,iBAAA;AHwzUJ;;AGzzUE;EACE,iBAAA;AH4zUJ;;AG7zUE;EACE,iBAAA;AHg0UJ;;AGj0UE;EACE,iBAAA;AHo0UJ;;AGr0UE;EACE,iBAAA;AHw0UJ;;AGz0UE;EACE,iBAAA;AH40UJ;;AG70UE;EACE,iBAAA;AHg1UJ;;AGj1UE;EACE,iBAAA;AHo1UJ;;AGr1UE;EACE,iBAAA;AHw1UJ;;AGz1UE;EACE,iBAAA;AH41UJ;;AG71UE;EACE,iBAAA;AHg2UJ;;AGj2UE;EACE,iBAAA;AHo2UJ;;AGr2UE;EACE,iBAAA;AHw2UJ;;AGz2UE;EACE,iBAAA;AH42UJ;;AG72UE;EACE,iBAAA;AHg3UJ;;AGj3UE;EACE,iBAAA;AHo3UJ;;AGr3UE;EACE,iBAAA;AHw3UJ;;AGz3UE;EACE,iBAAA;AH43UJ;;AG73UE;EACE,iBAAA;AHg4UJ;;AGj4UE;EACE,iBAAA;AHo4UJ;;AGr4UE;EACE,iBAAA;AHw4UJ;;AGz4UE;EACE,iBAAA;AH44UJ;;AG74UE;EACE,iBAAA;AHg5UJ;;AGj5UE;EACE,iBAAA;AHo5UJ;;AGr5UE;EACE,iBAAA;AHw5UJ;;AGz5UE;EACE,iBAAA;AH45UJ;;AG75UE;EACE,gBAAA;AHg6UJ;;AG35UA,gBAAA;AAGE;EACE,gBAHC;AH+5UL;;AG75UE;EACE,gBAEG;AH85UP;;AGj6UE;EACE,gBAEG;AHk6UP;;AGr6UE;EACE,gBAEG;AHs6UP;;AGn6UA,WAAA;AAGE;EACE,WAHK;AHu6UT;;AGr6UE;EACE,WAEO;AHs6UX;;AGz6UE;EACE,WAEO;AH06UX;;AG76UE;EACE,WAEO;AH86UX;;AGj7UE;EACE,WAEO;AHk7UX;;AGr7UE;EACE,WAEO;AHs7UX;;AoF59UA;EACE,alFiBY;EkFhBZ,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;ApF+9UF;AoF99UE;EAIE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;ApF69UJ;AoF39UE;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;ApF69UJ;;AE36UA,UAAA;AA2BE;EACE,cA3BO;AF+6UX;;AEl5UE;EACE,yBA9BO;AFm7UX;;AEn5UE;EACE,yBAjCO;AFu7UX;;AEp5UE;EACE,qBApCO;AF27UX;;AEj6UE;EACE,cA3BO;AF+7UX;;AEl6UE;EACE,yBA9BO;AFm8UX;;AEn6UE;EACE,yBAjCO;AFu8UX;;AEp6UE;EACE,qBApCO;AF28UX;;AEj7UE;EACE,cA3BO;AF+8UX;;AEl7UE;EACE,yBA9BO;AFm9UX;;AEn7UE;EACE,yBAjCO;AFu9UX;;AEp7UE;EACE,qBApCO;AF29UX;;AEj8UE;EACE,cA3BO;AF+9UX;;AEl8UE;EACE,yBA9BO;AFm+UX;;AEn8UE;EACE,yBAjCO;AFu+UX;;AEp8UE;EACE,qBApCO;AF2+UX;;AEj9UE;EACE,cA3BO;AF++UX;;AEl9UE;EACE,yBA9BO;AFm/UX;;AEn9UE;EACE,yBAjCO;AFu/UX;;AEp9UE;EACE,qBApCO;AF2/UX;;AEj+UE;EACE,cA3BO;AF+/UX;;AEl+UE;EACE,yBA9BO;AFmgVX;;AEn+UE;EACE,yBAjCO;AFugVX;;AEp+UE;EACE,qBApCO;AF2gVX;;AEj/UE;EACE,cA3BO;AF+gVX;;AEl/UE;EACE,yBA9BO;AFmhVX;;AEn/UE;EACE,yBAjCO;AFuhVX;;AEp/UE;EACE,qBApCO;AF2hVX;;AEjgVE;EACE,cA3BO;AF+hVX;;AElgVE;EACE,yBA9BO;AFmiVX;;AEngVE;EACE,yBAjCO;AFuiVX;;AEpgVE;EACE,qBApCO;AF2iVX;;AEjhVE;EACE,cA3BO;AF+iVX;;AElhVE;EACE,yBA9BO;AFmjVX;;AEnhVE;EACE,yBAjCO;AFujVX;;AEphVE;EACE,qBApCO;AF2jVX;;AEjiVE;EACE,cA3BO;AF+jVX;;AEliVE;EACE,yBA9BO;AFmkVX;;AEniVE;EACE,yBAjCO;AFukVX;;AEpiVE;EACE,qBApCO;AF2kVX;;AEjjVE;EACE,cA3BO;AF+kVX;;AEljVE;EACE,yBA9BO;AFmlVX;;AEnjVE;EACE,yBAjCO;AFulVX;;AEpjVE;EACE,qBApCO;AF2lVX;;AEjkVE;EACE,cA3BO;AF+lVX;;AElkVE;EACE,yBA9BO;AFmmVX;;AEnkVE;EACE,yBAjCO;AFumVX;;AEpkVE;EACE,qBApCO;AF2mVX;;AEjlVE;EACE,cA3BO;AF+mVX;;AEllVE;EACE,yBA9BO;AFmnVX;;AEnlVE;EACE,yBAjCO;AFunVX;;AEplVE;EACE,qBApCO;AF2nVX;;AEjmVE;EACE,cA3BO;AF+nVX;;AElmVE;EACE,yBA9BO;AFmoVX;;AEnmVE;EACE,yBAjCO;AFuoVX;;AEpmVE;EACE,qBApCO;AF2oVX;;AEjnVE;EACE,cA3BO;AF+oVX;;AElnVE;EACE,yBA9BO;AFmpVX;;AEnnVE;EACE,yBAjCO;AFupVX;;AEpnVE;EACE,qBApCO;AF2pVX;;AEjoVE;EACE,cA3BO;AF+pVX;;AEloVE;EACE,yBA9BO;AFmqVX;;AEnoVE;EACE,yBAjCO;AFuqVX;;AEpoVE;EACE,qBApCO;AF2qVX;;AEjpVE;EACE,cA3BO;AF+qVX;;AElpVE;EACE,yBA9BO;AFmrVX;;AEnpVE;EACE,yBAjCO;AFurVX;;AEppVE;EACE,qBApCO;AF2rVX;;AEjqVE;EACE,cA3BO;AF+rVX;;AElqVE;EACE,yBA9BO;AFmsVX;;AEnqVE;EACE,yBAjCO;AFusVX;;AEpqVE;EACE,qBApCO;AF2sVX;;AEjrVE;EACE,cA3BO;AF+sVX;;AElrVE;EACE,yBA9BO;AFmtVX;;AEnrVE;EACE,yBAjCO;AFutVX;;AEprVE;EACE,qBApCO;AF2tVX;;AEjsVE;EACE,cA3BO;AF+tVX;;AElsVE;EACE,yBA9BO;AFmuVX;;AEnsVE;EACE,yBAjCO;AFuuVX;;AEpsVE;EACE,qBApCO;AF2uVX;;AEjtVE;EACE,cA3BO;AF+uVX;;AEltVE;EACE,yBA9BO;AFmvVX;;AEntVE;EACE,yBAjCO;AFuvVX;;AEptVE;EACE,qBApCO;AF2vVX;;AG7zVA,cAAA;AAGE;EACE,eAAA;AH8zVJ;;AG/zVE;EACE,eAAA;AHk0VJ;;AGn0VE;EACE,eAAA;AHs0VJ;;AGv0VE;EACE,eAAA;AH00VJ;;AG30VE;EACE,eAAA;AH80VJ;;AG/0VE;EACE,eAAA;AHk1VJ;;AGn1VE;EACE,eAAA;AHs1VJ;;AGv1VE;EACE,eAAA;AH01VJ;;AG31VE;EACE,eAAA;AH81VJ;;AG/1VE;EACE,eAAA;AHk2VJ;;AGn2VE;EACE,eAAA;AHs2VJ;;AGv2VE;EACE,eAAA;AH02VJ;;AG32VE;EACE,eAAA;AH82VJ;;AG/2VE;EACE,eAAA;AHk3VJ;;AGn3VE;EACE,eAAA;AHs3VJ;;AGv3VE;EACE,eAAA;AH03VJ;;AG33VE;EACE,eAAA;AH83VJ;;AG/3VE;EACE,eAAA;AHk4VJ;;AGn4VE;EACE,eAAA;AHs4VJ;;AGv4VE;EACE,eAAA;AH04VJ;;AG34VE;EACE,eAAA;AH84VJ;;AG/4VE;EACE,eAAA;AHk5VJ;;AGn5VE;EACE,eAAA;AHs5VJ;;AGv5VE;EACE,eAAA;AH05VJ;;AG35VE;EACE,eAAA;AH85VJ;;AG/5VE;EACE,eAAA;AHk6VJ;;AGn6VE;EACE,eAAA;AHs6VJ;;AGv6VE;EACE,eAAA;AH06VJ;;AG36VE;EACE,eAAA;AH86VJ;;AG/6VE;EACE,cAAA;AHk7VJ;;AG16VE;EACE,iBAAA;AH66VJ;;AG96VE;EACE,iBAAA;AHi7VJ;;AGl7VE;EACE,iBAAA;AHq7VJ;;AGt7VE;EACE,iBAAA;AHy7VJ;;AG17VE;EACE,iBAAA;AH67VJ;;AG97VE;EACE,iBAAA;AHi8VJ;;AGl8VE;EACE,iBAAA;AHq8VJ;;AGt8VE;EACE,iBAAA;AHy8VJ;;AG18VE;EACE,iBAAA;AH68VJ;;AG98VE;EACE,iBAAA;AHi9VJ;;AGl9VE;EACE,iBAAA;AHq9VJ;;AGt9VE;EACE,iBAAA;AHy9VJ;;AG19VE;EACE,iBAAA;AH69VJ;;AG99VE;EACE,iBAAA;AHi+VJ;;AGl+VE;EACE,iBAAA;AHq+VJ;;AGt+VE;EACE,iBAAA;AHy+VJ;;AG1+VE;EACE,iBAAA;AH6+VJ;;AG9+VE;EACE,iBAAA;AHi/VJ;;AGl/VE;EACE,iBAAA;AHq/VJ;;AGt/VE;EACE,iBAAA;AHy/VJ;;AG1/VE;EACE,iBAAA;AH6/VJ;;AG9/VE;EACE,iBAAA;AHigWJ;;AGlgWE;EACE,iBAAA;AHqgWJ;;AGtgWE;EACE,iBAAA;AHygWJ;;AG1gWE;EACE,iBAAA;AH6gWJ;;AG9gWE;EACE,iBAAA;AHihWJ;;AGlhWE;EACE,iBAAA;AHqhWJ;;AGthWE;EACE,iBAAA;AHyhWJ;;AG1hWE;EACE,iBAAA;AH6hWJ;;AG9hWE;EACE,gBAAA;AHiiWJ;;AG5hWA,gBAAA;AAGE;EACE,gBAHC;AHgiWL;;AG9hWE;EACE,gBAEG;AH+hWP;;AGliWE;EACE,gBAEG;AHmiWP;;AGtiWE;EACE,gBAEG;AHuiWP;;AGpiWA,WAAA;AAGE;EACE,WAHK;AHwiWT;;AGtiWE;EACE,WAEO;AHuiWX;;AG1iWE;EACE,WAEO;AH2iWX;;AG9iWE;EACE,WAEO;AH+iWX;;AGljWE;EACE,WAEO;AHmjWX;;AGtjWE;EACE,WAEO;AHujWX;;AqF7lWA;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ArFgmWF;;AqF7lWE;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;ArFgmWJ;AqF/lWI;EACE,mBnFRK;EmFSL,yBAAA;EACA,WnFZE;AF6mWR;AqF/lWI;EACE,sBnFfE;EmFgBF,cnFnBO;EmFoBP,iBAAA;EACA,oCAAA;ArFimWN;AqF/lWI;EACE,mBnFxBO;EmFyBP,yBAAA;EACA,WnFvBE;AFwnWR;AqF/lWI;EACE,sBnF1BE;EmF2BF,cnF9BO;EmF+BP,iBAAA;ArFimWN;AqF/lWI;EACE,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,cnFhCK;AFioWX;AqF/lWI;EACE,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,cnFtCK;AFuoWX;AqF/lWI;EACE,mBnFzCK;EmF0CL,yBAAA;EACA,WnF7CE;AF8oWR;AqF/lWI;EACE,uBAAA;EACA,6BAAA;EACA,wBAAA;EACA,cnFjDK;AFkpWX;AqF/lWI;EACE,uBAAA;EACA,yBAAA;EACA,cnFtDK;AFupWX;AqF/lWI;EACE,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,cnF/DG;AFgqWT;AqF/lWI;EACE,mBnFlEG;EmFmEH,yBAAA;EACA,WnFnEE;AFoqWR;AqF/lWI;EACE,yBnFzEO;EmF0EP,WnFvEE;EmFwEF,oBAAA;EACA,iBAAA;ArFimWN;AqF/lWI;EACE,mBnF/EO;EmFgFP,sBAAA;EACA,WnF9EE;AF+qWR;AqF/lWI;EACE,yBnFzEK;EmF0EL,WnF/EE;EmFgFF,oBAAA;EACA,iBAAA;ArFimWN;AqF/lWI;EACE,mBnF/EK;EmFgFL,sBAAA;EACA,WnFtFE;AFurWR;AqF/lWI;EACE,yBnF3DK;EmF4DL,cnFhFG;AFirWT;AqF/lWI;EACE,mBnF/DK;EmFgEL,yBAAA;EACA,cnFrFG;AFsrWT;AqF/lWI;EACE,6BAAA;EACA,cnFzFG;EmF0FH,yBAAA;ArFimWN;AqF/lWI;EACE,uBAAA;EACA,yBAAA;EACA,cnF/FG;AFgsWT;;AqF5lWA;;;EAGE,UAAA;EACA,gBAAA;ArF+lWF;;AqF5lWA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;ArF+lWF;;AqF5lWE;EAEE,gBAAA;ArF8lWJ;;AqF3lWA;EACE,eAAA;ArF8lWF;;AqF3lWA;EACE,gCAAA;ArF8lWF;;AqF3lWA;EACE,sBnF7IM;EmF8IN,aAAA;ArF8lWF;;AqF3lWA;EACE,iBAAA;ArF8lWF;;AqF1lWA;;EAEE,wBAAA;EACA,SAAA;ArF6lWF;;AqFzlWA;EACE,0BAAA;ArF4lWF;;AqFtlWI;EACE,oBAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;ArFylWN;;AqFllWE;EACE,WAAA;EACA,cAAA;EACA,aAAA;ArFqlWJ;AqFnlWE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;ArFqlWJ;AqFplWI;EACE,UAAA;ArFslWN;AqFnlWE;;EAEE,aAAA;ArFqlWJ;AqFnlWE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBnFrMI;EmFsMJ,kBAAA;EACA,kBAAA;EACA,yBAAA;ArFqlWJ;AqFnlWE;EACE,yBAAA;ArFqlWJ;AqFnlWE;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;ArFqlWJ;AqFnlWE;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;ArFqlWJ;AqFllWI;EACE,6BAAA;ArFolWN;AqFllWI;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;ArFolWN;AqFhlWI;EACE,yBAAA;ArFklWN;AqFhlWI;;EAEE,6BAAA;ArFklWN;AqF9kWE;;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;ArFglWJ;AqF9kWE;EACE,QAAA;EACA,SAAA;EACA,iBAAA;ArFglWJ;AqF9kWE;EACE,OAAA;EACA,UAAA;EACA,kBAAA;ArFglWJ;;AqFzkWE;EACE,2CAAA;EACA,WAAA;ArF4kWJ;AqF3kWI;EACE,6BAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;ArF6kWN;AqFzkWI;EACE,eAAA;ArF2kWN;AqF1kWM;EACE,WnFjSQ;EmFkSR,kBAAA;EACA,6BAAA;ArF4kWR;AqF1kWM;EACE,uBAAA;EACA,oBAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;ArF4kWR;AqF1kWM;EACE,WnFpTQ;EmFqTR,kBAAA;EACA,6BAAA;ArF4kWR;;AqFrkWE;EACE,YAAA;EACA,WAAA;ArFwkWJ;;AqFrkWA;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;ArFwkWF;;AqFpkWA;EACE,WnF/TM;AFs4WR;;AqFrkWA;EACE,cnFjUS;AFy4WX;;AqFtkWA;EACE,cAAA;ArFykWF;;AqFtkWA;EACE,cnFrUK;AF84WP;;AqFtkWA;EACE,cnFrTU;AF83WZ;;AqFtkWA;EACE,cnFzUS;AFk5WX;;AqFtkWA;EACE,cnF/UQ;AFw5WV;;AqFtkWA;EACE,cnF1VS;AFm6WX;;AqFtkWA;EACE,yBnF9VS;AFu6WX;;AqFtkWA;EACE,yBnFhWS;AFy6WX;;AqFtkWA;EACE,yBnFhWS;AFy6WX;;AqFtkWA;EACE,yBnFjXI;AF07WN;;AqFtkWA;EACE,cnFnXW;AF47Wb;;AqFvkWA;EACE,cAAA;ArF0kWF;;AqFvkWA;EACE,yBnF1WO;EmF2WP,WnFxXM;AFk8WR;;AqFvkWA;EACE,yBnF/WO;EmFgXP,WnF7XM;AFu8WR;;AqFxkWA;EACE,0BAAA;ArF2kWF;;AqFzkWA;EACE,WnFnYM;EmFoYN,yBnFnXa;AF+7Wf;;AqF1kWA;EACE,cAAA;EACA,sBnFxYM;EmFyYN,yBAAA;ArF6kWF;;AqF3kWA;EACE,yBnF7XW;AF28Wb;;AqF3kWA;EACE,cnFnZW;AFi+Wb;;AqF5kWA;EACE,yBAAA;ArF+kWF;;AqF7kWA;EACE,cnFzYO;EmF0YP,iBAAA;EACA,gBAAA;ArFglWF;;AqF7kWA;EACE,kBAAA;ArFglWF;;AqF9kWA;EACE,yBAAA;ArFilWF;;AqF/kWA;EACE,eAAA;ArFklWF;;AqFhlWA;EACI,qBAAA;ArFmlWJ;;AqFjlWA;EACE,cAAA;ArFolWF;;AqFllWA;EACE,UAAA;ArFqlWF;;AqFnlWA;EACE,uBAAA;ArFslWF;;AEp8WA,UAAA;AA2BE;EACE,cA3BO;AFw8WX;;AE36WE;EACE,yBA9BO;AF48WX;;AE56WE;EACE,yBAjCO;AFg9WX;;AE76WE;EACE,qBApCO;AFo9WX;;AE17WE;EACE,cA3BO;AFw9WX;;AE37WE;EACE,yBA9BO;AF49WX;;AE57WE;EACE,yBAjCO;AFg+WX;;AE77WE;EACE,qBApCO;AFo+WX;;AE18WE;EACE,cA3BO;AFw+WX;;AE38WE;EACE,yBA9BO;AF4+WX;;AE58WE;EACE,yBAjCO;AFg/WX;;AE78WE;EACE,qBApCO;AFo/WX;;AE19WE;EACE,cA3BO;AFw/WX;;AE39WE;EACE,yBA9BO;AF4/WX;;AE59WE;EACE,yBAjCO;AFggXX;;AE79WE;EACE,qBApCO;AFogXX;;AE1+WE;EACE,cA3BO;AFwgXX;;AE3+WE;EACE,yBA9BO;AF4gXX;;AE5+WE;EACE,yBAjCO;AFghXX;;AE7+WE;EACE,qBApCO;AFohXX;;AE1/WE;EACE,cA3BO;AFwhXX;;AE3/WE;EACE,yBA9BO;AF4hXX;;AE5/WE;EACE,yBAjCO;AFgiXX;;AE7/WE;EACE,qBApCO;AFoiXX;;AE1gXE;EACE,cA3BO;AFwiXX;;AE3gXE;EACE,yBA9BO;AF4iXX;;AE5gXE;EACE,yBAjCO;AFgjXX;;AE7gXE;EACE,qBApCO;AFojXX;;AE1hXE;EACE,cA3BO;AFwjXX;;AE3hXE;EACE,yBA9BO;AF4jXX;;AE5hXE;EACE,yBAjCO;AFgkXX;;AE7hXE;EACE,qBApCO;AFokXX;;AE1iXE;EACE,cA3BO;AFwkXX;;AE3iXE;EACE,yBA9BO;AF4kXX;;AE5iXE;EACE,yBAjCO;AFglXX;;AE7iXE;EACE,qBApCO;AFolXX;;AE1jXE;EACE,cA3BO;AFwlXX;;AE3jXE;EACE,yBA9BO;AF4lXX;;AE5jXE;EACE,yBAjCO;AFgmXX;;AE7jXE;EACE,qBApCO;AFomXX;;AE1kXE;EACE,cA3BO;AFwmXX;;AE3kXE;EACE,yBA9BO;AF4mXX;;AE5kXE;EACE,yBAjCO;AFgnXX;;AE7kXE;EACE,qBApCO;AFonXX;;AE1lXE;EACE,cA3BO;AFwnXX;;AE3lXE;EACE,yBA9BO;AF4nXX;;AE5lXE;EACE,yBAjCO;AFgoXX;;AE7lXE;EACE,qBApCO;AFooXX;;AE1mXE;EACE,cA3BO;AFwoXX;;AE3mXE;EACE,yBA9BO;AF4oXX;;AE5mXE;EACE,yBAjCO;AFgpXX;;AE7mXE;EACE,qBApCO;AFopXX;;AE1nXE;EACE,cA3BO;AFwpXX;;AE3nXE;EACE,yBA9BO;AF4pXX;;AE5nXE;EACE,yBAjCO;AFgqXX;;AE7nXE;EACE,qBApCO;AFoqXX;;AE1oXE;EACE,cA3BO;AFwqXX;;AE3oXE;EACE,yBA9BO;AF4qXX;;AE5oXE;EACE,yBAjCO;AFgrXX;;AE7oXE;EACE,qBApCO;AForXX;;AE1pXE;EACE,cA3BO;AFwrXX;;AE3pXE;EACE,yBA9BO;AF4rXX;;AE5pXE;EACE,yBAjCO;AFgsXX;;AE7pXE;EACE,qBApCO;AFosXX;;AE1qXE;EACE,cA3BO;AFwsXX;;AE3qXE;EACE,yBA9BO;AF4sXX;;AE5qXE;EACE,yBAjCO;AFgtXX;;AE7qXE;EACE,qBApCO;AFotXX;;AE1rXE;EACE,cA3BO;AFwtXX;;AE3rXE;EACE,yBA9BO;AF4tXX;;AE5rXE;EACE,yBAjCO;AFguXX;;AE7rXE;EACE,qBApCO;AFouXX;;AE1sXE;EACE,cA3BO;AFwuXX;;AE3sXE;EACE,yBA9BO;AF4uXX;;AE5sXE;EACE,yBAjCO;AFgvXX;;AE7sXE;EACE,qBApCO;AFovXX;;AE1tXE;EACE,cA3BO;AFwvXX;;AE3tXE;EACE,yBA9BO;AF4vXX;;AE5tXE;EACE,yBAjCO;AFgwXX;;AE7tXE;EACE,qBApCO;AFowXX;;AE1uXE;EACE,cA3BO;AFwwXX;;AE3uXE;EACE,yBA9BO;AF4wXX;;AE5uXE;EACE,yBAjCO;AFgxXX;;AE7uXE;EACE,qBApCO;AFoxXX;;AGt1XA,cAAA;AAGE;EACE,eAAA;AHu1XJ;;AGx1XE;EACE,eAAA;AH21XJ;;AG51XE;EACE,eAAA;AH+1XJ;;AGh2XE;EACE,eAAA;AHm2XJ;;AGp2XE;EACE,eAAA;AHu2XJ;;AGx2XE;EACE,eAAA;AH22XJ;;AG52XE;EACE,eAAA;AH+2XJ;;AGh3XE;EACE,eAAA;AHm3XJ;;AGp3XE;EACE,eAAA;AHu3XJ;;AGx3XE;EACE,eAAA;AH23XJ;;AG53XE;EACE,eAAA;AH+3XJ;;AGh4XE;EACE,eAAA;AHm4XJ;;AGp4XE;EACE,eAAA;AHu4XJ;;AGx4XE;EACE,eAAA;AH24XJ;;AG54XE;EACE,eAAA;AH+4XJ;;AGh5XE;EACE,eAAA;AHm5XJ;;AGp5XE;EACE,eAAA;AHu5XJ;;AGx5XE;EACE,eAAA;AH25XJ;;AG55XE;EACE,eAAA;AH+5XJ;;AGh6XE;EACE,eAAA;AHm6XJ;;AGp6XE;EACE,eAAA;AHu6XJ;;AGx6XE;EACE,eAAA;AH26XJ;;AG56XE;EACE,eAAA;AH+6XJ;;AGh7XE;EACE,eAAA;AHm7XJ;;AGp7XE;EACE,eAAA;AHu7XJ;;AGx7XE;EACE,eAAA;AH27XJ;;AG57XE;EACE,eAAA;AH+7XJ;;AGh8XE;EACE,eAAA;AHm8XJ;;AGp8XE;EACE,eAAA;AHu8XJ;;AGx8XE;EACE,cAAA;AH28XJ;;AGn8XE;EACE,iBAAA;AHs8XJ;;AGv8XE;EACE,iBAAA;AH08XJ;;AG38XE;EACE,iBAAA;AH88XJ;;AG/8XE;EACE,iBAAA;AHk9XJ;;AGn9XE;EACE,iBAAA;AHs9XJ;;AGv9XE;EACE,iBAAA;AH09XJ;;AG39XE;EACE,iBAAA;AH89XJ;;AG/9XE;EACE,iBAAA;AHk+XJ;;AGn+XE;EACE,iBAAA;AHs+XJ;;AGv+XE;EACE,iBAAA;AH0+XJ;;AG3+XE;EACE,iBAAA;AH8+XJ;;AG/+XE;EACE,iBAAA;AHk/XJ;;AGn/XE;EACE,iBAAA;AHs/XJ;;AGv/XE;EACE,iBAAA;AH0/XJ;;AG3/XE;EACE,iBAAA;AH8/XJ;;AG//XE;EACE,iBAAA;AHkgYJ;;AGngYE;EACE,iBAAA;AHsgYJ;;AGvgYE;EACE,iBAAA;AH0gYJ;;AG3gYE;EACE,iBAAA;AH8gYJ;;AG/gYE;EACE,iBAAA;AHkhYJ;;AGnhYE;EACE,iBAAA;AHshYJ;;AGvhYE;EACE,iBAAA;AH0hYJ;;AG3hYE;EACE,iBAAA;AH8hYJ;;AG/hYE;EACE,iBAAA;AHkiYJ;;AGniYE;EACE,iBAAA;AHsiYJ;;AGviYE;EACE,iBAAA;AH0iYJ;;AG3iYE;EACE,iBAAA;AH8iYJ;;AG/iYE;EACE,iBAAA;AHkjYJ;;AGnjYE;EACE,iBAAA;AHsjYJ;;AGvjYE;EACE,gBAAA;AH0jYJ;;AGrjYA,gBAAA;AAGE;EACE,gBAHC;AHyjYL;;AGvjYE;EACE,gBAEG;AHwjYP;;AG3jYE;EACE,gBAEG;AH4jYP;;AG/jYE;EACE,gBAEG;AHgkYP;;AG7jYA,WAAA;AAGE;EACE,WAHK;AHikYT;;AG/jYE;EACE,WAEO;AHgkYX;;AGnkYE;EACE,WAEO;AHokYX;;AGvkYE;EACE,WAEO;AHwkYX;;AG3kYE;EACE,WAEO;AH4kYX;;AG/kYE;EACE,WAEO;AHglYX;;AsFtnYA;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AtFynYF;;AsFtnYA;EAEE;;;;IAIE,sBAAA;EtFwnYF;EsFrnYA;IACE,+BAAA;EtFunYF;EsFpnYA;IACE,4BAAA;EtFsnYF;EsFnnYA;;IAEE,0BAAA;EtFqnYF;AACF;AsFlnYA;EAEE;;;;IAIE,qBAAA;EtFmnYF;AACF;AAnpYA;EACE,oBAAA;EACA,6CAAA;AAqpYF;AAlpYA;EACE,4BAAA;EACA,6CAAA;AAopYF;AAjpYA;EACE,0BAAA;EACA,6CAAA;AAmpYF;AAhpYA;EACE,2BAAA;EACA,6CAAA;AAkpYF;AA/oYA;EACE,yBAAA;EACA,6CAAA;AAipYF;AA9oYA;EACE,YAAA;AAgpYF;;AA7oYA;EACE,iCAAA;AAgpYF;;AA7oYA;EACE,eAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;AAgpYF;;AA7oYA;EACE,kBAAA;AAgpYF;;AA7oYA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EAGA,SAAA;EACA,wBAAA;EACA,YAAA;AA8oYF;;AA3oYA;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;AA8oYF;;AA3oYA;EACE,2BAAA;AA8oYF;;AA3oYA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;EACA,UAAA;AA8oYF;;AA3oYA;EACE;IACE,WAAA;EA8oYF;EA3oYA;IACE,aAAA;EA6oYF;AACF;AA1oYA;EACE,gCAAA;AA4oYF;;AAzoYA;EACE;IACE,yBAAA;IACA,uBAAA;EA4oYF;EAzoYA;IACE,uBAAA;EA2oYF;AACF;AAxoYA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,oBAAA;EACA,WAAA;AA0oYF;;AAvoYA;EACE;IACE,uBAAA;EA0oYF;AACF;AAvoYA;;EAEE,uBAAA;AAyoYF;;AAtoYA;;;;EAIE,oCAAA;EACA,YAAA;AAyoYF;;AAtoYA;;EAEE,yBAAA;AAyoYF;;AAtoYA;EACE,UAAA;AAyoYF","sourcesContent":["@import \"./default/default.scss\";\n@import \"./default/utility.scss\";\n@import \"./vendors/vendors-dir.scss\";\n@import \"./auth/login.scss\";\n@import \"./icons/style.css\";\n@import \"./common.scss\";\n@import \"./layouts/mobile.scss\";\n\n@font-face {\n  font-family: Poppins;\n  src: url(../fonts/Poppins/Poppins-Regular.ttf);\n}\n\n@font-face {\n  font-family: Poppins-regular;\n  src: url(../fonts/Poppins/Poppins-Regular.ttf);\n}\n\n@font-face {\n  font-family: Poppins-heavy;\n  src: url(../fonts/Poppins/Poppins-Bold.ttf);\n}\n\n@font-face {\n  font-family: Poppins-Medium;\n  src: url(../fonts/Poppins/Poppins-Medium.ttf);\n}\n\n@font-face {\n  font-family: Poppins-Bold;\n  src: url(../fonts/Poppins/Poppins-Bold.ttf);\n}\n\n.srv-validation-message {\n  color: black;\n}\n\n* {\n  box-sizing: border-box !important;\n}\n\n.chatbotIcon {\n  position: fixed;\n  bottom: 5px;\n  right: 5px;\n  width: 50px;\n  height: 50px;\n  border-radius: 100px;\n  background-color: #2A7A7B;\n  cursor: pointer;\n}\n\n.chatbotCloseContainer {\n  position: relative\n}\n\n.chatbotClose {\n  position: absolute;\n  top: -15px;\n  right: 0px;\n  z-index: 999;\n  border-radius: 100px;\n  //width:40px;\n  //height:40px;\n  border: 0;\n  background-color: tomato;\n  color: white;\n}\n\n.react-chatbot-kit-chat-container {\n  width: 400px !important;\n  border: 1px solid lightgray;\n  border-radius: 5px;\n}\n\n.react-chatbot-kit-chat-bot-message {\n  margin-left: 0px !important;\n}\n\n.chatbotApp {\n  position: fixed;\n  bottom: 60px;\n  right: 10px;\n  display: none;\n  animation: chatbotAppAnim 0.5s 1;\n  z-index: 9;\n}\n\n@keyframes chatbotAppAnim {\n  from {\n    height: 0px;\n  }\n\n  to {\n    height: 600px;\n  }\n}\n\n.rotateIcon {\n  animation: rotateIconAnim 0.2s 1;\n}\n\n@keyframes rotateIconAnim {\n  from {\n    transform: rotate(360deg);\n    background-color: black;\n  }\n\n  to {\n    transform: rotate(0deg)\n  }\n}\n\n.appLogo2 {\n  width: 30px;\n  height: 30px;\n  background-color: transparent;\n  border-radius: 100px;\n  margin: 5px;\n}\n\n@media screen and (max-width:480px) {\n  .react-chatbot-kit-chat-container {\n    width: 340px !important;\n  }\n}\n\nhtml,\nbody {\n  scroll-behavior: smooth;\n}\n\n.badge-primary,\ndropdown-item:active,\n.dropdown-item:focus,\n.btn-default:focus {\n  background-color: #2A7A7B !important;\n  color: white;\n}\n\n.link-text:hover,\n.sidebar-list-item:hover {\n  color: #2A7A7B !important;\n}\n\n.dropdown-menu.show {\n  z-index: 1;\n}\n\n//@media screen and (min-width:820px) {\n//  .chatbotApp {\n//    bottom: 0px;\n//    right: 10px;\n//  }\n//}","html body {\n   margin: 0;\n   font-family: 'Poppins','-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n   -webkit-font-smoothing: antialiased;\n   -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n   font-family: 'source-code-pro', 'Menlo', 'Monaco', 'Consolas', 'Courier New', monospace;\n}\n","$primary-color: #222;\n$primary-color-dark: #222;\n$light-gray: #d6d6d6;\n$ash: #f7f7f7;\n$light-ash: #efefef;\n$primary-bg: #180065;\n$gold: #c89a32;\n$orange: #f58d45;\n$white: #fff;\n$green: #0a8c5b;\n$green-18: #837F39;\n$black: #000;\n$black-50: #565958;\n$black-33: #333536;\n$black-1c: #1c2c25;\n$grey: #e8e4e4;\n$ash-gray: #c4c4c4;\n$grey-65: #656565;\n$grey-50: #8c8c8c;\n$black-4D: #4d4d4d;\n$full-height: 100vh;\n$violet: #180065;\n$light-violet: #796ba6;\n$light-blue: #edf1fb;\n$light-violet50: #d6def5;\n$light-violet: #796ba6;\n$pink: #da274a;\n$skyblue: #3fc1e8;\n$cyanBlue: #07e1c7;\n$blue: #3783f5;\n$green-2f: #27bf2f;\n$green-href: #0f994e;\n$bg-ash: #f9f9f9;\n$label-ash: #575757;\n$light-ash: #efefef;\n$gray-span: #909090;\n$gray-6c: #6c6c6c;\n$calender-header: #aebfef;\n$tick-bg: #bf27276e;\n$thead-bg: #aebfef80;\n$red-dark: #ff0000;\n$blue-btn: #d4defb;\n$col-555555: #555555;\n$pagination-bg: #aebfef;\n\n$black-5: rgba(0, 0, 0, 0.5);\n$black-2: rgba(0, 0, 0, 0.2);\n$prev-btn: #f2f2f2;\n$c1: #e5e5e5;\n$c2: #180065;\n$c3: #f9f9f9;\n$c4: #556080;\n$c5: #6c6c6c;\n$c6: #dff5fb;\n$c7: #dff9e1;\n$c8: #dfedff;\n$c9: #fee7e5;\n\n$c10: #b9e1ec;\n$c11: #bfedc2;\n$c12: #b8ceeb;\n$c13: #f2d0cd;\n$c14: #0d0d0d;\n$c15: #424242;\n$c16: #d7dff7;\n$c17: $calender-header;\n$c18: $gray-6c;\n$c19: $green-2f;\n$col-CC2B5A: \"#CC2B5A\";\n$light-bg: $light-gray;\n$c20: #ff6f06;\n$c21: #d73e3e;\n/* Color */\n$myColors: (\n  \"c1\": $c1,\n  \"c2\": $c2,\n  \"c3\": $c3,\n  \"c4\": $c4,\n  \"c5\": $c5,\n  \"c6\": $c6,\n  \"c7\": $c7,\n  \"c8\": $c8,\n  \"c9\": $c9,\n  \"c10\": $c10,\n  \"c11\": $c11,\n  \"c12\": $c12,\n  \"c13\": $c13,\n  \"c14\": $c14,\n  \"c15\": $c15,\n  \"c16\": $c16,\n  \"c17\": $c17,\n  \"c18\": $c18,\n  \"c19\": $c19,\n  \"c20\": $c20,\n  \"c21\": $c21\n);\n\n@each $name, $colors in $myColors {\n  $index: index($myColors, $colors);\n  .text-#{$name} {\n    color: $colors;\n  }\n  .bg-#{$name} {\n    background-color: $colors;\n  }\n  .bg-h-#{$name} {\n    background-color: $colors;\n  }\n  .bc-#{$name} {\n    border-color: $colors;\n  }\n}\n","$root-font-size: 16px;\n\n@function fontSize($size) {\n  $remSize: $size / $root-font-size;\n  @return #{$remSize}rem;\n}\n\n/* Font Size */\n$fs: 38;\n@while $fs > 8 {\n  .fs-#{$fs} {\n    font-size: $fs * 1px;\n  }\n  $fs: $fs - 1;\n}\n\n//Line-Height\n$line-height: 38;\n@while $line-height > 8 {\n  .line-height-#{$line-height} {\n    line-height: $line-height * 1px;\n  }\n  $line-height: $line-height - 1;\n}\n\n/* Font-weight */\n$fw: 800;\n@while $fw > 400 {\n  .fw-#{$fw} {\n    font-weight: $fw;\n  }\n  $fw: $fw - 100;\n}\n\n/* Height */\n$height: 700;\n@while $height > 400 {\n  .h-#{$height} {\n    height: $height;\n  }\n  $height: $height - 50;\n}\n","@import \"../abstracts/abstracts\";\n.primary-color {\n  color: $primary-color;\n  &-dark {\n    color: $primary-color-dark;\n  }\n}\n.text-gold {\n  color: $gold;\n}\n.hover-primary-dark {\n  &:hover {\n    color: $primary-color-dark;\n    cursor: pointer;\n  }\n}\n.container-80 {\n  width: 90%;\n}\n.container-60 {\n  width: 60%;\n}\n.container-40 {\n  width: 48%;\n}\n.container-height-80 {\n  height: 400px;\n}\n\n.svg-hover {\n  &:hover {\n    background-color: white;\n  }\n}\n\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: $primary-color;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: $primary-color;\n}\n\n.container-sa {\n  max-width: 1340px;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\nbutton.btn:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0);\n}\n\n.form-control:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0);\n}\n\n.btn {\n  background: #e2f9ec;\n  border: 1px solid #f5f6f7;\n  box-sizing: border-box;\n  border-radius: 4px;\n  color: #000000;\n  font-weight: 500;\n  // min-width: 210px;\n  padding: 0.9rem 0;\n\n  &.active {\n    background: #189c5c;\n    border: 1px solid #f5f6f7;\n    color: #ffffff;\n  }\n}\n\n.tab-sammunaty {\n  &.nav-tabs {\n    border-bottom: 0px solid #dee2e6;\n    .nav-link {\n      margin-left: 0;\n      border: 0px;\n      min-width: 170px;\n      text-align: center;\n      padding: 0.7rem 0rem;\n      color: #189c5c;\n      font-size: 1.1rem;\n      border-top-left-radius: 10px;\n      border-top-right-radius: 10px;\n      border-bottom-right-radius: 0px;\n      border-bottom-left-radius: 0px;\n      cursor: pointer;\n\n      img {\n        height: 28px;\n        margin-right: 10px;\n      }\n      &.active {\n        background: #deecd2;\n        border-color: transparent;\n        color: #189c5c;\n      }\n    }\n  }\n}\n\n.ck.ck-content {\n  border: 1px solid #bababa;\n  border-top: 0;\n}\n","@import 'swiper-vars.scss';\n\n@font-face {\n  font-family: 'swiper-icons';\n  src: url('data:application/font-woff;charset=utf-8;base64, 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')\n    format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n:root {\n  --swiper-theme-color: #{$themeColor};\n}\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-container-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-container-multirow > .swiper-wrapper {\n  flex-wrap: wrap;\n}\n.swiper-container-multirow-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n.swiper-container-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-container-pointer-events {\n  touch-action: pan-y;\n  &.swiper-container-vertical {\n    touch-action: pan-x;\n  }\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-container-autoheight {\n  &,\n  .swiper-slide {\n    height: auto;\n  }\n\n  .swiper-wrapper {\n    align-items: flex-start;\n    transition-property: transform, height;\n  }\n}\n\n/* 3D Effects */\n.swiper-container-3d {\n  perspective: 1200px;\n  .swiper-wrapper,\n  .swiper-slide,\n  .swiper-slide-shadow-left,\n  .swiper-slide-shadow-right,\n  .swiper-slide-shadow-top,\n  .swiper-slide-shadow-bottom,\n  .swiper-cube-shadow {\n    transform-style: preserve-3d;\n  }\n  .swiper-slide-shadow-left,\n  .swiper-slide-shadow-right,\n  .swiper-slide-shadow-top,\n  .swiper-slide-shadow-bottom {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 10;\n  }\n  .swiper-slide-shadow-left {\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-right {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-top {\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-bottom {\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n}\n\n/* CSS Mode */\n.swiper-container-css-mode {\n  > .swiper-wrapper {\n    overflow: auto;\n    scrollbar-width: none; /* For Firefox */\n    -ms-overflow-style: none; /* For Internet Explorer and Edge */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  > .swiper-wrapper > .swiper-slide {\n    scroll-snap-align: start start;\n  }\n}\n.swiper-container-horizontal.swiper-container-css-mode {\n  > .swiper-wrapper {\n    scroll-snap-type: x mandatory;\n  }\n}\n.swiper-container-vertical.swiper-container-css-mode {\n  > .swiper-wrapper {\n    scroll-snap-type: y mandatory;\n  }\n}\n\n\n\n","/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","@import \"../abstracts/abstracts\";\n\n.center-view {\n  height: $full-height;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  overflow: auto;\n  &-login {\n    @extend .center-view;\n    // background: url(\"../../svg/loginback3.svg\"), url(\"../../svg/loginback2.svg\"),\n    //   url(\"../../svg/loginback1.svg\");\n    position: relative;\n    height: calc(100vh);\n    background-size: cover;\n    background-position: bottom;\n    background-repeat: no-repeat;\n  }\n  .card {\n    padding: 30px;\n    min-width: 400px;\n    margin: auto;\n    border-style: none;\n  }\n}\n","@import \"../scss/abstracts/abstracts\";\n\n.heading-20 {\n  font-family: Poppins;\n  font-size: 20px;\n  line-height: 24px;\n  color: #000000;\n}\nbutton {\n  &.btn {\n    border-radius: 4px;\n    font-family: Poppins;\n    line-height: 19px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-transform: uppercase;\n    &.mainbg-btn {\n      background: $green-18;\n      border: 1px solid $green-18;\n      color: $white;\n    }\n    &.btn-dark-primary-border {\n      background-color: $white;\n      color: $primary-bg;\n      font-weight: bold;\n      border: 1px solid $primary-bg !important;\n    }\n    &.btn-dark-primary-border:hover {\n      background: $primary-bg;\n      border: 1px solid $primary-bg;\n      color: $white;\n    }\n    &.btn-dark-primary-outline {\n      background-color: $white;\n      color: $primary-bg;\n      font-weight: bold;\n    }\n    &.mainbg-btn:hover {\n      background: transparent;\n      border: 1px solid $green-18;\n      transition: 0.3s ease-in;\n      color: $green-18;\n    }\n    &.outline-btn {\n      background: transparent;\n      border: 1px solid $green-18;\n      transition: 0.3s ease-in;\n      color: $green-18;\n    }\n    &.outline-btn:hover {\n      background: $green-18;\n      border: 1px solid $green-18;\n      color: $white;\n    }\n    &.outline-btn.border-none {\n      background: transparent;\n      border: 1px solid transparent;\n      transition: 0.3s ease-in;\n      color: $green-18;\n    }\n    &.outline-btn.border-none:hover {\n      background: transparent;\n      border: 1px solid $green-18;\n      color: $green-18;\n    }\n    &.danger-btn {\n      background: transparent;\n      border: 1px solid $orange;\n      transition: 0.3s ease-in;\n      color: $orange;\n    }\n    &.danger-btn:hover {\n      background: $orange;\n      border: 1px solid $orange;\n      color: $white;\n    }\n    &.btn-dark-primary {\n      background-color: $primary-bg;\n      color: $white;\n      padding: 0.7rem 2rem;\n      font-weight: bold;\n    }\n    &.btn-dark-primary:hover {\n      background: $primary-bg;\n      border: 1px solid $black;\n      color: $white;\n    }\n    &.btn-grey {\n      background-color: $ash-gray;\n      color: $black;\n      padding: 0.5rem 2rem;\n      font-weight: bold;\n    }\n    &.btn-grey:hover {\n      background: $ash-gray;\n      border: 1px solid $black;\n      color: $black;\n    }\n    &.btn-blue-primary {\n      background-color: $blue-btn;\n      color: $violet;\n    }\n    &.btn-blue-primary:hover {\n      background: $blue-btn;\n      border: 1px solid $blue-btn;\n      color: $violet;\n    }\n    &.btn-blue-outline {\n      background-color: transparent;\n      color: $violet;\n      border: 1px solid $violet;\n    }\n    &.btn-blue-outline:hover {\n      background: transparent;\n      border: 1px solid $violet;\n      color: $violet;\n    }\n  }\n}\n\n.btn:focus,\n.btn.focus,\ninput:focus {\n  outline: 0;\n  box-shadow: none;\n}\n\n.form-control:focus {\n  border-color: none;\n  outline: 0;\n  box-shadow: none;\n  background: none;\n}\n.form-control-multiselect {\n  div:first-child {\n    // height: 57px;\n    border-radius: 0;\n  }\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.border-bottom-c4 {\n  border-bottom: 1px solid #c4c4c4;\n}\n\n.white-bg {\n  background-color: $white;\n  padding: 24px;\n}\n\n.font-weight-bold {\n  font-weight: bold;\n}\n\n//Hide Arrows in input\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n//Hide Arrows in input\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n//Edit Input\n.cke_inner {\n  .cke_editable {\n    p {\n      font-family: Poppins;\n      font-size: 14px !important;\n      line-height: 17px;\n      color: #787878 !important;\n      opacity: 0.5;\n    }\n  }\n}\n\n.add-course {\n  //stepper flow\n  .stepper-horizontal {\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n  }\n  .stepper-horizontal .step {\n    position: relative;\n    width: 30%;\n    padding: 24px;\n    &:first-child {\n      width: 20%;\n    }\n  }\n  .stepper-horizontal .step:first-child .step-bar-left,\n  .stepper-horizontal .step:last-child .step-bar-right {\n    display: none;\n  }\n  .stepper-horizontal .step .step-circle {\n    width: 31px;\n    height: 31px;\n    margin: 0 auto;\n    background: $white;\n    border-radius: 50%;\n    text-align: center;\n    border: 1px solid #929292;\n  }\n  .stepper-horizontal.green .step.active .step-circle {\n    border: 8px solid #189c5c;\n  }\n  .stepper-horizontal .step .step-title {\n    margin-top: 18px;\n    font-family: Poppins;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #4f4f4f;\n  }\n  .stepper-horizontal .step .step-sub-title {\n    font-family: Poppins;\n    font-size: 13px;\n    line-height: 15px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #505050;\n  }\n  .stepper-horizontal .step.active {\n    .step-bar-left.completed {\n      border-top: 1px solid #189c5c;\n    }\n    .step-sub-title {\n      font-family: Poppins;\n      font-size: 13px;\n      line-height: 15px;\n      text-align: center;\n      text-transform: uppercase;\n      color: #189c5c;\n    }\n  }\n  .stepper-horizontal .step.completed {\n    .step-circle {\n      border: 8px solid #189c5c;\n    }\n    .step-bar-left,\n    .step-bar-right {\n      border-top: 1px solid #189c5c;\n    }\n  }\n\n  .stepper-horizontal .step .step-bar-left,\n  .stepper-horizontal .step .step-bar-right {\n    position: absolute;\n    top: 36px;\n    height: 1px;\n    border-top: 1px solid #c4c4c4;\n  }\n  .stepper-horizontal .step .step-bar-right {\n    right: 0;\n    left: 50%;\n    margin-left: 15px;\n  }\n  .stepper-horizontal .step .step-bar-left {\n    left: 0;\n    right: 50%;\n    margin-right: 15px;\n  }\n}\n\n//Nav- tabs\n\n.common-navlink {\n  .nav-tabs {\n    border-bottom: 1px solid #d7d7d7 !important;\n    width: 100%;\n    .nav-link {\n      border-bottom: 2px solid $primary-color;\n      cursor: pointer;\n      border: 0;\n      padding: 10px;\n    }\n  }\n  .filled-tabs {\n    a {\n      cursor: pointer;\n      &.active.nav-link {\n        color: $primary-color;\n        border-radius: 0px;\n        border-bottom: 4px solid $primary-color;\n      }\n      &.nav-link {\n        background: transparent;\n        font-family: Poppins;\n        border-bottom: 4px solid transparent;\n        width: 185px;\n        height: 100%;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #777777;\n        font-size: fontSize(18px);\n        line-height: 21px;\n      }\n      &.nav-link:hover {\n        color: $primary-color;\n        border-radius: 0px;\n        border-bottom: 4px solid $primary-color;\n      }\n    }\n  }\n}\n\n.input-group {\n  .mailIcon {\n    height: 13px;\n    width: 13px;\n  }\n}\n.border-dashed {\n  border-style: dashed;\n  border-width: thin;\n  border-color: #ddd;\n}\n\n//common-color-classes\n.text-black {\n  color: $black;\n}\n.text-black-50 {\n  color: $black-50;\n}\n.text-black-30 {\n  color: #303030;\n}\n\n.text-grey {\n  color: $grey;\n}\n\n.text-grey-span {\n  color: $gray-span;\n}\n\n.text-black-4D {\n  color: $black-4D;\n}\n\n.text-grey-65 {\n  color: $grey-65;\n}\n\n.text-green-18 {\n  color: $green-18;\n}\n\n.bg-green {\n  background-color: $green-18;\n}\n\n.bg-black50 {\n  background-color: $black-50;\n}\n\n.bg-ash-gray {\n  background-color: $ash-gray;\n}\n\n.bg-ash {\n  background-color: $ash;\n}\n\n.text-black-ash {\n  color: $primary-bg;\n}\n.text-blue-info {\n  color: #3fc1e8;\n}\n\n.bg-violet {\n  background-color: $violet;\n  color: $white;\n}\n\n.form-btn {\n  background-color: $violet;\n  color: $white;\n}\n.text-decoration-underline {\n  text-decoration: underline;\n}\n.bg-violet-lite {\n  color: $white;\n  background-color: $light-violet;\n}\n.bg-violet-border {\n  color: #7466a3;\n  background-color: $white;\n  border: 2px solid #7466a3;\n}\n.bg-blue-lite {\n  background-color: $light-blue;\n}\n\n.text-primarybg {\n  color: $primary-bg;\n}\n.border-primary-bg {\n  border: 1px solid $primary-bg;\n}\n.title-text {\n  color: $violet;\n  font-size: fontSize(24px);\n  font-weight: 600;\n}\n\n.border-radius-5 {\n  border-radius: 5px;\n}\n.bg-light-primary{\n  background-color: #EDF8F7;\n}\n.srv-validation-message{\n  font-size:12px;\n}\ninput[type=checkbox] {\n    accent-color:#2A7A7B;\n}\n.text-green{\n  color: #2A7A7B;\n}\n.css-bfrw9z{\n  z-index:0;\n}\n.month_default_event *{\n  color:white!important;\n}","@import \"../abstracts/abstracts\";\n\n.mob-title {\n  font-family: Poppins;\n  font-style: normal;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 34px;\n}\n\n@media (max-width: 480px) {\n\n  .search-bar,\n  .sidebar-icon-only .sidebar-list-items,\n  .date,\n  .search-bar2 {\n    width: 100% !important;\n  }\n\n  .userdropdown .dropdown-toggle::after {\n    margin-left: 4.255em !important;\n  }\n\n  .coin-icon {\n    padding-left: 0px !important;\n  }\n\n  h3,\n  h4 {\n    font-size: 16px !important;\n  }\n}\n\n@media screen and (min-width:820px) {\n\n  .search-bar,\n  .sidebar-icon-only .sidebar-list-items,\n  .date,\n  .search-bar2 {\n    width: 80% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
